/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Skyflow", [], t) : "object" == typeof exports ? exports.Skyflow = t() : e.Skyflow = t();
}(this, () => (() => {
  var e = {
      841: e => {
        "use strict";

        e.exports = function () {
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
            var t = 16 * Math.random() | 0;
            return ("x" === e ? t : 3 & t | 8).toString(16);
          });
        };
      },
      4148: (e, t, n) => {
        "use strict";

        var r = n(5606),
          o = n(6763);
        function i(e) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, i(e);
        }
        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, (o = r.key, a = void 0, a = function (e, t) {
              if ("object" !== i(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 !== n) {
                var r = n.call(e, t || "default");
                if ("object" !== i(r)) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return ("string" === t ? String : Number)(e);
            }(o, "string"), "symbol" === i(a) ? a : String(a)), r);
          }
          var o, a;
        }
        function c(e, t, n) {
          return t && a(e.prototype, t), n && a(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }
        var l,
          s,
          p = n(9597).codes,
          u = p.ERR_AMBIGUOUS_ARGUMENT,
          d = p.ERR_INVALID_ARG_TYPE,
          f = p.ERR_INVALID_ARG_VALUE,
          E = p.ERR_INVALID_RETURN_VALUE,
          _ = p.ERR_MISSING_ARGS,
          m = n(3918),
          v = n(537).inspect,
          I = n(537).types,
          y = I.isPromise,
          O = I.isRegExp,
          g = n(1514)(),
          N = n(9394)(),
          L = n(8075)("RegExp.prototype.test");
        new Map();
        function T() {
          var e = n(2299);
          l = e.isDeepEqual, s = e.isDeepStrictEqual;
        }
        var h = !1,
          b = e.exports = S,
          A = {};
        function w(e) {
          if (e.message instanceof Error) throw e.message;
          throw new m(e);
        }
        function R(e, t, n, r) {
          if (!n) {
            var o = !1;
            if (0 === t) o = !0, r = "No value argument passed to `assert.ok()`";else if (r instanceof Error) throw r;
            var i = new m({
              actual: n,
              expected: !0,
              message: r,
              operator: "==",
              stackStartFn: e
            });
            throw i.generatedMessage = o, i;
          }
        }
        function S() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          R.apply(void 0, [S, t.length].concat(t));
        }
        b.fail = function e(t, n, i, a, c) {
          var l,
            s = arguments.length;
          if (0 === s) l = "Failed";else if (1 === s) i = t, t = void 0;else {
            if (!1 === h) h = !0, (r.emitWarning ? r.emitWarning : o.warn.bind(o))("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
            2 === s && (a = "!=");
          }
          if (i instanceof Error) throw i;
          var p = {
            actual: t,
            expected: n,
            operator: void 0 === a ? "fail" : a,
            stackStartFn: c || e
          };
          void 0 !== i && (p.message = i);
          var u = new m(p);
          throw l && (u.message = l, u.generatedMessage = !0), u;
        }, b.AssertionError = m, b.ok = S, b.equal = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          t != n && w({
            actual: t,
            expected: n,
            message: r,
            operator: "==",
            stackStartFn: e
          });
        }, b.notEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          t == n && w({
            actual: t,
            expected: n,
            message: r,
            operator: "!=",
            stackStartFn: e
          });
        }, b.deepEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          void 0 === l && T(), l(t, n) || w({
            actual: t,
            expected: n,
            message: r,
            operator: "deepEqual",
            stackStartFn: e
          });
        }, b.notDeepEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          void 0 === l && T(), l(t, n) && w({
            actual: t,
            expected: n,
            message: r,
            operator: "notDeepEqual",
            stackStartFn: e
          });
        }, b.deepStrictEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          void 0 === l && T(), s(t, n) || w({
            actual: t,
            expected: n,
            message: r,
            operator: "deepStrictEqual",
            stackStartFn: e
          });
        }, b.notDeepStrictEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          void 0 === l && T();
          s(t, n) && w({
            actual: t,
            expected: n,
            message: r,
            operator: "notDeepStrictEqual",
            stackStartFn: e
          });
        }, b.strictEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          N(t, n) || w({
            actual: t,
            expected: n,
            message: r,
            operator: "strictEqual",
            stackStartFn: e
          });
        }, b.notStrictEqual = function e(t, n, r) {
          if (arguments.length < 2) throw new _("actual", "expected");
          N(t, n) && w({
            actual: t,
            expected: n,
            message: r,
            operator: "notStrictEqual",
            stackStartFn: e
          });
        };
        var D = c(function e(t, n, r) {
          var o = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), n.forEach(function (e) {
            e in t && (void 0 !== r && "string" == typeof r[e] && O(t[e]) && L(t[e], r[e]) ? o[e] = r[e] : o[e] = t[e]);
          });
        });
        function x(e, t, n, r) {
          if ("function" != typeof t) {
            if (O(t)) return L(t, e);
            if (2 === arguments.length) throw new d("expected", ["Function", "RegExp"], t);
            if ("object" !== i(e) || null === e) {
              var o = new m({
                actual: e,
                expected: t,
                message: n,
                operator: "deepStrictEqual",
                stackStartFn: r
              });
              throw o.operator = r.name, o;
            }
            var a = Object.keys(t);
            if (t instanceof Error) a.push("name", "message");else if (0 === a.length) throw new f("error", t, "may not be an empty object");
            return void 0 === l && T(), a.forEach(function (o) {
              "string" == typeof e[o] && O(t[o]) && L(t[o], e[o]) || function (e, t, n, r, o, i) {
                if (!(n in e) || !s(e[n], t[n])) {
                  if (!r) {
                    var a = new D(e, o),
                      c = new D(t, o, e),
                      l = new m({
                        actual: a,
                        expected: c,
                        operator: "deepStrictEqual",
                        stackStartFn: i
                      });
                    throw l.actual = e, l.expected = t, l.operator = i.name, l;
                  }
                  w({
                    actual: e,
                    expected: t,
                    message: r,
                    operator: i.name,
                    stackStartFn: i
                  });
                }
              }(e, t, o, n, a, r);
            }), !0;
          }
          return void 0 !== t.prototype && e instanceof t || !Error.isPrototypeOf(t) && !0 === t.call({}, e);
        }
        function M(e) {
          if ("function" != typeof e) throw new d("fn", "Function", e);
          try {
            e();
          } catch (e) {
            return e;
          }
          return A;
        }
        function P(e) {
          return y(e) || null !== e && "object" === i(e) && "function" == typeof e.then && "function" == typeof e.catch;
        }
        function C(e) {
          return Promise.resolve().then(function () {
            var t;
            if ("function" == typeof e) {
              if (!P(t = e())) throw new E("instance of Promise", "promiseFn", t);
            } else {
              if (!P(e)) throw new d("promiseFn", ["Function", "Promise"], e);
              t = e;
            }
            return Promise.resolve().then(function () {
              return t;
            }).then(function () {
              return A;
            }).catch(function (e) {
              return e;
            });
          });
        }
        function k(e, t, n, r) {
          if ("string" == typeof n) {
            if (4 === arguments.length) throw new d("error", ["Object", "Error", "Function", "RegExp"], n);
            if ("object" === i(t) && null !== t) {
              if (t.message === n) throw new u("error/message", 'The error message "'.concat(t.message, '" is identical to the message.'));
            } else if (t === n) throw new u("error/message", 'The error "'.concat(t, '" is identical to the message.'));
            r = n, n = void 0;
          } else if (null != n && "object" !== i(n) && "function" != typeof n) throw new d("error", ["Object", "Error", "Function", "RegExp"], n);
          if (t === A) {
            var o = "";
            n && n.name && (o += " (".concat(n.name, ")")), o += r ? ": ".concat(r) : ".";
            var a = "rejects" === e.name ? "rejection" : "exception";
            w({
              actual: void 0,
              expected: n,
              operator: e.name,
              message: "Missing expected ".concat(a).concat(o),
              stackStartFn: e
            });
          }
          if (n && !x(t, n, r, e)) throw t;
        }
        function V(e, t, n, r) {
          if (t !== A) {
            if ("string" == typeof n && (r = n, n = void 0), !n || x(t, n)) {
              var o = r ? ": ".concat(r) : ".",
                i = "doesNotReject" === e.name ? "rejection" : "exception";
              w({
                actual: t,
                expected: n,
                operator: e.name,
                message: "Got unwanted ".concat(i).concat(o, "\n") + 'Actual message: "'.concat(t && t.message, '"'),
                stackStartFn: e
              });
            }
            throw t;
          }
        }
        function j(e, t, n, r, o) {
          if (!O(t)) throw new d("regexp", "RegExp", t);
          var a = "match" === o;
          if ("string" != typeof e || L(t, e) !== a) {
            if (n instanceof Error) throw n;
            var c = !n;
            n = n || ("string" != typeof e ? 'The "string" argument must be of type string. Received type ' + "".concat(i(e), " (").concat(v(e), ")") : (a ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(v(t), ". Input:\n\n").concat(v(e), "\n"));
            var l = new m({
              actual: e,
              expected: t,
              message: n,
              operator: o,
              stackStartFn: r
            });
            throw l.generatedMessage = c, l;
          }
        }
        function U() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          R.apply(void 0, [U, t.length].concat(t));
        }
        b.throws = function e(t) {
          for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
          k.apply(void 0, [e, M(t)].concat(r));
        }, b.rejects = function e(t) {
          for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
          return C(t).then(function (t) {
            return k.apply(void 0, [e, t].concat(r));
          });
        }, b.doesNotThrow = function e(t) {
          for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
          V.apply(void 0, [e, M(t)].concat(r));
        }, b.doesNotReject = function e(t) {
          for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
          return C(t).then(function (t) {
            return V.apply(void 0, [e, t].concat(r));
          });
        }, b.ifError = function e(t) {
          if (null != t) {
            var n = "ifError got unwanted exception: ";
            "object" === i(t) && "string" == typeof t.message ? 0 === t.message.length && t.constructor ? n += t.constructor.name : n += t.message : n += v(t);
            var r = new m({
                actual: t,
                expected: null,
                operator: "ifError",
                message: n,
                stackStartFn: e
              }),
              o = t.stack;
            if ("string" == typeof o) {
              var a = o.split("\n");
              a.shift();
              for (var c = r.stack.split("\n"), l = 0; l < a.length; l++) {
                var s = c.indexOf(a[l]);
                if (-1 !== s) {
                  c = c.slice(0, s);
                  break;
                }
              }
              r.stack = "".concat(c.join("\n"), "\n").concat(a.join("\n"));
            }
            throw r;
          }
        }, b.match = function e(t, n, r) {
          j(t, n, r, e, "match");
        }, b.doesNotMatch = function e(t, n, r) {
          j(t, n, r, e, "doesNotMatch");
        }, b.strict = g(U, b, {
          equal: b.strictEqual,
          deepEqual: b.deepStrictEqual,
          notEqual: b.notStrictEqual,
          notDeepEqual: b.notDeepStrictEqual
        }), b.strict.strict = b.strict;
      },
      3918: (e, t, n) => {
        "use strict";

        var r = n(5606);
        function o(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function i(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(n), !0).forEach(function (t) {
              a(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function a(e, t, n) {
          return (t = l(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function c(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, l(r.key), r);
          }
        }
        function l(e) {
          var t = function (e, t) {
            if ("object" !== m(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" !== m(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" === m(t) ? t : String(t);
        }
        function s(e, t) {
          if (t && ("object" === m(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return p(e);
        }
        function p(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function u(e) {
          var t = "function" == typeof Map ? new Map() : void 0;
          return u = function (e) {
            if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
            var n;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
              if (t.has(e)) return t.get(e);
              t.set(e, r);
            }
            function r() {
              return d(e, arguments, _(this).constructor);
            }
            return r.prototype = Object.create(e.prototype, {
              constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), E(r, e);
          }, u(e);
        }
        function d(e, t, n) {
          return d = f() ? Reflect.construct.bind() : function (e, t, n) {
            var r = [null];
            r.push.apply(r, t);
            var o = new (Function.bind.apply(e, r))();
            return n && E(o, n.prototype), o;
          }, d.apply(null, arguments);
        }
        function f() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }
        function E(e, t) {
          return E = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, E(e, t);
        }
        function _(e) {
          return _ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, _(e);
        }
        function m(e) {
          return m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, m(e);
        }
        var v = n(537).inspect,
          I = n(9597).codes.ERR_INVALID_ARG_TYPE;
        function y(e, t, n) {
          return (void 0 === n || n > e.length) && (n = e.length), e.substring(n - t.length, n) === t;
        }
        var O = "",
          g = "",
          N = "",
          L = "",
          T = {
            deepStrictEqual: "Expected values to be strictly deep-equal:",
            strictEqual: "Expected values to be strictly equal:",
            strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
            deepEqual: "Expected values to be loosely deep-equal:",
            equal: "Expected values to be loosely equal:",
            notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
            notStrictEqual: 'Expected "actual" to be strictly unequal to:',
            notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
            notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
            notEqual: 'Expected "actual" to be loosely unequal to:',
            notIdentical: "Values identical but not reference-equal:"
          };
        function h(e) {
          var t = Object.keys(e),
            n = Object.create(Object.getPrototypeOf(e));
          return t.forEach(function (t) {
            n[t] = e[t];
          }), Object.defineProperty(n, "message", {
            value: e.message
          }), n;
        }
        function b(e) {
          return v(e, {
            compact: !1,
            customInspect: !1,
            depth: 1e3,
            maxArrayLength: 1 / 0,
            showHidden: !1,
            breakLength: 1 / 0,
            showProxy: !1,
            sorted: !0,
            getters: !0
          });
        }
        function A(e, t, n) {
          var o = "",
            i = "",
            a = 0,
            c = "",
            l = !1,
            s = b(e),
            p = s.split("\n"),
            u = b(t).split("\n"),
            d = 0,
            f = "";
          if ("strictEqual" === n && "object" === m(e) && "object" === m(t) && null !== e && null !== t && (n = "strictEqualObject"), 1 === p.length && 1 === u.length && p[0] !== u[0]) {
            var E = p[0].length + u[0].length;
            if (E <= 10) {
              if (!("object" === m(e) && null !== e || "object" === m(t) && null !== t || 0 === e && 0 === t)) return "".concat(T[n], "\n\n") + "".concat(p[0], " !== ").concat(u[0], "\n");
            } else if ("strictEqualObject" !== n) {
              if (E < (r.stderr && r.stderr.isTTY ? r.stderr.columns : 80)) {
                for (; p[0][d] === u[0][d];) d++;
                d > 2 && (f = "\n  ".concat(function (e, t) {
                  if (t = Math.floor(t), 0 == e.length || 0 == t) return "";
                  var n = e.length * t;
                  for (t = Math.floor(Math.log(t) / Math.log(2)); t;) e += e, t--;
                  return e + e.substring(0, n - e.length);
                }(" ", d), "^"), d = 0);
              }
            }
          }
          for (var _ = p[p.length - 1], v = u[u.length - 1]; _ === v && (d++ < 2 ? c = "\n  ".concat(_).concat(c) : o = _, p.pop(), u.pop(), 0 !== p.length && 0 !== u.length);) _ = p[p.length - 1], v = u[u.length - 1];
          var I = Math.max(p.length, u.length);
          if (0 === I) {
            var h = s.split("\n");
            if (h.length > 30) for (h[26] = "".concat(O, "...").concat(L); h.length > 27;) h.pop();
            return "".concat(T.notIdentical, "\n\n").concat(h.join("\n"), "\n");
          }
          d > 3 && (c = "\n".concat(O, "...").concat(L).concat(c), l = !0), "" !== o && (c = "\n  ".concat(o).concat(c), o = "");
          var A = 0,
            w = T[n] + "\n".concat(g, "+ actual").concat(L, " ").concat(N, "- expected").concat(L),
            R = " ".concat(O, "...").concat(L, " Lines skipped");
          for (d = 0; d < I; d++) {
            var S = d - a;
            if (p.length < d + 1) S > 1 && d > 2 && (S > 4 ? (i += "\n".concat(O, "...").concat(L), l = !0) : S > 3 && (i += "\n  ".concat(u[d - 2]), A++), i += "\n  ".concat(u[d - 1]), A++), a = d, o += "\n".concat(N, "-").concat(L, " ").concat(u[d]), A++;else if (u.length < d + 1) S > 1 && d > 2 && (S > 4 ? (i += "\n".concat(O, "...").concat(L), l = !0) : S > 3 && (i += "\n  ".concat(p[d - 2]), A++), i += "\n  ".concat(p[d - 1]), A++), a = d, i += "\n".concat(g, "+").concat(L, " ").concat(p[d]), A++;else {
              var D = u[d],
                x = p[d],
                M = x !== D && (!y(x, ",") || x.slice(0, -1) !== D);
              M && y(D, ",") && D.slice(0, -1) === x && (M = !1, x += ","), M ? (S > 1 && d > 2 && (S > 4 ? (i += "\n".concat(O, "...").concat(L), l = !0) : S > 3 && (i += "\n  ".concat(p[d - 2]), A++), i += "\n  ".concat(p[d - 1]), A++), a = d, i += "\n".concat(g, "+").concat(L, " ").concat(x), o += "\n".concat(N, "-").concat(L, " ").concat(D), A += 2) : (i += o, o = "", 1 !== S && 0 !== d || (i += "\n  ".concat(x), A++));
            }
            if (A > 20 && d < I - 2) return "".concat(w).concat(R, "\n").concat(i, "\n").concat(O, "...").concat(L).concat(o, "\n") + "".concat(O, "...").concat(L);
          }
          return "".concat(w).concat(l ? R : "", "\n").concat(i).concat(o).concat(c).concat(f);
        }
        var w = function (e, t) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && E(e, t);
          }(y, e);
          var n,
            o,
            a,
            l,
            u,
            d = (n = y, o = f(), function () {
              var e,
                t = _(n);
              if (o) {
                var r = _(this).constructor;
                e = Reflect.construct(t, arguments, r);
              } else e = t.apply(this, arguments);
              return s(this, e);
            });
          function y(e) {
            var t;
            if (function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, y), "object" !== m(e) || null === e) throw new I("options", "Object", e);
            var n = e.message,
              o = e.operator,
              i = e.stackStartFn,
              a = e.actual,
              c = e.expected,
              l = Error.stackTraceLimit;
            if (Error.stackTraceLimit = 0, null != n) t = d.call(this, String(n));else if (r.stderr && r.stderr.isTTY && (r.stderr && r.stderr.getColorDepth && 1 !== r.stderr.getColorDepth() ? (O = "[34m", g = "[32m", L = "[39m", N = "[31m") : (O = "", g = "", L = "", N = "")), "object" === m(a) && null !== a && "object" === m(c) && null !== c && "stack" in a && a instanceof Error && "stack" in c && c instanceof Error && (a = h(a), c = h(c)), "deepStrictEqual" === o || "strictEqual" === o) t = d.call(this, A(a, c, o));else if ("notDeepStrictEqual" === o || "notStrictEqual" === o) {
              var u = T[o],
                f = b(a).split("\n");
              if ("notStrictEqual" === o && "object" === m(a) && null !== a && (u = T.notStrictEqualObject), f.length > 30) for (f[26] = "".concat(O, "...").concat(L); f.length > 27;) f.pop();
              t = 1 === f.length ? d.call(this, "".concat(u, " ").concat(f[0])) : d.call(this, "".concat(u, "\n\n").concat(f.join("\n"), "\n"));
            } else {
              var E = b(a),
                _ = "",
                v = T[o];
              "notDeepEqual" === o || "notEqual" === o ? (E = "".concat(T[o], "\n\n").concat(E)).length > 1024 && (E = "".concat(E.slice(0, 1021), "...")) : (_ = "".concat(b(c)), E.length > 512 && (E = "".concat(E.slice(0, 509), "...")), _.length > 512 && (_ = "".concat(_.slice(0, 509), "...")), "deepEqual" === o || "equal" === o ? E = "".concat(v, "\n\n").concat(E, "\n\nshould equal\n\n") : _ = " ".concat(o, " ").concat(_)), t = d.call(this, "".concat(E).concat(_));
            }
            return Error.stackTraceLimit = l, t.generatedMessage = !n, Object.defineProperty(p(t), "name", {
              value: "AssertionError [ERR_ASSERTION]",
              enumerable: !1,
              writable: !0,
              configurable: !0
            }), t.code = "ERR_ASSERTION", t.actual = a, t.expected = c, t.operator = o, Error.captureStackTrace && Error.captureStackTrace(p(t), i), t.stack, t.name = "AssertionError", s(t);
          }
          return a = y, (l = [{
            key: "toString",
            value: function () {
              return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
          }, {
            key: t,
            value: function (e, t) {
              return v(this, i(i({}, t), {}, {
                customInspect: !1,
                depth: 0
              }));
            }
          }]) && c(a.prototype, l), u && c(a, u), Object.defineProperty(a, "prototype", {
            writable: !1
          }), y;
        }(u(Error), v.custom);
        e.exports = w;
      },
      9597: (e, t, n) => {
        "use strict";

        function r(e) {
          return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, r(e);
        }
        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (i = o.key, a = void 0, a = function (e, t) {
              if ("object" !== r(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" !== r(o)) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return ("string" === t ? String : Number)(e);
            }(i, "string"), "symbol" === r(a) ? a : String(a)), o);
          }
          var i, a;
        }
        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }
        function a(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              o = c(e);
            if (t) {
              var i = c(this).constructor;
              n = Reflect.construct(o, arguments, i);
            } else n = o.apply(this, arguments);
            return function (e, t) {
              if (t && ("object" === r(t) || "function" == typeof t)) return t;
              if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
              return function (e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }(e);
            }(this, n);
          };
        }
        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }
        var l,
          s,
          p = {};
        function u(e, t, n) {
          n || (n = Error);
          var r = function (n) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), Object.defineProperty(e, "prototype", {
                writable: !1
              }), t && i(e, t);
            }(p, n);
            var r,
              c,
              l,
              s = a(p);
            function p(n, r, o) {
              var i;
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, p), i = s.call(this, function (e, n, r) {
                return "string" == typeof t ? t : t(e, n, r);
              }(n, r, o)), i.code = e, i;
            }
            return r = p, c && o(r.prototype, c), l && o(r, l), Object.defineProperty(r, "prototype", {
              writable: !1
            }), r;
          }(n);
          p[e] = r;
        }
        function d(e, t) {
          if (Array.isArray(e)) {
            var n = e.length;
            return e = e.map(function (e) {
              return String(e);
            }), n > 2 ? "one of ".concat(t, " ").concat(e.slice(0, n - 1).join(", "), ", or ") + e[n - 1] : 2 === n ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
          }
          return "of ".concat(t, " ").concat(String(e));
        }
        u("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), u("ERR_INVALID_ARG_TYPE", function (e, t, o) {
          var i, a, c, s;
          if (void 0 === l && (l = n(4148)), l("string" == typeof e, "'name' must be a string"), "string" == typeof t && (a = "not ", t.substr(!c || c < 0 ? 0 : +c, a.length) === a) ? (i = "must not be", t = t.replace(/^not /, "")) : i = "must be", function (e, t, n) {
            return (void 0 === n || n > e.length) && (n = e.length), e.substring(n - t.length, n) === t;
          }(e, " argument")) s = "The ".concat(e, " ").concat(i, " ").concat(d(t, "type"));else {
            var p = function (e, t, n) {
              return "number" != typeof n && (n = 0), !(n + t.length > e.length) && -1 !== e.indexOf(t, n);
            }(e, ".") ? "property" : "argument";
            s = 'The "'.concat(e, '" ').concat(p, " ").concat(i, " ").concat(d(t, "type"));
          }
          return s += ". Received type ".concat(r(o));
        }, TypeError), u("ERR_INVALID_ARG_VALUE", function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "is invalid";
          void 0 === s && (s = n(537));
          var o = s.inspect(t);
          return o.length > 128 && (o = "".concat(o.slice(0, 128), "...")), "The argument '".concat(e, "' ").concat(r, ". Received ").concat(o);
        }, TypeError, RangeError), u("ERR_INVALID_RETURN_VALUE", function (e, t, n) {
          var o;
          return o = n && n.constructor && n.constructor.name ? "instance of ".concat(n.constructor.name) : "type ".concat(r(n)), "Expected ".concat(e, ' to be returned from the "').concat(t, '"') + " function but got ".concat(o, ".");
        }, TypeError), u("ERR_MISSING_ARGS", function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          void 0 === l && (l = n(4148)), l(t.length > 0, "At least one arg needs to be specified");
          var o = "The ",
            i = t.length;
          switch (t = t.map(function (e) {
            return '"'.concat(e, '"');
          }), i) {
            case 1:
              o += "".concat(t[0], " argument");
              break;
            case 2:
              o += "".concat(t[0], " and ").concat(t[1], " arguments");
              break;
            default:
              o += t.slice(0, i - 1).join(", "), o += ", and ".concat(t[i - 1], " arguments");
          }
          return "".concat(o, " must be specified");
        }, TypeError), e.exports.codes = p;
      },
      2299: (e, t, n) => {
        "use strict";

        function r(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
              var r,
                o,
                i,
                a,
                c = [],
                l = !0,
                s = !1;
              try {
                if (i = (n = n.call(e)).next, 0 === t) {
                  if (Object(n) !== n) return;
                  l = !1;
                } else for (; !(l = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); l = !0);
              } catch (e) {
                s = !0, o = e;
              } finally {
                try {
                  if (!l && null != n.return && (a = n.return(), Object(a) !== a)) return;
                } finally {
                  if (s) throw o;
                }
              }
              return c;
            }
          }(e, t) || function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return o(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
          }(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function o(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function i(e) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, i(e);
        }
        var a = void 0 !== /a/g.flags,
          c = function (e) {
            var t = [];
            return e.forEach(function (e) {
              return t.push(e);
            }), t;
          },
          l = function (e) {
            var t = [];
            return e.forEach(function (e, n) {
              return t.push([n, e]);
            }), t;
          },
          s = Object.is ? Object.is : n(7653),
          p = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function () {
            return [];
          },
          u = Number.isNaN ? Number.isNaN : n(4133);
        function d(e) {
          return e.call.bind(e);
        }
        var f = d(Object.prototype.hasOwnProperty),
          E = d(Object.prototype.propertyIsEnumerable),
          _ = d(Object.prototype.toString),
          m = n(537).types,
          v = m.isAnyArrayBuffer,
          I = m.isArrayBufferView,
          y = m.isDate,
          O = m.isMap,
          g = m.isRegExp,
          N = m.isSet,
          L = m.isNativeError,
          T = m.isBoxedPrimitive,
          h = m.isNumberObject,
          b = m.isStringObject,
          A = m.isBooleanObject,
          w = m.isBigIntObject,
          R = m.isSymbolObject,
          S = m.isFloat32Array,
          D = m.isFloat64Array;
        function x(e) {
          if (0 === e.length || e.length > 10) return !0;
          for (var t = 0; t < e.length; t++) {
            var n = e.charCodeAt(t);
            if (n < 48 || n > 57) return !0;
          }
          return 10 === e.length && e >= Math.pow(2, 32);
        }
        function M(e) {
          return Object.keys(e).filter(x).concat(p(e).filter(Object.prototype.propertyIsEnumerable.bind(e)));
        }
        function P(e, t) {
          if (e === t) return 0;
          for (var n = e.length, r = t.length, o = 0, i = Math.min(n, r); o < i; ++o) if (e[o] !== t[o]) {
            n = e[o], r = t[o];
            break;
          }
          return n < r ? -1 : r < n ? 1 : 0;
        }
        function C(e, t, n, r) {
          if (e === t) return 0 !== e || !n || s(e, t);
          if (n) {
            if ("object" !== i(e)) return "number" == typeof e && u(e) && u(t);
            if ("object" !== i(t) || null === e || null === t) return !1;
            if (Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
          } else {
            if (null === e || "object" !== i(e)) return (null === t || "object" !== i(t)) && e == t;
            if (null === t || "object" !== i(t)) return !1;
          }
          var o,
            c,
            l,
            p,
            d = _(e);
          if (d !== _(t)) return !1;
          if (Array.isArray(e)) {
            if (e.length !== t.length) return !1;
            var f = M(e),
              E = M(t);
            return f.length === E.length && V(e, t, n, r, 1, f);
          }
          if ("[object Object]" === d && (!O(e) && O(t) || !N(e) && N(t))) return !1;
          if (y(e)) {
            if (!y(t) || Date.prototype.getTime.call(e) !== Date.prototype.getTime.call(t)) return !1;
          } else if (g(e)) {
            if (!g(t) || (l = e, p = t, !(a ? l.source === p.source && l.flags === p.flags : RegExp.prototype.toString.call(l) === RegExp.prototype.toString.call(p)))) return !1;
          } else if (L(e) || e instanceof Error) {
            if (e.message !== t.message || e.name !== t.name) return !1;
          } else {
            if (I(e)) {
              if (n || !S(e) && !D(e)) {
                if (!function (e, t) {
                  return e.byteLength === t.byteLength && 0 === P(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
                }(e, t)) return !1;
              } else if (!function (e, t) {
                if (e.byteLength !== t.byteLength) return !1;
                for (var n = 0; n < e.byteLength; n++) if (e[n] !== t[n]) return !1;
                return !0;
              }(e, t)) return !1;
              var m = M(e),
                x = M(t);
              return m.length === x.length && V(e, t, n, r, 0, m);
            }
            if (N(e)) return !(!N(t) || e.size !== t.size) && V(e, t, n, r, 2);
            if (O(e)) return !(!O(t) || e.size !== t.size) && V(e, t, n, r, 3);
            if (v(e)) {
              if (c = t, (o = e).byteLength !== c.byteLength || 0 !== P(new Uint8Array(o), new Uint8Array(c))) return !1;
            } else if (T(e) && !function (e, t) {
              return h(e) ? h(t) && s(Number.prototype.valueOf.call(e), Number.prototype.valueOf.call(t)) : b(e) ? b(t) && String.prototype.valueOf.call(e) === String.prototype.valueOf.call(t) : A(e) ? A(t) && Boolean.prototype.valueOf.call(e) === Boolean.prototype.valueOf.call(t) : w(e) ? w(t) && BigInt.prototype.valueOf.call(e) === BigInt.prototype.valueOf.call(t) : R(t) && Symbol.prototype.valueOf.call(e) === Symbol.prototype.valueOf.call(t);
            }(e, t)) return !1;
          }
          return V(e, t, n, r, 0);
        }
        function k(e, t) {
          return t.filter(function (t) {
            return E(e, t);
          });
        }
        function V(e, t, n, o, a, s) {
          if (5 === arguments.length) {
            s = Object.keys(e);
            var u = Object.keys(t);
            if (s.length !== u.length) return !1;
          }
          for (var d = 0; d < s.length; d++) if (!f(t, s[d])) return !1;
          if (n && 5 === arguments.length) {
            var _ = p(e);
            if (0 !== _.length) {
              var m = 0;
              for (d = 0; d < _.length; d++) {
                var v = _[d];
                if (E(e, v)) {
                  if (!E(t, v)) return !1;
                  s.push(v), m++;
                } else if (E(t, v)) return !1;
              }
              var I = p(t);
              if (_.length !== I.length && k(t, I).length !== m) return !1;
            } else {
              var y = p(t);
              if (0 !== y.length && 0 !== k(t, y).length) return !1;
            }
          }
          if (0 === s.length && (0 === a || 1 === a && 0 === e.length || 0 === e.size)) return !0;
          if (void 0 === o) o = {
            val1: new Map(),
            val2: new Map(),
            position: 0
          };else {
            var O = o.val1.get(e);
            if (void 0 !== O) {
              var g = o.val2.get(t);
              if (void 0 !== g) return O === g;
            }
            o.position++;
          }
          o.val1.set(e, o.position), o.val2.set(t, o.position);
          var N = function (e, t, n, o, a, s) {
            var p = 0;
            if (2 === s) {
              if (!function (e, t, n, r) {
                for (var o = null, a = c(e), l = 0; l < a.length; l++) {
                  var s = a[l];
                  if ("object" === i(s) && null !== s) null === o && (o = new Set()), o.add(s);else if (!t.has(s)) {
                    if (n) return !1;
                    if (!F(e, t, s)) return !1;
                    null === o && (o = new Set()), o.add(s);
                  }
                }
                if (null !== o) {
                  for (var p = c(t), u = 0; u < p.length; u++) {
                    var d = p[u];
                    if ("object" === i(d) && null !== d) {
                      if (!j(o, d, n, r)) return !1;
                    } else if (!n && !e.has(d) && !j(o, d, n, r)) return !1;
                  }
                  return 0 === o.size;
                }
                return !0;
              }(e, t, n, a)) return !1;
            } else if (3 === s) {
              if (!function (e, t, n, o) {
                for (var a = null, c = l(e), s = 0; s < c.length; s++) {
                  var p = r(c[s], 2),
                    u = p[0],
                    d = p[1];
                  if ("object" === i(u) && null !== u) null === a && (a = new Set()), a.add(u);else {
                    var f = t.get(u);
                    if (void 0 === f && !t.has(u) || !C(d, f, n, o)) {
                      if (n) return !1;
                      if (!Y(e, t, u, d, o)) return !1;
                      null === a && (a = new Set()), a.add(u);
                    }
                  }
                }
                if (null !== a) {
                  for (var E = l(t), _ = 0; _ < E.length; _++) {
                    var m = r(E[_], 2),
                      v = m[0],
                      I = m[1];
                    if ("object" === i(v) && null !== v) {
                      if (!G(a, e, v, I, n, o)) return !1;
                    } else if (!(n || e.has(v) && C(e.get(v), I, !1, o) || G(a, e, v, I, !1, o))) return !1;
                  }
                  return 0 === a.size;
                }
                return !0;
              }(e, t, n, a)) return !1;
            } else if (1 === s) for (; p < e.length; p++) {
              if (!f(e, p)) {
                if (f(t, p)) return !1;
                for (var u = Object.keys(e); p < u.length; p++) {
                  var d = u[p];
                  if (!f(t, d) || !C(e[d], t[d], n, a)) return !1;
                }
                return u.length === Object.keys(t).length;
              }
              if (!f(t, p) || !C(e[p], t[p], n, a)) return !1;
            }
            for (p = 0; p < o.length; p++) {
              var E = o[p];
              if (!C(e[E], t[E], n, a)) return !1;
            }
            return !0;
          }(e, t, n, s, o, a);
          return o.val1.delete(e), o.val2.delete(t), N;
        }
        function j(e, t, n, r) {
          for (var o = c(e), i = 0; i < o.length; i++) {
            var a = o[i];
            if (C(t, a, n, r)) return e.delete(a), !0;
          }
          return !1;
        }
        function U(e) {
          switch (i(e)) {
            case "undefined":
              return null;
            case "object":
              return;
            case "symbol":
              return !1;
            case "string":
              e = +e;
            case "number":
              if (u(e)) return !1;
          }
          return !0;
        }
        function F(e, t, n) {
          var r = U(n);
          return null != r ? r : t.has(r) && !e.has(r);
        }
        function Y(e, t, n, r, o) {
          var i = U(n);
          if (null != i) return i;
          var a = t.get(i);
          return !(void 0 === a && !t.has(i) || !C(r, a, !1, o)) && !e.has(i) && C(r, a, !1, o);
        }
        function G(e, t, n, r, o, i) {
          for (var a = c(e), l = 0; l < a.length; l++) {
            var s = a[l];
            if (C(n, s, o, i) && C(r, t.get(s), o, i)) return e.delete(s), !0;
          }
          return !1;
        }
        e.exports = {
          isDeepEqual: function (e, t) {
            return C(e, t, false);
          },
          isDeepStrictEqual: function (e, t) {
            return C(e, t, true);
          }
        };
      },
      8075: (e, t, n) => {
        "use strict";

        var r = n(453),
          o = n(487),
          i = o(r("String.prototype.indexOf"));
        e.exports = function (e, t) {
          var n = r(e, !!t);
          return "function" == typeof n && i(e, ".prototype.") > -1 ? o(n) : n;
        };
      },
      487: (e, t, n) => {
        "use strict";

        var r = n(6743),
          o = n(453),
          i = o("%Function.prototype.apply%"),
          a = o("%Function.prototype.call%"),
          c = o("%Reflect.apply%", !0) || r.call(a, i),
          l = o("%Object.getOwnPropertyDescriptor%", !0),
          s = o("%Object.defineProperty%", !0),
          p = o("%Math.max%");
        if (s) try {
          s({}, "a", {
            value: 1
          });
        } catch (e) {
          s = null;
        }
        e.exports = function (e) {
          var t = c(r, a, arguments);
          l && s && l(t, "length").configurable && s(t, "length", {
            value: 1 + p(0, e.length - (arguments.length - 1))
          });
          return t;
        };
        var u = function () {
          return c(r, i, arguments);
        };
        s ? s(e.exports, "apply", {
          value: u
        }) : e.exports.apply = u;
      },
      6763: (e, t, n) => {
        var r = n(537),
          o = n(4148);
        function i() {
          return new Date().getTime();
        }
        var a,
          c = Array.prototype.slice,
          l = {};
        a = void 0 !== n.g && n.g.console ? n.g.console : "undefined" != typeof window && window.console ? window.console : {};
        for (var s = [[function () {}, "log"], [function () {
            a.log.apply(a, arguments);
          }, "info"], [function () {
            a.log.apply(a, arguments);
          }, "warn"], [function () {
            a.warn.apply(a, arguments);
          }, "error"], [function (e) {
            l[e] = i();
          }, "time"], [function (e) {
            var t = l[e];
            if (!t) throw new Error("No such label: " + e);
            delete l[e];
            var n = i() - t;
            a.log(e + ": " + n + "ms");
          }, "timeEnd"], [function () {
            var e = new Error();
            e.name = "Trace", e.message = r.format.apply(null, arguments), a.error(e.stack);
          }, "trace"], [function (e) {
            a.log(r.inspect(e) + "\n");
          }, "dir"], [function (e) {
            if (!e) {
              var t = c.call(arguments, 1);
              o.ok(!1, r.format.apply(null, t));
            }
          }, "assert"]], p = 0; p < s.length; p++) {
          var u = s[p],
            d = u[0],
            f = u[1];
          a[f] || (a[f] = d);
        }
        e.exports = a;
      },
      41: (e, t, n) => {
        "use strict";

        var r = n(592)(),
          o = n(453),
          i = r && o("%Object.defineProperty%", !0),
          a = o("%SyntaxError%"),
          c = o("%TypeError%"),
          l = n(5795);
        e.exports = function (e, t, n) {
          if (!e || "object" != typeof e && "function" != typeof e) throw new c("`obj` must be an object or a function`");
          if ("string" != typeof t && "symbol" != typeof t) throw new c("`property` must be a string or a symbol`");
          if (arguments.length > 3 && "boolean" != typeof arguments[3] && null !== arguments[3]) throw new c("`nonEnumerable`, if provided, must be a boolean or null");
          if (arguments.length > 4 && "boolean" != typeof arguments[4] && null !== arguments[4]) throw new c("`nonWritable`, if provided, must be a boolean or null");
          if (arguments.length > 5 && "boolean" != typeof arguments[5] && null !== arguments[5]) throw new c("`nonConfigurable`, if provided, must be a boolean or null");
          if (arguments.length > 6 && "boolean" != typeof arguments[6]) throw new c("`loose`, if provided, must be a boolean");
          var r = arguments.length > 3 ? arguments[3] : null,
            o = arguments.length > 4 ? arguments[4] : null,
            s = arguments.length > 5 ? arguments[5] : null,
            p = arguments.length > 6 && arguments[6],
            u = !!l && l(e, t);
          if (i) i(e, t, {
            configurable: null === s && u ? u.configurable : !s,
            enumerable: null === r && u ? u.enumerable : !r,
            value: n,
            writable: null === o && u ? u.writable : !o
          });else {
            if (!p && (r || o || s)) throw new a("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
            e[t] = n;
          }
        };
      },
      8452: (e, t, n) => {
        "use strict";

        var r = n(1189),
          o = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
          i = Object.prototype.toString,
          a = Array.prototype.concat,
          c = n(41),
          l = n(592)(),
          s = function (e, t, n, r) {
            if (t in e) if (!0 === r) {
              if (e[t] === n) return;
            } else if ("function" != typeof (o = r) || "[object Function]" !== i.call(o) || !r()) return;
            var o;
            l ? c(e, t, n, !0) : c(e, t, n);
          },
          p = function (e, t) {
            var n = arguments.length > 2 ? arguments[2] : {},
              i = r(t);
            o && (i = a.call(i, Object.getOwnPropertySymbols(t)));
            for (var c = 0; c < i.length; c += 1) s(e, i[c], t[i[c]], n[i[c]]);
          };
        p.supportsDescriptors = !!l, e.exports = p;
      },
      2682: (e, t, n) => {
        "use strict";

        var r = n(9600),
          o = Object.prototype.toString,
          i = Object.prototype.hasOwnProperty;
        e.exports = function (e, t, n) {
          if (!r(t)) throw new TypeError("iterator must be a function");
          var a;
          arguments.length >= 3 && (a = n), "[object Array]" === o.call(e) ? function (e, t, n) {
            for (var r = 0, o = e.length; r < o; r++) i.call(e, r) && (null == n ? t(e[r], r, e) : t.call(n, e[r], r, e));
          }(e, t, a) : "string" == typeof e ? function (e, t, n) {
            for (var r = 0, o = e.length; r < o; r++) null == n ? t(e.charAt(r), r, e) : t.call(n, e.charAt(r), r, e);
          }(e, t, a) : function (e, t, n) {
            for (var r in e) i.call(e, r) && (null == n ? t(e[r], r, e) : t.call(n, e[r], r, e));
          }(e, t, a);
        };
      },
      6096: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Framebus = void 0;
        var r = n(9275),
          o = n(2926),
          i = n(9974),
          a = n(3678),
          c = n(6968),
          l = function () {
            function e(e) {
              void 0 === e && (e = "*"), this.origin = e;
            }
            return e.target = function (t) {
              return void 0 === t && (t = "*"), new e(t);
            }, e.prototype.include = function (e) {
              return null != e && null != e.Window && e.constructor === e.Window && (c.childWindows.push(e), !0);
            }, e.prototype.target = function (t) {
              return e.target(t);
            }, e.prototype.emit = function (e, t, n) {
              var o = this.origin;
              if (r.isntString(e)) return !1;
              if (r.isntString(o)) return !1;
              "function" == typeof t && (n = t, t = void 0);
              var c = a.packagePayload(e, o, t, n);
              return !!c && (i.broadcast(window.top || window.self, c, o), !0);
            }, e.prototype.on = function (e, t) {
              var n = this.origin;
              return !o.subscriptionArgsInvalid(e, t, n) && (c.subscribers[n] = c.subscribers[n] || {}, c.subscribers[n][e] = c.subscribers[n][e] || [], c.subscribers[n][e].push(t), !0);
            }, e.prototype.off = function (e, t) {
              var n = this.origin;
              if (o.subscriptionArgsInvalid(e, t, n)) return !1;
              var r = c.subscribers[n] && c.subscribers[n][e];
              if (!r) return !1;
              for (var i = 0; i < r.length; i++) if (r[i] === t) return r.splice(i, 1), !0;
              return !1;
            }, e;
          }();
        t.Framebus = l;
      },
      2281: (e, t, n) => {
        "use strict";

        var r = n(7920),
          o = new (n(6096).Framebus)();
        r.attach(), e.exports = o;
      },
      7920: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.detach = t.attach = void 0;
        var r = n(3610),
          o = !1;
        t.attach = function () {
          o || "undefined" == typeof window || (o = !0, window.addEventListener("message", r.onmessage, !1));
        }, t.detach = function () {
          o = !1, window.removeEventListener("message", r.onmessage, !1);
        };
      },
      1117: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.broadcastToChildWindows = void 0;
        var r = n(9974),
          o = n(6968);
        t.broadcastToChildWindows = function (e, t, n) {
          for (var i = o.childWindows.length - 1; i >= 0; i--) {
            var a = o.childWindows[i];
            a.closed ? o.childWindows.splice(i, 1) : n !== a && r.broadcast(a.top, e, t);
          }
        };
      },
      9974: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.broadcast = void 0;
        var r = n(5213);
        t.broadcast = function e(t, n, o) {
          var i,
            a = 0;
          try {
            for (t.postMessage(n, o), r.hasOpener(t) && e(t.opener.top, n, o); i = t.frames[a];) e(i, n, o), a++;
          } catch (e) {}
        };
      },
      6968: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.subscribers = t.childWindows = t.prefix = void 0, t.prefix = "/*framebus*/", t.childWindows = [], t.subscribers = {};
      },
      9923: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.dispatch = void 0;
        var r = n(6968);
        t.dispatch = function (e, t, n, o, i) {
          if (r.subscribers[e] && r.subscribers[e][t]) {
            var a = [];
            n && a.push(n), o && a.push(o);
            for (var c = 0; c < r.subscribers[e][t].length; c++) r.subscribers[e][t][c].apply(i, a);
          }
        };
      },
      5213: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasOpener = void 0, t.hasOpener = function (e) {
          return e.top === e && null != e.opener && e.opener !== e && !0 !== e.opener.closed;
        };
      },
      9275: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isntString = void 0, t.isntString = function (e) {
          return "string" != typeof e;
        };
      },
      3610: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.onmessage = void 0;
        var r = n(9275),
          o = n(9752),
          i = n(9923),
          a = n(1117);
        t.onmessage = function (e) {
          if (!r.isntString(e.data)) {
            var t = o.unpackPayload(e);
            if (t) {
              var n = t.eventData,
                c = t.reply;
              i.dispatch("*", t.event, n, c, e), i.dispatch(e.origin, t.event, n, c, e), a.broadcastToChildWindows(e.data, t.origin, e.source);
            }
          }
        };
      },
      3678: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.packagePayload = void 0;
        var r = n(5159),
          o = n(6968);
        t.packagePayload = function (e, t, n, i) {
          var a,
            c = {
              event: e,
              origin: t
            };
          "function" == typeof i && (c.reply = r.subscribeReplier(i, t)), c.eventData = n;
          try {
            a = o.prefix + JSON.stringify(c);
          } catch (e) {
            throw new Error("Could not stringify event: " + e.message);
          }
          return a;
        };
      },
      5159: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.subscribeReplier = void 0;
        var o = n(6096),
          i = r(n(841));
        t.subscribeReplier = function (e, t) {
          var n = i.default();
          return o.Framebus.target(t).on(n, function r(i, a) {
            e(i, a), o.Framebus.target(t).off(n, r);
          }), n;
        };
      },
      2926: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.subscriptionArgsInvalid = void 0;
        var r = n(9275);
        t.subscriptionArgsInvalid = function (e, t, n) {
          return !!r.isntString(e) || "function" != typeof t || r.isntString(n);
        };
      },
      9752: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.unpackPayload = void 0;
        var r = n(6968),
          o = n(3678);
        t.unpackPayload = function (e) {
          var t;
          if (e.data.slice(0, r.prefix.length) !== r.prefix) return !1;
          try {
            t = JSON.parse(e.data.slice(r.prefix.length));
          } catch (e) {
            return !1;
          }
          if (t.reply) {
            var n = e.origin,
              i = e.source,
              a = t.reply;
            t.reply = function (e) {
              if (i) {
                var t = o.packagePayload(a, n, e);
                t && i.postMessage(t, n);
              }
            };
          }
          return t;
        };
      },
      9353: e => {
        "use strict";

        var t = Array.prototype.slice,
          n = Object.prototype.toString;
        e.exports = function (e) {
          var r = this;
          if ("function" != typeof r || "[object Function]" !== n.call(r)) throw new TypeError("Function.prototype.bind called on incompatible " + r);
          for (var o, i = t.call(arguments, 1), a = Math.max(0, r.length - i.length), c = [], l = 0; l < a; l++) c.push("$" + l);
          if (o = Function("binder", "return function (" + c.join(",") + "){ return binder.apply(this,arguments); }")(function () {
            if (this instanceof o) {
              var n = r.apply(this, i.concat(t.call(arguments)));
              return Object(n) === n ? n : this;
            }
            return r.apply(e, i.concat(t.call(arguments)));
          }), r.prototype) {
            var s = function () {};
            s.prototype = r.prototype, o.prototype = new s(), s.prototype = null;
          }
          return o;
        };
      },
      6743: (e, t, n) => {
        "use strict";

        var r = n(9353);
        e.exports = Function.prototype.bind || r;
      },
      453: (e, t, n) => {
        "use strict";

        var r,
          o = SyntaxError,
          i = Function,
          a = TypeError,
          c = function (e) {
            try {
              return i('"use strict"; return (' + e + ").constructor;")();
            } catch (e) {}
          },
          l = Object.getOwnPropertyDescriptor;
        if (l) try {
          l({}, "");
        } catch (e) {
          l = null;
        }
        var s = function () {
            throw new a();
          },
          p = l ? function () {
            try {
              return s;
            } catch (e) {
              try {
                return l(arguments, "callee").get;
              } catch (e) {
                return s;
              }
            }
          }() : s,
          u = n(4039)(),
          d = n(24)(),
          f = Object.getPrototypeOf || (d ? function (e) {
            return e.__proto__;
          } : null),
          E = {},
          _ = "undefined" != typeof Uint8Array && f ? f(Uint8Array) : r,
          m = {
            "%AggregateError%": "undefined" == typeof AggregateError ? r : AggregateError,
            "%Array%": Array,
            "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? r : ArrayBuffer,
            "%ArrayIteratorPrototype%": u && f ? f([][Symbol.iterator]()) : r,
            "%AsyncFromSyncIteratorPrototype%": r,
            "%AsyncFunction%": E,
            "%AsyncGenerator%": E,
            "%AsyncGeneratorFunction%": E,
            "%AsyncIteratorPrototype%": E,
            "%Atomics%": "undefined" == typeof Atomics ? r : Atomics,
            "%BigInt%": "undefined" == typeof BigInt ? r : BigInt,
            "%BigInt64Array%": "undefined" == typeof BigInt64Array ? r : BigInt64Array,
            "%BigUint64Array%": "undefined" == typeof BigUint64Array ? r : BigUint64Array,
            "%Boolean%": Boolean,
            "%DataView%": "undefined" == typeof DataView ? r : DataView,
            "%Date%": Date,
            "%decodeURI%": decodeURI,
            "%decodeURIComponent%": decodeURIComponent,
            "%encodeURI%": encodeURI,
            "%encodeURIComponent%": encodeURIComponent,
            "%Error%": Error,
            "%eval%": eval,
            "%EvalError%": EvalError,
            "%Float32Array%": "undefined" == typeof Float32Array ? r : Float32Array,
            "%Float64Array%": "undefined" == typeof Float64Array ? r : Float64Array,
            "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? r : FinalizationRegistry,
            "%Function%": i,
            "%GeneratorFunction%": E,
            "%Int8Array%": "undefined" == typeof Int8Array ? r : Int8Array,
            "%Int16Array%": "undefined" == typeof Int16Array ? r : Int16Array,
            "%Int32Array%": "undefined" == typeof Int32Array ? r : Int32Array,
            "%isFinite%": isFinite,
            "%isNaN%": isNaN,
            "%IteratorPrototype%": u && f ? f(f([][Symbol.iterator]())) : r,
            "%JSON%": "object" == typeof JSON ? JSON : r,
            "%Map%": "undefined" == typeof Map ? r : Map,
            "%MapIteratorPrototype%": "undefined" != typeof Map && u && f ? f(new Map()[Symbol.iterator]()) : r,
            "%Math%": Math,
            "%Number%": Number,
            "%Object%": Object,
            "%parseFloat%": parseFloat,
            "%parseInt%": parseInt,
            "%Promise%": "undefined" == typeof Promise ? r : Promise,
            "%Proxy%": "undefined" == typeof Proxy ? r : Proxy,
            "%RangeError%": RangeError,
            "%ReferenceError%": ReferenceError,
            "%Reflect%": "undefined" == typeof Reflect ? r : Reflect,
            "%RegExp%": RegExp,
            "%Set%": "undefined" == typeof Set ? r : Set,
            "%SetIteratorPrototype%": "undefined" != typeof Set && u && f ? f(new Set()[Symbol.iterator]()) : r,
            "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? r : SharedArrayBuffer,
            "%String%": String,
            "%StringIteratorPrototype%": u && f ? f(""[Symbol.iterator]()) : r,
            "%Symbol%": u ? Symbol : r,
            "%SyntaxError%": o,
            "%ThrowTypeError%": p,
            "%TypedArray%": _,
            "%TypeError%": a,
            "%Uint8Array%": "undefined" == typeof Uint8Array ? r : Uint8Array,
            "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? r : Uint8ClampedArray,
            "%Uint16Array%": "undefined" == typeof Uint16Array ? r : Uint16Array,
            "%Uint32Array%": "undefined" == typeof Uint32Array ? r : Uint32Array,
            "%URIError%": URIError,
            "%WeakMap%": "undefined" == typeof WeakMap ? r : WeakMap,
            "%WeakRef%": "undefined" == typeof WeakRef ? r : WeakRef,
            "%WeakSet%": "undefined" == typeof WeakSet ? r : WeakSet
          };
        if (f) try {
          null.error;
        } catch (e) {
          var v = f(f(e));
          m["%Error.prototype%"] = v;
        }
        var I = function e(t) {
            var n;
            if ("%AsyncFunction%" === t) n = c("async function () {}");else if ("%GeneratorFunction%" === t) n = c("function* () {}");else if ("%AsyncGeneratorFunction%" === t) n = c("async function* () {}");else if ("%AsyncGenerator%" === t) {
              var r = e("%AsyncGeneratorFunction%");
              r && (n = r.prototype);
            } else if ("%AsyncIteratorPrototype%" === t) {
              var o = e("%AsyncGenerator%");
              o && f && (n = f(o.prototype));
            }
            return m[t] = n, n;
          },
          y = {
            "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
            "%ArrayPrototype%": ["Array", "prototype"],
            "%ArrayProto_entries%": ["Array", "prototype", "entries"],
            "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
            "%ArrayProto_keys%": ["Array", "prototype", "keys"],
            "%ArrayProto_values%": ["Array", "prototype", "values"],
            "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
            "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
            "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
            "%BooleanPrototype%": ["Boolean", "prototype"],
            "%DataViewPrototype%": ["DataView", "prototype"],
            "%DatePrototype%": ["Date", "prototype"],
            "%ErrorPrototype%": ["Error", "prototype"],
            "%EvalErrorPrototype%": ["EvalError", "prototype"],
            "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
            "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
            "%FunctionPrototype%": ["Function", "prototype"],
            "%Generator%": ["GeneratorFunction", "prototype"],
            "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
            "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
            "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
            "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
            "%JSONParse%": ["JSON", "parse"],
            "%JSONStringify%": ["JSON", "stringify"],
            "%MapPrototype%": ["Map", "prototype"],
            "%NumberPrototype%": ["Number", "prototype"],
            "%ObjectPrototype%": ["Object", "prototype"],
            "%ObjProto_toString%": ["Object", "prototype", "toString"],
            "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
            "%PromisePrototype%": ["Promise", "prototype"],
            "%PromiseProto_then%": ["Promise", "prototype", "then"],
            "%Promise_all%": ["Promise", "all"],
            "%Promise_reject%": ["Promise", "reject"],
            "%Promise_resolve%": ["Promise", "resolve"],
            "%RangeErrorPrototype%": ["RangeError", "prototype"],
            "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
            "%RegExpPrototype%": ["RegExp", "prototype"],
            "%SetPrototype%": ["Set", "prototype"],
            "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
            "%StringPrototype%": ["String", "prototype"],
            "%SymbolPrototype%": ["Symbol", "prototype"],
            "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
            "%TypedArrayPrototype%": ["TypedArray", "prototype"],
            "%TypeErrorPrototype%": ["TypeError", "prototype"],
            "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
            "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
            "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
            "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
            "%URIErrorPrototype%": ["URIError", "prototype"],
            "%WeakMapPrototype%": ["WeakMap", "prototype"],
            "%WeakSetPrototype%": ["WeakSet", "prototype"]
          },
          O = n(6743),
          g = n(9030),
          N = O.call(Function.call, Array.prototype.concat),
          L = O.call(Function.apply, Array.prototype.splice),
          T = O.call(Function.call, String.prototype.replace),
          h = O.call(Function.call, String.prototype.slice),
          b = O.call(Function.call, RegExp.prototype.exec),
          A = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
          w = /\\(\\)?/g,
          R = function (e, t) {
            var n,
              r = e;
            if (g(y, r) && (r = "%" + (n = y[r])[0] + "%"), g(m, r)) {
              var i = m[r];
              if (i === E && (i = I(r)), void 0 === i && !t) throw new a("intrinsic " + e + " exists, but is not available. Please file an issue!");
              return {
                alias: n,
                name: r,
                value: i
              };
            }
            throw new o("intrinsic " + e + " does not exist!");
          };
        e.exports = function (e, t) {
          if ("string" != typeof e || 0 === e.length) throw new a("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && "boolean" != typeof t) throw new a('"allowMissing" argument must be a boolean');
          if (null === b(/^%?[^%]*%?$/, e)) throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
          var n = function (e) {
              var t = h(e, 0, 1),
                n = h(e, -1);
              if ("%" === t && "%" !== n) throw new o("invalid intrinsic syntax, expected closing `%`");
              if ("%" === n && "%" !== t) throw new o("invalid intrinsic syntax, expected opening `%`");
              var r = [];
              return T(e, A, function (e, t, n, o) {
                r[r.length] = n ? T(o, w, "$1") : t || e;
              }), r;
            }(e),
            r = n.length > 0 ? n[0] : "",
            i = R("%" + r + "%", t),
            c = i.name,
            s = i.value,
            p = !1,
            u = i.alias;
          u && (r = u[0], L(n, N([0, 1], u)));
          for (var d = 1, f = !0; d < n.length; d += 1) {
            var E = n[d],
              _ = h(E, 0, 1),
              v = h(E, -1);
            if (('"' === _ || "'" === _ || "`" === _ || '"' === v || "'" === v || "`" === v) && _ !== v) throw new o("property names with quotes must have matching quotes");
            if ("constructor" !== E && f || (p = !0), g(m, c = "%" + (r += "." + E) + "%")) s = m[c];else if (null != s) {
              if (!(E in s)) {
                if (!t) throw new a("base intrinsic for " + e + " exists, but the property is not available.");
                return;
              }
              if (l && d + 1 >= n.length) {
                var I = l(s, E);
                s = (f = !!I) && "get" in I && !("originalValue" in I.get) ? I.get : s[E];
              } else f = g(s, E), s = s[E];
              f && !p && (m[c] = s);
            }
          }
          return s;
        };
      },
      5795: (e, t, n) => {
        "use strict";

        var r = n(453)("%Object.getOwnPropertyDescriptor%", !0);
        if (r) try {
          r([], "length");
        } catch (e) {
          r = null;
        }
        e.exports = r;
      },
      592: (e, t, n) => {
        "use strict";

        var r = n(453)("%Object.defineProperty%", !0),
          o = function () {
            if (r) try {
              return r({}, "a", {
                value: 1
              }), !0;
            } catch (e) {
              return !1;
            }
            return !1;
          };
        o.hasArrayLengthDefineBug = function () {
          if (!o()) return null;
          try {
            return 1 !== r([], "length", {
              value: 1
            }).length;
          } catch (e) {
            return !0;
          }
        }, e.exports = o;
      },
      24: e => {
        "use strict";

        var t = {
            foo: {}
          },
          n = Object;
        e.exports = function () {
          return {
            __proto__: t
          }.foo === t.foo && !({
            __proto__: null
          } instanceof n);
        };
      },
      4039: (e, t, n) => {
        "use strict";

        var r = "undefined" != typeof Symbol && Symbol,
          o = n(1333);
        e.exports = function () {
          return "function" == typeof r && "function" == typeof Symbol && "symbol" == typeof r("foo") && "symbol" == typeof Symbol("bar") && o();
        };
      },
      1333: e => {
        "use strict";

        e.exports = function () {
          if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
          if ("symbol" == typeof Symbol.iterator) return !0;
          var e = {},
            t = Symbol("test"),
            n = Object(t);
          if ("string" == typeof t) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
          if ("[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
          for (t in e[t] = 42, e) return !1;
          if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
          if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
          var r = Object.getOwnPropertySymbols(e);
          if (1 !== r.length || r[0] !== t) return !1;
          if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
          if ("function" == typeof Object.getOwnPropertyDescriptor) {
            var o = Object.getOwnPropertyDescriptor(e, t);
            if (42 !== o.value || !0 !== o.enumerable) return !1;
          }
          return !0;
        };
      },
      9092: (e, t, n) => {
        "use strict";

        var r = n(1333);
        e.exports = function () {
          return r() && !!Symbol.toStringTag;
        };
      },
      9030: (e, t, n) => {
        "use strict";

        var r = n(6743);
        e.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
      },
      6698: e => {
        "function" == typeof Object.create ? e.exports = function (e, t) {
          t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : e.exports = function (e, t) {
          if (t) {
            e.super_ = t;
            var n = function () {};
            n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
          }
        };
      },
      7244: (e, t, n) => {
        "use strict";

        var r = n(9092)(),
          o = n(8075)("Object.prototype.toString"),
          i = function (e) {
            return !(r && e && "object" == typeof e && Symbol.toStringTag in e) && "[object Arguments]" === o(e);
          },
          a = function (e) {
            return !!i(e) || null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== o(e) && "[object Function]" === o(e.callee);
          },
          c = function () {
            return i(arguments);
          }();
        i.isLegacyArguments = a, e.exports = c ? i : a;
      },
      9600: e => {
        "use strict";

        var t,
          n,
          r = Function.prototype.toString,
          o = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
        if ("function" == typeof o && "function" == typeof Object.defineProperty) try {
          t = Object.defineProperty({}, "length", {
            get: function () {
              throw n;
            }
          }), n = {}, o(function () {
            throw 42;
          }, null, t);
        } catch (e) {
          e !== n && (o = null);
        } else o = null;
        var i = /^\s*class\b/,
          a = function (e) {
            try {
              var t = r.call(e);
              return i.test(t);
            } catch (e) {
              return !1;
            }
          },
          c = function (e) {
            try {
              return !a(e) && (r.call(e), !0);
            } catch (e) {
              return !1;
            }
          },
          l = Object.prototype.toString,
          s = "function" == typeof Symbol && !!Symbol.toStringTag,
          p = !(0 in [,]),
          u = function () {
            return !1;
          };
        if ("object" == typeof document) {
          var d = document.all;
          l.call(d) === l.call(document.all) && (u = function (e) {
            if ((p || !e) && (void 0 === e || "object" == typeof e)) try {
              var t = l.call(e);
              return ("[object HTMLAllCollection]" === t || "[object HTML document.all class]" === t || "[object HTMLCollection]" === t || "[object Object]" === t) && null == e("");
            } catch (e) {}
            return !1;
          });
        }
        e.exports = o ? function (e) {
          if (u(e)) return !0;
          if (!e) return !1;
          if ("function" != typeof e && "object" != typeof e) return !1;
          try {
            o(e, null, t);
          } catch (e) {
            if (e !== n) return !1;
          }
          return !a(e) && c(e);
        } : function (e) {
          if (u(e)) return !0;
          if (!e) return !1;
          if ("function" != typeof e && "object" != typeof e) return !1;
          if (s) return c(e);
          if (a(e)) return !1;
          var t = l.call(e);
          return !("[object Function]" !== t && "[object GeneratorFunction]" !== t && !/^\[object HTML/.test(t)) && c(e);
        };
      },
      8184: (e, t, n) => {
        "use strict";

        var r,
          o = Object.prototype.toString,
          i = Function.prototype.toString,
          a = /^\s*(?:function)?\*/,
          c = n(9092)(),
          l = Object.getPrototypeOf;
        e.exports = function (e) {
          if ("function" != typeof e) return !1;
          if (a.test(i.call(e))) return !0;
          if (!c) return "[object GeneratorFunction]" === o.call(e);
          if (!l) return !1;
          if (void 0 === r) {
            var t = function () {
              if (!c) return !1;
              try {
                return Function("return function*() {}")();
              } catch (e) {}
            }();
            r = !!t && l(t);
          }
          return l(e) === r;
        };
      },
      3003: e => {
        "use strict";

        e.exports = function (e) {
          return e != e;
        };
      },
      4133: (e, t, n) => {
        "use strict";

        var r = n(487),
          o = n(8452),
          i = n(3003),
          a = n(6642),
          c = n(2464),
          l = r(a(), Number);
        o(l, {
          getPolyfill: a,
          implementation: i,
          shim: c
        }), e.exports = l;
      },
      6642: (e, t, n) => {
        "use strict";

        var r = n(3003);
        e.exports = function () {
          return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : r;
        };
      },
      2464: (e, t, n) => {
        "use strict";

        var r = n(8452),
          o = n(6642);
        e.exports = function () {
          var e = o();
          return r(Number, {
            isNaN: e
          }, {
            isNaN: function () {
              return Number.isNaN !== e;
            }
          }), e;
        };
      },
      5680: (e, t, n) => {
        "use strict";

        var r = n(5767);
        e.exports = function (e) {
          return !!r(e);
        };
      },
      7721: e => {
        e.exports = function (e, t) {
          for (var n, r = -1, o = e.length; ++r < o;) {
            var i = t(e[r]);
            void 0 !== i && (n = void 0 === n ? i : n + i);
          }
          return n;
        };
      },
      3488: e => {
        e.exports = function (e) {
          return e;
        };
      },
      6119: (e, t, n) => {
        var r = n(7721),
          o = n(3488);
        e.exports = function (e) {
          return e && e.length ? r(e, o) : 0;
        };
      },
      8673: e => {
        "use strict";

        function t() {
          this._types = Object.create(null), this._extensions = Object.create(null);
          for (let e = 0; e < arguments.length; e++) this.define(arguments[e]);
          this.define = this.define.bind(this), this.getType = this.getType.bind(this), this.getExtension = this.getExtension.bind(this);
        }
        t.prototype.define = function (e, t) {
          for (let n in e) {
            let r = e[n].map(function (e) {
              return e.toLowerCase();
            });
            n = n.toLowerCase();
            for (let e = 0; e < r.length; e++) {
              const o = r[e];
              if ("*" !== o[0]) {
                if (!t && o in this._types) throw new Error('Attempt to change mapping for "' + o + '" extension from "' + this._types[o] + '" to "' + n + '". Pass `force=true` to allow this, otherwise remove "' + o + '" from the list of extensions for "' + n + '".');
                this._types[o] = n;
              }
            }
            if (t || !this._extensions[n]) {
              const e = r[0];
              this._extensions[n] = "*" !== e[0] ? e : e.substr(1);
            }
          }
        }, t.prototype.getType = function (e) {
          let t = (e = String(e)).replace(/^.*[/\\]/, "").toLowerCase(),
            n = t.replace(/^.*\./, "").toLowerCase(),
            r = t.length < e.length;
          return (n.length < t.length - 1 || !r) && this._types[n] || null;
        }, t.prototype.getExtension = function (e) {
          return (e = /^\s*([^;\s]*)/.test(e) && RegExp.$1) && this._extensions[e.toLowerCase()] || null;
        }, e.exports = t;
      },
      125: (e, t, n) => {
        "use strict";

        let r = n(8673);
        e.exports = new r(n(8446), n(1453));
      },
      1453: e => {
        e.exports = {
          "application/prs.cww": ["cww"],
          "application/vnd.1000minds.decision-model+xml": ["1km"],
          "application/vnd.3gpp.pic-bw-large": ["plb"],
          "application/vnd.3gpp.pic-bw-small": ["psb"],
          "application/vnd.3gpp.pic-bw-var": ["pvb"],
          "application/vnd.3gpp2.tcap": ["tcap"],
          "application/vnd.3m.post-it-notes": ["pwn"],
          "application/vnd.accpac.simply.aso": ["aso"],
          "application/vnd.accpac.simply.imp": ["imp"],
          "application/vnd.acucobol": ["acu"],
          "application/vnd.acucorp": ["atc", "acutc"],
          "application/vnd.adobe.air-application-installer-package+zip": ["air"],
          "application/vnd.adobe.formscentral.fcdt": ["fcdt"],
          "application/vnd.adobe.fxp": ["fxp", "fxpl"],
          "application/vnd.adobe.xdp+xml": ["xdp"],
          "application/vnd.adobe.xfdf": ["xfdf"],
          "application/vnd.ahead.space": ["ahead"],
          "application/vnd.airzip.filesecure.azf": ["azf"],
          "application/vnd.airzip.filesecure.azs": ["azs"],
          "application/vnd.amazon.ebook": ["azw"],
          "application/vnd.americandynamics.acc": ["acc"],
          "application/vnd.amiga.ami": ["ami"],
          "application/vnd.android.package-archive": ["apk"],
          "application/vnd.anser-web-certificate-issue-initiation": ["cii"],
          "application/vnd.anser-web-funds-transfer-initiation": ["fti"],
          "application/vnd.antix.game-component": ["atx"],
          "application/vnd.apple.installer+xml": ["mpkg"],
          "application/vnd.apple.keynote": ["key"],
          "application/vnd.apple.mpegurl": ["m3u8"],
          "application/vnd.apple.numbers": ["numbers"],
          "application/vnd.apple.pages": ["pages"],
          "application/vnd.apple.pkpass": ["pkpass"],
          "application/vnd.aristanetworks.swi": ["swi"],
          "application/vnd.astraea-software.iota": ["iota"],
          "application/vnd.audiograph": ["aep"],
          "application/vnd.balsamiq.bmml+xml": ["bmml"],
          "application/vnd.blueice.multipass": ["mpm"],
          "application/vnd.bmi": ["bmi"],
          "application/vnd.businessobjects": ["rep"],
          "application/vnd.chemdraw+xml": ["cdxml"],
          "application/vnd.chipnuts.karaoke-mmd": ["mmd"],
          "application/vnd.cinderella": ["cdy"],
          "application/vnd.citationstyles.style+xml": ["csl"],
          "application/vnd.claymore": ["cla"],
          "application/vnd.cloanto.rp9": ["rp9"],
          "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"],
          "application/vnd.cluetrust.cartomobile-config": ["c11amc"],
          "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"],
          "application/vnd.commonspace": ["csp"],
          "application/vnd.contact.cmsg": ["cdbcmsg"],
          "application/vnd.cosmocaller": ["cmc"],
          "application/vnd.crick.clicker": ["clkx"],
          "application/vnd.crick.clicker.keyboard": ["clkk"],
          "application/vnd.crick.clicker.palette": ["clkp"],
          "application/vnd.crick.clicker.template": ["clkt"],
          "application/vnd.crick.clicker.wordbank": ["clkw"],
          "application/vnd.criticaltools.wbs+xml": ["wbs"],
          "application/vnd.ctc-posml": ["pml"],
          "application/vnd.cups-ppd": ["ppd"],
          "application/vnd.curl.car": ["car"],
          "application/vnd.curl.pcurl": ["pcurl"],
          "application/vnd.dart": ["dart"],
          "application/vnd.data-vision.rdz": ["rdz"],
          "application/vnd.dbf": ["dbf"],
          "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"],
          "application/vnd.dece.ttml+xml": ["uvt", "uvvt"],
          "application/vnd.dece.unspecified": ["uvx", "uvvx"],
          "application/vnd.dece.zip": ["uvz", "uvvz"],
          "application/vnd.denovo.fcselayout-link": ["fe_launch"],
          "application/vnd.dna": ["dna"],
          "application/vnd.dolby.mlp": ["mlp"],
          "application/vnd.dpgraph": ["dpg"],
          "application/vnd.dreamfactory": ["dfac"],
          "application/vnd.ds-keypoint": ["kpxx"],
          "application/vnd.dvb.ait": ["ait"],
          "application/vnd.dvb.service": ["svc"],
          "application/vnd.dynageo": ["geo"],
          "application/vnd.ecowin.chart": ["mag"],
          "application/vnd.enliven": ["nml"],
          "application/vnd.epson.esf": ["esf"],
          "application/vnd.epson.msf": ["msf"],
          "application/vnd.epson.quickanime": ["qam"],
          "application/vnd.epson.salt": ["slt"],
          "application/vnd.epson.ssf": ["ssf"],
          "application/vnd.eszigno3+xml": ["es3", "et3"],
          "application/vnd.ezpix-album": ["ez2"],
          "application/vnd.ezpix-package": ["ez3"],
          "application/vnd.fdf": ["fdf"],
          "application/vnd.fdsn.mseed": ["mseed"],
          "application/vnd.fdsn.seed": ["seed", "dataless"],
          "application/vnd.flographit": ["gph"],
          "application/vnd.fluxtime.clip": ["ftc"],
          "application/vnd.framemaker": ["fm", "frame", "maker", "book"],
          "application/vnd.frogans.fnc": ["fnc"],
          "application/vnd.frogans.ltf": ["ltf"],
          "application/vnd.fsc.weblaunch": ["fsc"],
          "application/vnd.fujitsu.oasys": ["oas"],
          "application/vnd.fujitsu.oasys2": ["oa2"],
          "application/vnd.fujitsu.oasys3": ["oa3"],
          "application/vnd.fujitsu.oasysgp": ["fg5"],
          "application/vnd.fujitsu.oasysprs": ["bh2"],
          "application/vnd.fujixerox.ddd": ["ddd"],
          "application/vnd.fujixerox.docuworks": ["xdw"],
          "application/vnd.fujixerox.docuworks.binder": ["xbd"],
          "application/vnd.fuzzysheet": ["fzs"],
          "application/vnd.genomatix.tuxedo": ["txd"],
          "application/vnd.geogebra.file": ["ggb"],
          "application/vnd.geogebra.tool": ["ggt"],
          "application/vnd.geometry-explorer": ["gex", "gre"],
          "application/vnd.geonext": ["gxt"],
          "application/vnd.geoplan": ["g2w"],
          "application/vnd.geospace": ["g3w"],
          "application/vnd.gmx": ["gmx"],
          "application/vnd.google-apps.document": ["gdoc"],
          "application/vnd.google-apps.presentation": ["gslides"],
          "application/vnd.google-apps.spreadsheet": ["gsheet"],
          "application/vnd.google-earth.kml+xml": ["kml"],
          "application/vnd.google-earth.kmz": ["kmz"],
          "application/vnd.grafeq": ["gqf", "gqs"],
          "application/vnd.groove-account": ["gac"],
          "application/vnd.groove-help": ["ghf"],
          "application/vnd.groove-identity-message": ["gim"],
          "application/vnd.groove-injector": ["grv"],
          "application/vnd.groove-tool-message": ["gtm"],
          "application/vnd.groove-tool-template": ["tpl"],
          "application/vnd.groove-vcard": ["vcg"],
          "application/vnd.hal+xml": ["hal"],
          "application/vnd.handheld-entertainment+xml": ["zmm"],
          "application/vnd.hbci": ["hbci"],
          "application/vnd.hhe.lesson-player": ["les"],
          "application/vnd.hp-hpgl": ["hpgl"],
          "application/vnd.hp-hpid": ["hpid"],
          "application/vnd.hp-hps": ["hps"],
          "application/vnd.hp-jlyt": ["jlt"],
          "application/vnd.hp-pcl": ["pcl"],
          "application/vnd.hp-pclxl": ["pclxl"],
          "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"],
          "application/vnd.ibm.minipay": ["mpy"],
          "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"],
          "application/vnd.ibm.rights-management": ["irm"],
          "application/vnd.ibm.secure-container": ["sc"],
          "application/vnd.iccprofile": ["icc", "icm"],
          "application/vnd.igloader": ["igl"],
          "application/vnd.immervision-ivp": ["ivp"],
          "application/vnd.immervision-ivu": ["ivu"],
          "application/vnd.insors.igm": ["igm"],
          "application/vnd.intercon.formnet": ["xpw", "xpx"],
          "application/vnd.intergeo": ["i2g"],
          "application/vnd.intu.qbo": ["qbo"],
          "application/vnd.intu.qfx": ["qfx"],
          "application/vnd.ipunplugged.rcprofile": ["rcprofile"],
          "application/vnd.irepository.package+xml": ["irp"],
          "application/vnd.is-xpr": ["xpr"],
          "application/vnd.isac.fcs": ["fcs"],
          "application/vnd.jam": ["jam"],
          "application/vnd.jcp.javame.midlet-rms": ["rms"],
          "application/vnd.jisp": ["jisp"],
          "application/vnd.joost.joda-archive": ["joda"],
          "application/vnd.kahootz": ["ktz", "ktr"],
          "application/vnd.kde.karbon": ["karbon"],
          "application/vnd.kde.kchart": ["chrt"],
          "application/vnd.kde.kformula": ["kfo"],
          "application/vnd.kde.kivio": ["flw"],
          "application/vnd.kde.kontour": ["kon"],
          "application/vnd.kde.kpresenter": ["kpr", "kpt"],
          "application/vnd.kde.kspread": ["ksp"],
          "application/vnd.kde.kword": ["kwd", "kwt"],
          "application/vnd.kenameaapp": ["htke"],
          "application/vnd.kidspiration": ["kia"],
          "application/vnd.kinar": ["kne", "knp"],
          "application/vnd.koan": ["skp", "skd", "skt", "skm"],
          "application/vnd.kodak-descriptor": ["sse"],
          "application/vnd.las.las+xml": ["lasxml"],
          "application/vnd.llamagraphics.life-balance.desktop": ["lbd"],
          "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"],
          "application/vnd.lotus-1-2-3": ["123"],
          "application/vnd.lotus-approach": ["apr"],
          "application/vnd.lotus-freelance": ["pre"],
          "application/vnd.lotus-notes": ["nsf"],
          "application/vnd.lotus-organizer": ["org"],
          "application/vnd.lotus-screencam": ["scm"],
          "application/vnd.lotus-wordpro": ["lwp"],
          "application/vnd.macports.portpkg": ["portpkg"],
          "application/vnd.mapbox-vector-tile": ["mvt"],
          "application/vnd.mcd": ["mcd"],
          "application/vnd.medcalcdata": ["mc1"],
          "application/vnd.mediastation.cdkey": ["cdkey"],
          "application/vnd.mfer": ["mwf"],
          "application/vnd.mfmp": ["mfm"],
          "application/vnd.micrografx.flo": ["flo"],
          "application/vnd.micrografx.igx": ["igx"],
          "application/vnd.mif": ["mif"],
          "application/vnd.mobius.daf": ["daf"],
          "application/vnd.mobius.dis": ["dis"],
          "application/vnd.mobius.mbk": ["mbk"],
          "application/vnd.mobius.mqy": ["mqy"],
          "application/vnd.mobius.msl": ["msl"],
          "application/vnd.mobius.plc": ["plc"],
          "application/vnd.mobius.txf": ["txf"],
          "application/vnd.mophun.application": ["mpn"],
          "application/vnd.mophun.certificate": ["mpc"],
          "application/vnd.mozilla.xul+xml": ["xul"],
          "application/vnd.ms-artgalry": ["cil"],
          "application/vnd.ms-cab-compressed": ["cab"],
          "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"],
          "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"],
          "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"],
          "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"],
          "application/vnd.ms-excel.template.macroenabled.12": ["xltm"],
          "application/vnd.ms-fontobject": ["eot"],
          "application/vnd.ms-htmlhelp": ["chm"],
          "application/vnd.ms-ims": ["ims"],
          "application/vnd.ms-lrm": ["lrm"],
          "application/vnd.ms-officetheme": ["thmx"],
          "application/vnd.ms-outlook": ["msg"],
          "application/vnd.ms-pki.seccat": ["cat"],
          "application/vnd.ms-pki.stl": ["*stl"],
          "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"],
          "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"],
          "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"],
          "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"],
          "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"],
          "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"],
          "application/vnd.ms-project": ["mpp", "mpt"],
          "application/vnd.ms-word.document.macroenabled.12": ["docm"],
          "application/vnd.ms-word.template.macroenabled.12": ["dotm"],
          "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"],
          "application/vnd.ms-wpl": ["wpl"],
          "application/vnd.ms-xpsdocument": ["xps"],
          "application/vnd.mseq": ["mseq"],
          "application/vnd.musician": ["mus"],
          "application/vnd.muvee.style": ["msty"],
          "application/vnd.mynfc": ["taglet"],
          "application/vnd.neurolanguage.nlu": ["nlu"],
          "application/vnd.nitf": ["ntf", "nitf"],
          "application/vnd.noblenet-directory": ["nnd"],
          "application/vnd.noblenet-sealer": ["nns"],
          "application/vnd.noblenet-web": ["nnw"],
          "application/vnd.nokia.n-gage.ac+xml": ["*ac"],
          "application/vnd.nokia.n-gage.data": ["ngdat"],
          "application/vnd.nokia.n-gage.symbian.install": ["n-gage"],
          "application/vnd.nokia.radio-preset": ["rpst"],
          "application/vnd.nokia.radio-presets": ["rpss"],
          "application/vnd.novadigm.edm": ["edm"],
          "application/vnd.novadigm.edx": ["edx"],
          "application/vnd.novadigm.ext": ["ext"],
          "application/vnd.oasis.opendocument.chart": ["odc"],
          "application/vnd.oasis.opendocument.chart-template": ["otc"],
          "application/vnd.oasis.opendocument.database": ["odb"],
          "application/vnd.oasis.opendocument.formula": ["odf"],
          "application/vnd.oasis.opendocument.formula-template": ["odft"],
          "application/vnd.oasis.opendocument.graphics": ["odg"],
          "application/vnd.oasis.opendocument.graphics-template": ["otg"],
          "application/vnd.oasis.opendocument.image": ["odi"],
          "application/vnd.oasis.opendocument.image-template": ["oti"],
          "application/vnd.oasis.opendocument.presentation": ["odp"],
          "application/vnd.oasis.opendocument.presentation-template": ["otp"],
          "application/vnd.oasis.opendocument.spreadsheet": ["ods"],
          "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"],
          "application/vnd.oasis.opendocument.text": ["odt"],
          "application/vnd.oasis.opendocument.text-master": ["odm"],
          "application/vnd.oasis.opendocument.text-template": ["ott"],
          "application/vnd.oasis.opendocument.text-web": ["oth"],
          "application/vnd.olpc-sugar": ["xo"],
          "application/vnd.oma.dd2+xml": ["dd2"],
          "application/vnd.openblox.game+xml": ["obgx"],
          "application/vnd.openofficeorg.extension": ["oxt"],
          "application/vnd.openstreetmap.data+xml": ["osm"],
          "application/vnd.openxmlformats-officedocument.presentationml.presentation": ["pptx"],
          "application/vnd.openxmlformats-officedocument.presentationml.slide": ["sldx"],
          "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ["ppsx"],
          "application/vnd.openxmlformats-officedocument.presentationml.template": ["potx"],
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
          "application/vnd.openxmlformats-officedocument.spreadsheetml.template": ["xltx"],
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"],
          "application/vnd.openxmlformats-officedocument.wordprocessingml.template": ["dotx"],
          "application/vnd.osgeo.mapguide.package": ["mgp"],
          "application/vnd.osgi.dp": ["dp"],
          "application/vnd.osgi.subsystem": ["esa"],
          "application/vnd.palm": ["pdb", "pqa", "oprc"],
          "application/vnd.pawaafile": ["paw"],
          "application/vnd.pg.format": ["str"],
          "application/vnd.pg.osasli": ["ei6"],
          "application/vnd.picsel": ["efif"],
          "application/vnd.pmi.widget": ["wg"],
          "application/vnd.pocketlearn": ["plf"],
          "application/vnd.powerbuilder6": ["pbd"],
          "application/vnd.previewsystems.box": ["box"],
          "application/vnd.proteus.magazine": ["mgz"],
          "application/vnd.publishare-delta-tree": ["qps"],
          "application/vnd.pvi.ptid1": ["ptid"],
          "application/vnd.quark.quarkxpress": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"],
          "application/vnd.rar": ["rar"],
          "application/vnd.realvnc.bed": ["bed"],
          "application/vnd.recordare.musicxml": ["mxl"],
          "application/vnd.recordare.musicxml+xml": ["musicxml"],
          "application/vnd.rig.cryptonote": ["cryptonote"],
          "application/vnd.rim.cod": ["cod"],
          "application/vnd.rn-realmedia": ["rm"],
          "application/vnd.rn-realmedia-vbr": ["rmvb"],
          "application/vnd.route66.link66+xml": ["link66"],
          "application/vnd.sailingtracker.track": ["st"],
          "application/vnd.seemail": ["see"],
          "application/vnd.sema": ["sema"],
          "application/vnd.semd": ["semd"],
          "application/vnd.semf": ["semf"],
          "application/vnd.shana.informed.formdata": ["ifm"],
          "application/vnd.shana.informed.formtemplate": ["itp"],
          "application/vnd.shana.informed.interchange": ["iif"],
          "application/vnd.shana.informed.package": ["ipk"],
          "application/vnd.simtech-mindmapper": ["twd", "twds"],
          "application/vnd.smaf": ["mmf"],
          "application/vnd.smart.teacher": ["teacher"],
          "application/vnd.software602.filler.form+xml": ["fo"],
          "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"],
          "application/vnd.spotfire.dxp": ["dxp"],
          "application/vnd.spotfire.sfs": ["sfs"],
          "application/vnd.stardivision.calc": ["sdc"],
          "application/vnd.stardivision.draw": ["sda"],
          "application/vnd.stardivision.impress": ["sdd"],
          "application/vnd.stardivision.math": ["smf"],
          "application/vnd.stardivision.writer": ["sdw", "vor"],
          "application/vnd.stardivision.writer-global": ["sgl"],
          "application/vnd.stepmania.package": ["smzip"],
          "application/vnd.stepmania.stepchart": ["sm"],
          "application/vnd.sun.wadl+xml": ["wadl"],
          "application/vnd.sun.xml.calc": ["sxc"],
          "application/vnd.sun.xml.calc.template": ["stc"],
          "application/vnd.sun.xml.draw": ["sxd"],
          "application/vnd.sun.xml.draw.template": ["std"],
          "application/vnd.sun.xml.impress": ["sxi"],
          "application/vnd.sun.xml.impress.template": ["sti"],
          "application/vnd.sun.xml.math": ["sxm"],
          "application/vnd.sun.xml.writer": ["sxw"],
          "application/vnd.sun.xml.writer.global": ["sxg"],
          "application/vnd.sun.xml.writer.template": ["stw"],
          "application/vnd.sus-calendar": ["sus", "susp"],
          "application/vnd.svd": ["svd"],
          "application/vnd.symbian.install": ["sis", "sisx"],
          "application/vnd.syncml+xml": ["xsm"],
          "application/vnd.syncml.dm+wbxml": ["bdm"],
          "application/vnd.syncml.dm+xml": ["xdm"],
          "application/vnd.syncml.dmddf+xml": ["ddf"],
          "application/vnd.tao.intent-module-archive": ["tao"],
          "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"],
          "application/vnd.tmobile-livetv": ["tmo"],
          "application/vnd.trid.tpt": ["tpt"],
          "application/vnd.triscape.mxs": ["mxs"],
          "application/vnd.trueapp": ["tra"],
          "application/vnd.ufdl": ["ufd", "ufdl"],
          "application/vnd.uiq.theme": ["utz"],
          "application/vnd.umajin": ["umj"],
          "application/vnd.unity": ["unityweb"],
          "application/vnd.uoml+xml": ["uoml"],
          "application/vnd.vcx": ["vcx"],
          "application/vnd.visio": ["vsd", "vst", "vss", "vsw"],
          "application/vnd.visionary": ["vis"],
          "application/vnd.vsf": ["vsf"],
          "application/vnd.wap.wbxml": ["wbxml"],
          "application/vnd.wap.wmlc": ["wmlc"],
          "application/vnd.wap.wmlscriptc": ["wmlsc"],
          "application/vnd.webturbo": ["wtb"],
          "application/vnd.wolfram.player": ["nbp"],
          "application/vnd.wordperfect": ["wpd"],
          "application/vnd.wqd": ["wqd"],
          "application/vnd.wt.stf": ["stf"],
          "application/vnd.xara": ["xar"],
          "application/vnd.xfdl": ["xfdl"],
          "application/vnd.yamaha.hv-dic": ["hvd"],
          "application/vnd.yamaha.hv-script": ["hvs"],
          "application/vnd.yamaha.hv-voice": ["hvp"],
          "application/vnd.yamaha.openscoreformat": ["osf"],
          "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"],
          "application/vnd.yamaha.smaf-audio": ["saf"],
          "application/vnd.yamaha.smaf-phrase": ["spf"],
          "application/vnd.yellowriver-custom-menu": ["cmp"],
          "application/vnd.zul": ["zir", "zirz"],
          "application/vnd.zzazz.deck+xml": ["zaz"],
          "application/x-7z-compressed": ["7z"],
          "application/x-abiword": ["abw"],
          "application/x-ace-compressed": ["ace"],
          "application/x-apple-diskimage": ["*dmg"],
          "application/x-arj": ["arj"],
          "application/x-authorware-bin": ["aab", "x32", "u32", "vox"],
          "application/x-authorware-map": ["aam"],
          "application/x-authorware-seg": ["aas"],
          "application/x-bcpio": ["bcpio"],
          "application/x-bdoc": ["*bdoc"],
          "application/x-bittorrent": ["torrent"],
          "application/x-blorb": ["blb", "blorb"],
          "application/x-bzip": ["bz"],
          "application/x-bzip2": ["bz2", "boz"],
          "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"],
          "application/x-cdlink": ["vcd"],
          "application/x-cfs-compressed": ["cfs"],
          "application/x-chat": ["chat"],
          "application/x-chess-pgn": ["pgn"],
          "application/x-chrome-extension": ["crx"],
          "application/x-cocoa": ["cco"],
          "application/x-conference": ["nsc"],
          "application/x-cpio": ["cpio"],
          "application/x-csh": ["csh"],
          "application/x-debian-package": ["*deb", "udeb"],
          "application/x-dgc-compressed": ["dgc"],
          "application/x-director": ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"],
          "application/x-doom": ["wad"],
          "application/x-dtbncx+xml": ["ncx"],
          "application/x-dtbook+xml": ["dtb"],
          "application/x-dtbresource+xml": ["res"],
          "application/x-dvi": ["dvi"],
          "application/x-envoy": ["evy"],
          "application/x-eva": ["eva"],
          "application/x-font-bdf": ["bdf"],
          "application/x-font-ghostscript": ["gsf"],
          "application/x-font-linux-psf": ["psf"],
          "application/x-font-pcf": ["pcf"],
          "application/x-font-snf": ["snf"],
          "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"],
          "application/x-freearc": ["arc"],
          "application/x-futuresplash": ["spl"],
          "application/x-gca-compressed": ["gca"],
          "application/x-glulx": ["ulx"],
          "application/x-gnumeric": ["gnumeric"],
          "application/x-gramps-xml": ["gramps"],
          "application/x-gtar": ["gtar"],
          "application/x-hdf": ["hdf"],
          "application/x-httpd-php": ["php"],
          "application/x-install-instructions": ["install"],
          "application/x-iso9660-image": ["*iso"],
          "application/x-iwork-keynote-sffkey": ["*key"],
          "application/x-iwork-numbers-sffnumbers": ["*numbers"],
          "application/x-iwork-pages-sffpages": ["*pages"],
          "application/x-java-archive-diff": ["jardiff"],
          "application/x-java-jnlp-file": ["jnlp"],
          "application/x-keepass2": ["kdbx"],
          "application/x-latex": ["latex"],
          "application/x-lua-bytecode": ["luac"],
          "application/x-lzh-compressed": ["lzh", "lha"],
          "application/x-makeself": ["run"],
          "application/x-mie": ["mie"],
          "application/x-mobipocket-ebook": ["prc", "mobi"],
          "application/x-ms-application": ["application"],
          "application/x-ms-shortcut": ["lnk"],
          "application/x-ms-wmd": ["wmd"],
          "application/x-ms-wmz": ["wmz"],
          "application/x-ms-xbap": ["xbap"],
          "application/x-msaccess": ["mdb"],
          "application/x-msbinder": ["obd"],
          "application/x-mscardfile": ["crd"],
          "application/x-msclip": ["clp"],
          "application/x-msdos-program": ["*exe"],
          "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"],
          "application/x-msmediaview": ["mvb", "m13", "m14"],
          "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"],
          "application/x-msmoney": ["mny"],
          "application/x-mspublisher": ["pub"],
          "application/x-msschedule": ["scd"],
          "application/x-msterminal": ["trm"],
          "application/x-mswrite": ["wri"],
          "application/x-netcdf": ["nc", "cdf"],
          "application/x-ns-proxy-autoconfig": ["pac"],
          "application/x-nzb": ["nzb"],
          "application/x-perl": ["pl", "pm"],
          "application/x-pilot": ["*prc", "*pdb"],
          "application/x-pkcs12": ["p12", "pfx"],
          "application/x-pkcs7-certificates": ["p7b", "spc"],
          "application/x-pkcs7-certreqresp": ["p7r"],
          "application/x-rar-compressed": ["*rar"],
          "application/x-redhat-package-manager": ["rpm"],
          "application/x-research-info-systems": ["ris"],
          "application/x-sea": ["sea"],
          "application/x-sh": ["sh"],
          "application/x-shar": ["shar"],
          "application/x-shockwave-flash": ["swf"],
          "application/x-silverlight-app": ["xap"],
          "application/x-sql": ["sql"],
          "application/x-stuffit": ["sit"],
          "application/x-stuffitx": ["sitx"],
          "application/x-subrip": ["srt"],
          "application/x-sv4cpio": ["sv4cpio"],
          "application/x-sv4crc": ["sv4crc"],
          "application/x-t3vm-image": ["t3"],
          "application/x-tads": ["gam"],
          "application/x-tar": ["tar"],
          "application/x-tcl": ["tcl", "tk"],
          "application/x-tex": ["tex"],
          "application/x-tex-tfm": ["tfm"],
          "application/x-texinfo": ["texinfo", "texi"],
          "application/x-tgif": ["*obj"],
          "application/x-ustar": ["ustar"],
          "application/x-virtualbox-hdd": ["hdd"],
          "application/x-virtualbox-ova": ["ova"],
          "application/x-virtualbox-ovf": ["ovf"],
          "application/x-virtualbox-vbox": ["vbox"],
          "application/x-virtualbox-vbox-extpack": ["vbox-extpack"],
          "application/x-virtualbox-vdi": ["vdi"],
          "application/x-virtualbox-vhd": ["vhd"],
          "application/x-virtualbox-vmdk": ["vmdk"],
          "application/x-wais-source": ["src"],
          "application/x-web-app-manifest+json": ["webapp"],
          "application/x-x509-ca-cert": ["der", "crt", "pem"],
          "application/x-xfig": ["fig"],
          "application/x-xliff+xml": ["*xlf"],
          "application/x-xpinstall": ["xpi"],
          "application/x-xz": ["xz"],
          "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"],
          "audio/vnd.dece.audio": ["uva", "uvva"],
          "audio/vnd.digital-winds": ["eol"],
          "audio/vnd.dra": ["dra"],
          "audio/vnd.dts": ["dts"],
          "audio/vnd.dts.hd": ["dtshd"],
          "audio/vnd.lucent.voice": ["lvp"],
          "audio/vnd.ms-playready.media.pya": ["pya"],
          "audio/vnd.nuera.ecelp4800": ["ecelp4800"],
          "audio/vnd.nuera.ecelp7470": ["ecelp7470"],
          "audio/vnd.nuera.ecelp9600": ["ecelp9600"],
          "audio/vnd.rip": ["rip"],
          "audio/x-aac": ["aac"],
          "audio/x-aiff": ["aif", "aiff", "aifc"],
          "audio/x-caf": ["caf"],
          "audio/x-flac": ["flac"],
          "audio/x-m4a": ["*m4a"],
          "audio/x-matroska": ["mka"],
          "audio/x-mpegurl": ["m3u"],
          "audio/x-ms-wax": ["wax"],
          "audio/x-ms-wma": ["wma"],
          "audio/x-pn-realaudio": ["ram", "ra"],
          "audio/x-pn-realaudio-plugin": ["rmp"],
          "audio/x-realaudio": ["*ra"],
          "audio/x-wav": ["*wav"],
          "chemical/x-cdx": ["cdx"],
          "chemical/x-cif": ["cif"],
          "chemical/x-cmdf": ["cmdf"],
          "chemical/x-cml": ["cml"],
          "chemical/x-csml": ["csml"],
          "chemical/x-xyz": ["xyz"],
          "image/prs.btif": ["btif"],
          "image/prs.pti": ["pti"],
          "image/vnd.adobe.photoshop": ["psd"],
          "image/vnd.airzip.accelerator.azv": ["azv"],
          "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"],
          "image/vnd.djvu": ["djvu", "djv"],
          "image/vnd.dvb.subtitle": ["*sub"],
          "image/vnd.dwg": ["dwg"],
          "image/vnd.dxf": ["dxf"],
          "image/vnd.fastbidsheet": ["fbs"],
          "image/vnd.fpx": ["fpx"],
          "image/vnd.fst": ["fst"],
          "image/vnd.fujixerox.edmics-mmr": ["mmr"],
          "image/vnd.fujixerox.edmics-rlc": ["rlc"],
          "image/vnd.microsoft.icon": ["ico"],
          "image/vnd.ms-dds": ["dds"],
          "image/vnd.ms-modi": ["mdi"],
          "image/vnd.ms-photo": ["wdp"],
          "image/vnd.net-fpx": ["npx"],
          "image/vnd.pco.b16": ["b16"],
          "image/vnd.tencent.tap": ["tap"],
          "image/vnd.valve.source.texture": ["vtf"],
          "image/vnd.wap.wbmp": ["wbmp"],
          "image/vnd.xiff": ["xif"],
          "image/vnd.zbrush.pcx": ["pcx"],
          "image/x-3ds": ["3ds"],
          "image/x-cmu-raster": ["ras"],
          "image/x-cmx": ["cmx"],
          "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"],
          "image/x-icon": ["*ico"],
          "image/x-jng": ["jng"],
          "image/x-mrsid-image": ["sid"],
          "image/x-ms-bmp": ["*bmp"],
          "image/x-pcx": ["*pcx"],
          "image/x-pict": ["pic", "pct"],
          "image/x-portable-anymap": ["pnm"],
          "image/x-portable-bitmap": ["pbm"],
          "image/x-portable-graymap": ["pgm"],
          "image/x-portable-pixmap": ["ppm"],
          "image/x-rgb": ["rgb"],
          "image/x-tga": ["tga"],
          "image/x-xbitmap": ["xbm"],
          "image/x-xpixmap": ["xpm"],
          "image/x-xwindowdump": ["xwd"],
          "message/vnd.wfa.wsc": ["wsc"],
          "model/vnd.collada+xml": ["dae"],
          "model/vnd.dwf": ["dwf"],
          "model/vnd.gdl": ["gdl"],
          "model/vnd.gtw": ["gtw"],
          "model/vnd.mts": ["mts"],
          "model/vnd.opengex": ["ogex"],
          "model/vnd.parasolid.transmit.binary": ["x_b"],
          "model/vnd.parasolid.transmit.text": ["x_t"],
          "model/vnd.sap.vds": ["vds"],
          "model/vnd.usdz+zip": ["usdz"],
          "model/vnd.valve.source.compiled-map": ["bsp"],
          "model/vnd.vtu": ["vtu"],
          "text/prs.lines.tag": ["dsc"],
          "text/vnd.curl": ["curl"],
          "text/vnd.curl.dcurl": ["dcurl"],
          "text/vnd.curl.mcurl": ["mcurl"],
          "text/vnd.curl.scurl": ["scurl"],
          "text/vnd.dvb.subtitle": ["sub"],
          "text/vnd.fly": ["fly"],
          "text/vnd.fmi.flexstor": ["flx"],
          "text/vnd.graphviz": ["gv"],
          "text/vnd.in3d.3dml": ["3dml"],
          "text/vnd.in3d.spot": ["spot"],
          "text/vnd.sun.j2me.app-descriptor": ["jad"],
          "text/vnd.wap.wml": ["wml"],
          "text/vnd.wap.wmlscript": ["wmls"],
          "text/x-asm": ["s", "asm"],
          "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"],
          "text/x-component": ["htc"],
          "text/x-fortran": ["f", "for", "f77", "f90"],
          "text/x-handlebars-template": ["hbs"],
          "text/x-java-source": ["java"],
          "text/x-lua": ["lua"],
          "text/x-markdown": ["mkd"],
          "text/x-nfo": ["nfo"],
          "text/x-opml": ["opml"],
          "text/x-org": ["*org"],
          "text/x-pascal": ["p", "pas"],
          "text/x-processing": ["pde"],
          "text/x-sass": ["sass"],
          "text/x-scss": ["scss"],
          "text/x-setext": ["etx"],
          "text/x-sfv": ["sfv"],
          "text/x-suse-ymp": ["ymp"],
          "text/x-uuencode": ["uu"],
          "text/x-vcalendar": ["vcs"],
          "text/x-vcard": ["vcf"],
          "video/vnd.dece.hd": ["uvh", "uvvh"],
          "video/vnd.dece.mobile": ["uvm", "uvvm"],
          "video/vnd.dece.pd": ["uvp", "uvvp"],
          "video/vnd.dece.sd": ["uvs", "uvvs"],
          "video/vnd.dece.video": ["uvv", "uvvv"],
          "video/vnd.dvb.file": ["dvb"],
          "video/vnd.fvt": ["fvt"],
          "video/vnd.mpegurl": ["mxu", "m4u"],
          "video/vnd.ms-playready.media.pyv": ["pyv"],
          "video/vnd.uvvu.mp4": ["uvu", "uvvu"],
          "video/vnd.vivo": ["viv"],
          "video/x-f4v": ["f4v"],
          "video/x-fli": ["fli"],
          "video/x-flv": ["flv"],
          "video/x-m4v": ["m4v"],
          "video/x-matroska": ["mkv", "mk3d", "mks"],
          "video/x-mng": ["mng"],
          "video/x-ms-asf": ["asf", "asx"],
          "video/x-ms-vob": ["vob"],
          "video/x-ms-wm": ["wm"],
          "video/x-ms-wmv": ["wmv"],
          "video/x-ms-wmx": ["wmx"],
          "video/x-ms-wvx": ["wvx"],
          "video/x-msvideo": ["avi"],
          "video/x-sgi-movie": ["movie"],
          "video/x-smv": ["smv"],
          "x-conference/x-cooltalk": ["ice"]
        };
      },
      8446: e => {
        e.exports = {
          "application/andrew-inset": ["ez"],
          "application/applixware": ["aw"],
          "application/atom+xml": ["atom"],
          "application/atomcat+xml": ["atomcat"],
          "application/atomdeleted+xml": ["atomdeleted"],
          "application/atomsvc+xml": ["atomsvc"],
          "application/atsc-dwd+xml": ["dwd"],
          "application/atsc-held+xml": ["held"],
          "application/atsc-rsat+xml": ["rsat"],
          "application/bdoc": ["bdoc"],
          "application/calendar+xml": ["xcs"],
          "application/ccxml+xml": ["ccxml"],
          "application/cdfx+xml": ["cdfx"],
          "application/cdmi-capability": ["cdmia"],
          "application/cdmi-container": ["cdmic"],
          "application/cdmi-domain": ["cdmid"],
          "application/cdmi-object": ["cdmio"],
          "application/cdmi-queue": ["cdmiq"],
          "application/cu-seeme": ["cu"],
          "application/dash+xml": ["mpd"],
          "application/davmount+xml": ["davmount"],
          "application/docbook+xml": ["dbk"],
          "application/dssc+der": ["dssc"],
          "application/dssc+xml": ["xdssc"],
          "application/ecmascript": ["es", "ecma"],
          "application/emma+xml": ["emma"],
          "application/emotionml+xml": ["emotionml"],
          "application/epub+zip": ["epub"],
          "application/exi": ["exi"],
          "application/express": ["exp"],
          "application/fdt+xml": ["fdt"],
          "application/font-tdpfr": ["pfr"],
          "application/geo+json": ["geojson"],
          "application/gml+xml": ["gml"],
          "application/gpx+xml": ["gpx"],
          "application/gxf": ["gxf"],
          "application/gzip": ["gz"],
          "application/hjson": ["hjson"],
          "application/hyperstudio": ["stk"],
          "application/inkml+xml": ["ink", "inkml"],
          "application/ipfix": ["ipfix"],
          "application/its+xml": ["its"],
          "application/java-archive": ["jar", "war", "ear"],
          "application/java-serialized-object": ["ser"],
          "application/java-vm": ["class"],
          "application/javascript": ["js", "mjs"],
          "application/json": ["json", "map"],
          "application/json5": ["json5"],
          "application/jsonml+json": ["jsonml"],
          "application/ld+json": ["jsonld"],
          "application/lgr+xml": ["lgr"],
          "application/lost+xml": ["lostxml"],
          "application/mac-binhex40": ["hqx"],
          "application/mac-compactpro": ["cpt"],
          "application/mads+xml": ["mads"],
          "application/manifest+json": ["webmanifest"],
          "application/marc": ["mrc"],
          "application/marcxml+xml": ["mrcx"],
          "application/mathematica": ["ma", "nb", "mb"],
          "application/mathml+xml": ["mathml"],
          "application/mbox": ["mbox"],
          "application/mediaservercontrol+xml": ["mscml"],
          "application/metalink+xml": ["metalink"],
          "application/metalink4+xml": ["meta4"],
          "application/mets+xml": ["mets"],
          "application/mmt-aei+xml": ["maei"],
          "application/mmt-usd+xml": ["musd"],
          "application/mods+xml": ["mods"],
          "application/mp21": ["m21", "mp21"],
          "application/mp4": ["mp4s", "m4p"],
          "application/msword": ["doc", "dot"],
          "application/mxf": ["mxf"],
          "application/n-quads": ["nq"],
          "application/n-triples": ["nt"],
          "application/node": ["cjs"],
          "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"],
          "application/oda": ["oda"],
          "application/oebps-package+xml": ["opf"],
          "application/ogg": ["ogx"],
          "application/omdoc+xml": ["omdoc"],
          "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"],
          "application/oxps": ["oxps"],
          "application/p2p-overlay+xml": ["relo"],
          "application/patch-ops-error+xml": ["xer"],
          "application/pdf": ["pdf"],
          "application/pgp-encrypted": ["pgp"],
          "application/pgp-signature": ["asc", "sig"],
          "application/pics-rules": ["prf"],
          "application/pkcs10": ["p10"],
          "application/pkcs7-mime": ["p7m", "p7c"],
          "application/pkcs7-signature": ["p7s"],
          "application/pkcs8": ["p8"],
          "application/pkix-attr-cert": ["ac"],
          "application/pkix-cert": ["cer"],
          "application/pkix-crl": ["crl"],
          "application/pkix-pkipath": ["pkipath"],
          "application/pkixcmp": ["pki"],
          "application/pls+xml": ["pls"],
          "application/postscript": ["ai", "eps", "ps"],
          "application/provenance+xml": ["provx"],
          "application/pskc+xml": ["pskcxml"],
          "application/raml+yaml": ["raml"],
          "application/rdf+xml": ["rdf", "owl"],
          "application/reginfo+xml": ["rif"],
          "application/relax-ng-compact-syntax": ["rnc"],
          "application/resource-lists+xml": ["rl"],
          "application/resource-lists-diff+xml": ["rld"],
          "application/rls-services+xml": ["rs"],
          "application/route-apd+xml": ["rapd"],
          "application/route-s-tsid+xml": ["sls"],
          "application/route-usd+xml": ["rusd"],
          "application/rpki-ghostbusters": ["gbr"],
          "application/rpki-manifest": ["mft"],
          "application/rpki-roa": ["roa"],
          "application/rsd+xml": ["rsd"],
          "application/rss+xml": ["rss"],
          "application/rtf": ["rtf"],
          "application/sbml+xml": ["sbml"],
          "application/scvp-cv-request": ["scq"],
          "application/scvp-cv-response": ["scs"],
          "application/scvp-vp-request": ["spq"],
          "application/scvp-vp-response": ["spp"],
          "application/sdp": ["sdp"],
          "application/senml+xml": ["senmlx"],
          "application/sensml+xml": ["sensmlx"],
          "application/set-payment-initiation": ["setpay"],
          "application/set-registration-initiation": ["setreg"],
          "application/shf+xml": ["shf"],
          "application/sieve": ["siv", "sieve"],
          "application/smil+xml": ["smi", "smil"],
          "application/sparql-query": ["rq"],
          "application/sparql-results+xml": ["srx"],
          "application/srgs": ["gram"],
          "application/srgs+xml": ["grxml"],
          "application/sru+xml": ["sru"],
          "application/ssdl+xml": ["ssdl"],
          "application/ssml+xml": ["ssml"],
          "application/swid+xml": ["swidtag"],
          "application/tei+xml": ["tei", "teicorpus"],
          "application/thraud+xml": ["tfi"],
          "application/timestamped-data": ["tsd"],
          "application/toml": ["toml"],
          "application/trig": ["trig"],
          "application/ttml+xml": ["ttml"],
          "application/ubjson": ["ubj"],
          "application/urc-ressheet+xml": ["rsheet"],
          "application/urc-targetdesc+xml": ["td"],
          "application/voicexml+xml": ["vxml"],
          "application/wasm": ["wasm"],
          "application/widget": ["wgt"],
          "application/winhlp": ["hlp"],
          "application/wsdl+xml": ["wsdl"],
          "application/wspolicy+xml": ["wspolicy"],
          "application/xaml+xml": ["xaml"],
          "application/xcap-att+xml": ["xav"],
          "application/xcap-caps+xml": ["xca"],
          "application/xcap-diff+xml": ["xdf"],
          "application/xcap-el+xml": ["xel"],
          "application/xcap-ns+xml": ["xns"],
          "application/xenc+xml": ["xenc"],
          "application/xhtml+xml": ["xhtml", "xht"],
          "application/xliff+xml": ["xlf"],
          "application/xml": ["xml", "xsl", "xsd", "rng"],
          "application/xml-dtd": ["dtd"],
          "application/xop+xml": ["xop"],
          "application/xproc+xml": ["xpl"],
          "application/xslt+xml": ["*xsl", "xslt"],
          "application/xspf+xml": ["xspf"],
          "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"],
          "application/yang": ["yang"],
          "application/yin+xml": ["yin"],
          "application/zip": ["zip"],
          "audio/3gpp": ["*3gpp"],
          "audio/adpcm": ["adp"],
          "audio/amr": ["amr"],
          "audio/basic": ["au", "snd"],
          "audio/midi": ["mid", "midi", "kar", "rmi"],
          "audio/mobile-xmf": ["mxmf"],
          "audio/mp3": ["*mp3"],
          "audio/mp4": ["m4a", "mp4a"],
          "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"],
          "audio/ogg": ["oga", "ogg", "spx", "opus"],
          "audio/s3m": ["s3m"],
          "audio/silk": ["sil"],
          "audio/wav": ["wav"],
          "audio/wave": ["*wav"],
          "audio/webm": ["weba"],
          "audio/xm": ["xm"],
          "font/collection": ["ttc"],
          "font/otf": ["otf"],
          "font/ttf": ["ttf"],
          "font/woff": ["woff"],
          "font/woff2": ["woff2"],
          "image/aces": ["exr"],
          "image/apng": ["apng"],
          "image/avif": ["avif"],
          "image/bmp": ["bmp"],
          "image/cgm": ["cgm"],
          "image/dicom-rle": ["drle"],
          "image/emf": ["emf"],
          "image/fits": ["fits"],
          "image/g3fax": ["g3"],
          "image/gif": ["gif"],
          "image/heic": ["heic"],
          "image/heic-sequence": ["heics"],
          "image/heif": ["heif"],
          "image/heif-sequence": ["heifs"],
          "image/hej2k": ["hej2"],
          "image/hsj2": ["hsj2"],
          "image/ief": ["ief"],
          "image/jls": ["jls"],
          "image/jp2": ["jp2", "jpg2"],
          "image/jpeg": ["jpeg", "jpg", "jpe"],
          "image/jph": ["jph"],
          "image/jphc": ["jhc"],
          "image/jpm": ["jpm"],
          "image/jpx": ["jpx", "jpf"],
          "image/jxr": ["jxr"],
          "image/jxra": ["jxra"],
          "image/jxrs": ["jxrs"],
          "image/jxs": ["jxs"],
          "image/jxsc": ["jxsc"],
          "image/jxsi": ["jxsi"],
          "image/jxss": ["jxss"],
          "image/ktx": ["ktx"],
          "image/ktx2": ["ktx2"],
          "image/png": ["png"],
          "image/sgi": ["sgi"],
          "image/svg+xml": ["svg", "svgz"],
          "image/t38": ["t38"],
          "image/tiff": ["tif", "tiff"],
          "image/tiff-fx": ["tfx"],
          "image/webp": ["webp"],
          "image/wmf": ["wmf"],
          "message/disposition-notification": ["disposition-notification"],
          "message/global": ["u8msg"],
          "message/global-delivery-status": ["u8dsn"],
          "message/global-disposition-notification": ["u8mdn"],
          "message/global-headers": ["u8hdr"],
          "message/rfc822": ["eml", "mime"],
          "model/3mf": ["3mf"],
          "model/gltf+json": ["gltf"],
          "model/gltf-binary": ["glb"],
          "model/iges": ["igs", "iges"],
          "model/mesh": ["msh", "mesh", "silo"],
          "model/mtl": ["mtl"],
          "model/obj": ["obj"],
          "model/step+xml": ["stpx"],
          "model/step+zip": ["stpz"],
          "model/step-xml+zip": ["stpxz"],
          "model/stl": ["stl"],
          "model/vrml": ["wrl", "vrml"],
          "model/x3d+binary": ["*x3db", "x3dbz"],
          "model/x3d+fastinfoset": ["x3db"],
          "model/x3d+vrml": ["*x3dv", "x3dvz"],
          "model/x3d+xml": ["x3d", "x3dz"],
          "model/x3d-vrml": ["x3dv"],
          "text/cache-manifest": ["appcache", "manifest"],
          "text/calendar": ["ics", "ifb"],
          "text/coffeescript": ["coffee", "litcoffee"],
          "text/css": ["css"],
          "text/csv": ["csv"],
          "text/html": ["html", "htm", "shtml"],
          "text/jade": ["jade"],
          "text/jsx": ["jsx"],
          "text/less": ["less"],
          "text/markdown": ["markdown", "md"],
          "text/mathml": ["mml"],
          "text/mdx": ["mdx"],
          "text/n3": ["n3"],
          "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"],
          "text/richtext": ["rtx"],
          "text/rtf": ["*rtf"],
          "text/sgml": ["sgml", "sgm"],
          "text/shex": ["shex"],
          "text/slim": ["slim", "slm"],
          "text/spdx": ["spdx"],
          "text/stylus": ["stylus", "styl"],
          "text/tab-separated-values": ["tsv"],
          "text/troff": ["t", "tr", "roff", "man", "me", "ms"],
          "text/turtle": ["ttl"],
          "text/uri-list": ["uri", "uris", "urls"],
          "text/vcard": ["vcard"],
          "text/vtt": ["vtt"],
          "text/xml": ["*xml"],
          "text/yaml": ["yaml", "yml"],
          "video/3gpp": ["3gp", "3gpp"],
          "video/3gpp2": ["3g2"],
          "video/h261": ["h261"],
          "video/h263": ["h263"],
          "video/h264": ["h264"],
          "video/iso.segment": ["m4s"],
          "video/jpeg": ["jpgv"],
          "video/jpm": ["*jpm", "jpgm"],
          "video/mj2": ["mj2", "mjp2"],
          "video/mp2t": ["ts"],
          "video/mp4": ["mp4", "mp4v", "mpg4"],
          "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"],
          "video/ogg": ["ogv"],
          "video/quicktime": ["qt", "mov"],
          "video/webm": ["webm"]
        };
      },
      9211: e => {
        "use strict";

        var t = function (e) {
          return e != e;
        };
        e.exports = function (e, n) {
          return 0 === e && 0 === n ? 1 / e == 1 / n : e === n || !(!t(e) || !t(n));
        };
      },
      7653: (e, t, n) => {
        "use strict";

        var r = n(8452),
          o = n(487),
          i = n(9211),
          a = n(9394),
          c = n(6576),
          l = o(a(), Object);
        r(l, {
          getPolyfill: a,
          implementation: i,
          shim: c
        }), e.exports = l;
      },
      9394: (e, t, n) => {
        "use strict";

        var r = n(9211);
        e.exports = function () {
          return "function" == typeof Object.is ? Object.is : r;
        };
      },
      6576: (e, t, n) => {
        "use strict";

        var r = n(9394),
          o = n(8452);
        e.exports = function () {
          var e = r();
          return o(Object, {
            is: e
          }, {
            is: function () {
              return Object.is !== e;
            }
          }), e;
        };
      },
      8875: (e, t, n) => {
        "use strict";

        var r;
        if (!Object.keys) {
          var o = Object.prototype.hasOwnProperty,
            i = Object.prototype.toString,
            a = n(1093),
            c = Object.prototype.propertyIsEnumerable,
            l = !c.call({
              toString: null
            }, "toString"),
            s = c.call(function () {}, "prototype"),
            p = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
            u = function (e) {
              var t = e.constructor;
              return t && t.prototype === e;
            },
            d = {
              $applicationCache: !0,
              $console: !0,
              $external: !0,
              $frame: !0,
              $frameElement: !0,
              $frames: !0,
              $innerHeight: !0,
              $innerWidth: !0,
              $onmozfullscreenchange: !0,
              $onmozfullscreenerror: !0,
              $outerHeight: !0,
              $outerWidth: !0,
              $pageXOffset: !0,
              $pageYOffset: !0,
              $parent: !0,
              $scrollLeft: !0,
              $scrollTop: !0,
              $scrollX: !0,
              $scrollY: !0,
              $self: !0,
              $webkitIndexedDB: !0,
              $webkitStorageInfo: !0,
              $window: !0
            },
            f = function () {
              if ("undefined" == typeof window) return !1;
              for (var e in window) try {
                if (!d["$" + e] && o.call(window, e) && null !== window[e] && "object" == typeof window[e]) try {
                  u(window[e]);
                } catch (e) {
                  return !0;
                }
              } catch (e) {
                return !0;
              }
              return !1;
            }();
          r = function (e) {
            var t = null !== e && "object" == typeof e,
              n = "[object Function]" === i.call(e),
              r = a(e),
              c = t && "[object String]" === i.call(e),
              d = [];
            if (!t && !n && !r) throw new TypeError("Object.keys called on a non-object");
            var E = s && n;
            if (c && e.length > 0 && !o.call(e, 0)) for (var _ = 0; _ < e.length; ++_) d.push(String(_));
            if (r && e.length > 0) for (var m = 0; m < e.length; ++m) d.push(String(m));else for (var v in e) E && "prototype" === v || !o.call(e, v) || d.push(String(v));
            if (l) for (var I = function (e) {
                if ("undefined" == typeof window || !f) return u(e);
                try {
                  return u(e);
                } catch (e) {
                  return !1;
                }
              }(e), y = 0; y < p.length; ++y) I && "constructor" === p[y] || !o.call(e, p[y]) || d.push(p[y]);
            return d;
          };
        }
        e.exports = r;
      },
      1189: (e, t, n) => {
        "use strict";

        var r = Array.prototype.slice,
          o = n(1093),
          i = Object.keys,
          a = i ? function (e) {
            return i(e);
          } : n(8875),
          c = Object.keys;
        a.shim = function () {
          if (Object.keys) {
            var e = function () {
              var e = Object.keys(arguments);
              return e && e.length === arguments.length;
            }(1, 2);
            e || (Object.keys = function (e) {
              return o(e) ? c(r.call(e)) : c(e);
            });
          } else Object.keys = a;
          return Object.keys || a;
        }, e.exports = a;
      },
      1093: e => {
        "use strict";

        var t = Object.prototype.toString;
        e.exports = function (e) {
          var n = t.call(e),
            r = "[object Arguments]" === n;
          return r || (r = "[object Array]" !== n && null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Function]" === t.call(e.callee)), r;
        };
      },
      8403: (e, t, n) => {
        "use strict";

        var r = n(1189),
          o = n(1333)(),
          i = n(8075),
          a = Object,
          c = i("Array.prototype.push"),
          l = i("Object.prototype.propertyIsEnumerable"),
          s = o ? Object.getOwnPropertySymbols : null;
        e.exports = function (e, t) {
          if (null == e) throw new TypeError("target must be an object");
          var n = a(e);
          if (1 === arguments.length) return n;
          for (var i = 1; i < arguments.length; ++i) {
            var p = a(arguments[i]),
              u = r(p),
              d = o && (Object.getOwnPropertySymbols || s);
            if (d) for (var f = d(p), E = 0; E < f.length; ++E) {
              var _ = f[E];
              l(p, _) && c(u, _);
            }
            for (var m = 0; m < u.length; ++m) {
              var v = u[m];
              if (l(p, v)) {
                var I = p[v];
                n[v] = I;
              }
            }
          }
          return n;
        };
      },
      1514: (e, t, n) => {
        "use strict";

        var r = n(8403);
        e.exports = function () {
          return Object.assign ? function () {
            if (!Object.assign) return !1;
            for (var e = "abcdefghijklmnopqrst", t = e.split(""), n = {}, r = 0; r < t.length; ++r) n[t[r]] = t[r];
            var o = Object.assign({}, n),
              i = "";
            for (var a in o) i += a;
            return e !== i;
          }() || function () {
            if (!Object.assign || !Object.preventExtensions) return !1;
            var e = Object.preventExtensions({
              1: 2
            });
            try {
              Object.assign(e, "xy");
            } catch (t) {
              return "y" === e[1];
            }
            return !1;
          }() ? r : Object.assign : r;
        };
      },
      5606: e => {
        var t,
          n,
          r = e.exports = {};
        function o() {
          throw new Error("setTimeout has not been defined");
        }
        function i() {
          throw new Error("clearTimeout has not been defined");
        }
        function a(e) {
          if (t === setTimeout) return setTimeout(e, 0);
          if ((t === o || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
          try {
            return t(e, 0);
          } catch (n) {
            try {
              return t.call(null, e, 0);
            } catch (n) {
              return t.call(this, e, 0);
            }
          }
        }
        !function () {
          try {
            t = "function" == typeof setTimeout ? setTimeout : o;
          } catch (e) {
            t = o;
          }
          try {
            n = "function" == typeof clearTimeout ? clearTimeout : i;
          } catch (e) {
            n = i;
          }
        }();
        var c,
          l = [],
          s = !1,
          p = -1;
        function u() {
          s && c && (s = !1, c.length ? l = c.concat(l) : p = -1, l.length && d());
        }
        function d() {
          if (!s) {
            var e = a(u);
            s = !0;
            for (var t = l.length; t;) {
              for (c = l, l = []; ++p < t;) c && c[p].run();
              p = -1, t = l.length;
            }
            c = null, s = !1, function (e) {
              if (n === clearTimeout) return clearTimeout(e);
              if ((n === i || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);
              try {
                return n(e);
              } catch (t) {
                try {
                  return n.call(null, e);
                } catch (t) {
                  return n.call(this, e);
                }
              }
            }(e);
          }
        }
        function f(e, t) {
          this.fun = e, this.array = t;
        }
        function E() {}
        r.nextTick = function (e) {
          var t = new Array(arguments.length - 1);
          if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          l.push(new f(e, t)), 1 !== l.length || s || a(d);
        }, f.prototype.run = function () {
          this.fun.apply(null, this.array);
        }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = E, r.addListener = E, r.once = E, r.off = E, r.removeListener = E, r.removeAllListeners = E, r.emit = E, r.prependListener = E, r.prependOnceListener = E, r.listeners = function (e) {
          return [];
        }, r.binding = function (e) {
          throw new Error("process.binding is not supported");
        }, r.cwd = function () {
          return "/";
        }, r.chdir = function (e) {
          throw new Error("process.chdir is not supported");
        }, r.umask = function () {
          return 0;
        };
      },
      1135: e => {
        e.exports = function (e) {
          return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
        };
      },
      9032: (e, t, n) => {
        "use strict";

        var r = n(7244),
          o = n(8184),
          i = n(5767),
          a = n(5680);
        function c(e) {
          return e.call.bind(e);
        }
        var l = "undefined" != typeof BigInt,
          s = "undefined" != typeof Symbol,
          p = c(Object.prototype.toString),
          u = c(Number.prototype.valueOf),
          d = c(String.prototype.valueOf),
          f = c(Boolean.prototype.valueOf);
        if (l) var E = c(BigInt.prototype.valueOf);
        if (s) var _ = c(Symbol.prototype.valueOf);
        function m(e, t) {
          if ("object" != typeof e) return !1;
          try {
            return t(e), !0;
          } catch (e) {
            return !1;
          }
        }
        function v(e) {
          return "[object Map]" === p(e);
        }
        function I(e) {
          return "[object Set]" === p(e);
        }
        function y(e) {
          return "[object WeakMap]" === p(e);
        }
        function O(e) {
          return "[object WeakSet]" === p(e);
        }
        function g(e) {
          return "[object ArrayBuffer]" === p(e);
        }
        function N(e) {
          return "undefined" != typeof ArrayBuffer && (g.working ? g(e) : e instanceof ArrayBuffer);
        }
        function L(e) {
          return "[object DataView]" === p(e);
        }
        function T(e) {
          return "undefined" != typeof DataView && (L.working ? L(e) : e instanceof DataView);
        }
        t.isArgumentsObject = r, t.isGeneratorFunction = o, t.isTypedArray = a, t.isPromise = function (e) {
          return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" == typeof e && "function" == typeof e.then && "function" == typeof e.catch;
        }, t.isArrayBufferView = function (e) {
          return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : a(e) || T(e);
        }, t.isUint8Array = function (e) {
          return "Uint8Array" === i(e);
        }, t.isUint8ClampedArray = function (e) {
          return "Uint8ClampedArray" === i(e);
        }, t.isUint16Array = function (e) {
          return "Uint16Array" === i(e);
        }, t.isUint32Array = function (e) {
          return "Uint32Array" === i(e);
        }, t.isInt8Array = function (e) {
          return "Int8Array" === i(e);
        }, t.isInt16Array = function (e) {
          return "Int16Array" === i(e);
        }, t.isInt32Array = function (e) {
          return "Int32Array" === i(e);
        }, t.isFloat32Array = function (e) {
          return "Float32Array" === i(e);
        }, t.isFloat64Array = function (e) {
          return "Float64Array" === i(e);
        }, t.isBigInt64Array = function (e) {
          return "BigInt64Array" === i(e);
        }, t.isBigUint64Array = function (e) {
          return "BigUint64Array" === i(e);
        }, v.working = "undefined" != typeof Map && v(new Map()), t.isMap = function (e) {
          return "undefined" != typeof Map && (v.working ? v(e) : e instanceof Map);
        }, I.working = "undefined" != typeof Set && I(new Set()), t.isSet = function (e) {
          return "undefined" != typeof Set && (I.working ? I(e) : e instanceof Set);
        }, y.working = "undefined" != typeof WeakMap && y(new WeakMap()), t.isWeakMap = function (e) {
          return "undefined" != typeof WeakMap && (y.working ? y(e) : e instanceof WeakMap);
        }, O.working = "undefined" != typeof WeakSet && O(new WeakSet()), t.isWeakSet = function (e) {
          return O(e);
        }, g.working = "undefined" != typeof ArrayBuffer && g(new ArrayBuffer()), t.isArrayBuffer = N, L.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && L(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = T;
        var h = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
        function b(e) {
          return "[object SharedArrayBuffer]" === p(e);
        }
        function A(e) {
          return void 0 !== h && (void 0 === b.working && (b.working = b(new h())), b.working ? b(e) : e instanceof h);
        }
        function w(e) {
          return m(e, u);
        }
        function R(e) {
          return m(e, d);
        }
        function S(e) {
          return m(e, f);
        }
        function D(e) {
          return l && m(e, E);
        }
        function x(e) {
          return s && m(e, _);
        }
        t.isSharedArrayBuffer = A, t.isAsyncFunction = function (e) {
          return "[object AsyncFunction]" === p(e);
        }, t.isMapIterator = function (e) {
          return "[object Map Iterator]" === p(e);
        }, t.isSetIterator = function (e) {
          return "[object Set Iterator]" === p(e);
        }, t.isGeneratorObject = function (e) {
          return "[object Generator]" === p(e);
        }, t.isWebAssemblyCompiledModule = function (e) {
          return "[object WebAssembly.Module]" === p(e);
        }, t.isNumberObject = w, t.isStringObject = R, t.isBooleanObject = S, t.isBigIntObject = D, t.isSymbolObject = x, t.isBoxedPrimitive = function (e) {
          return w(e) || R(e) || S(e) || D(e) || x(e);
        }, t.isAnyArrayBuffer = function (e) {
          return "undefined" != typeof Uint8Array && (N(e) || A(e));
        }, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function (e) {
          Object.defineProperty(t, e, {
            enumerable: !1,
            value: function () {
              throw new Error(e + " is not supported in userland");
            }
          });
        });
      },
      537: (e, t, n) => {
        var r = n(5606),
          o = n(6763),
          i = Object.getOwnPropertyDescriptors || function (e) {
            for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) n[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
            return n;
          },
          a = /%[sdj%]/g;
        t.format = function (e) {
          if (!O(e)) {
            for (var t = [], n = 0; n < arguments.length; n++) t.push(p(arguments[n]));
            return t.join(" ");
          }
          n = 1;
          for (var r = arguments, o = r.length, i = String(e).replace(a, function (e) {
              if ("%%" === e) return "%";
              if (n >= o) return e;
              switch (e) {
                case "%s":
                  return String(r[n++]);
                case "%d":
                  return Number(r[n++]);
                case "%j":
                  try {
                    return JSON.stringify(r[n++]);
                  } catch (e) {
                    return "[Circular]";
                  }
                default:
                  return e;
              }
            }), c = r[n]; n < o; c = r[++n]) I(c) || !L(c) ? i += " " + c : i += " " + p(c);
          return i;
        }, t.deprecate = function (e, n) {
          if (void 0 !== r && !0 === r.noDeprecation) return e;
          if (void 0 === r) return function () {
            return t.deprecate(e, n).apply(this, arguments);
          };
          var i = !1;
          return function () {
            if (!i) {
              if (r.throwDeprecation) throw new Error(n);
              r.traceDeprecation ? o.trace(n) : o.error(n), i = !0;
            }
            return e.apply(this, arguments);
          };
        };
        var c = {},
          l = /^$/;
        if ({
          IFRAME_SECURE_SITE: "v2.4.1/elements/index.html",
          IFRAME_SECURE_ORIGIN: "https://js.skyflow.com"
        }.NODE_DEBUG) {
          var s = {
            IFRAME_SECURE_SITE: "v2.4.1/elements/index.html",
            IFRAME_SECURE_ORIGIN: "https://js.skyflow.com"
          }.NODE_DEBUG;
          s = s.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), l = new RegExp("^" + s + "$", "i");
        }
        function p(e, n) {
          var r = {
            seen: [],
            stylize: d
          };
          return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), v(n) ? r.showHidden = n : n && t._extend(r, n), g(r.showHidden) && (r.showHidden = !1), g(r.depth) && (r.depth = 2), g(r.colors) && (r.colors = !1), g(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = u), f(r, e, r.depth);
        }
        function u(e, t) {
          var n = p.styles[t];
          return n ? "[" + p.colors[n][0] + "m" + e + "[" + p.colors[n][1] + "m" : e;
        }
        function d(e, t) {
          return e;
        }
        function f(e, n, r) {
          if (e.customInspect && n && b(n.inspect) && n.inspect !== t.inspect && (!n.constructor || n.constructor.prototype !== n)) {
            var o = n.inspect(r, e);
            return O(o) || (o = f(e, o, r)), o;
          }
          var i = function (e, t) {
            if (g(t)) return e.stylize("undefined", "undefined");
            if (O(t)) {
              var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return e.stylize(n, "string");
            }
            if (y(t)) return e.stylize("" + t, "number");
            if (v(t)) return e.stylize("" + t, "boolean");
            if (I(t)) return e.stylize("null", "null");
          }(e, n);
          if (i) return i;
          var a = Object.keys(n),
            c = function (e) {
              var t = {};
              return e.forEach(function (e, n) {
                t[e] = !0;
              }), t;
            }(a);
          if (e.showHidden && (a = Object.getOwnPropertyNames(n)), h(n) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return E(n);
          if (0 === a.length) {
            if (b(n)) {
              var l = n.name ? ": " + n.name : "";
              return e.stylize("[Function" + l + "]", "special");
            }
            if (N(n)) return e.stylize(RegExp.prototype.toString.call(n), "regexp");
            if (T(n)) return e.stylize(Date.prototype.toString.call(n), "date");
            if (h(n)) return E(n);
          }
          var s,
            p = "",
            u = !1,
            d = ["{", "}"];
          (m(n) && (u = !0, d = ["[", "]"]), b(n)) && (p = " [Function" + (n.name ? ": " + n.name : "") + "]");
          return N(n) && (p = " " + RegExp.prototype.toString.call(n)), T(n) && (p = " " + Date.prototype.toUTCString.call(n)), h(n) && (p = " " + E(n)), 0 !== a.length || u && 0 != n.length ? r < 0 ? N(n) ? e.stylize(RegExp.prototype.toString.call(n), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(n), s = u ? function (e, t, n, r, o) {
            for (var i = [], a = 0, c = t.length; a < c; ++a) S(t, String(a)) ? i.push(_(e, t, n, r, String(a), !0)) : i.push("");
            return o.forEach(function (o) {
              o.match(/^\d+$/) || i.push(_(e, t, n, r, o, !0));
            }), i;
          }(e, n, r, c, a) : a.map(function (t) {
            return _(e, n, r, c, t, u);
          }), e.seen.pop(), function (e, t, n) {
            var r = e.reduce(function (e, t) {
              return t.indexOf("\n") >= 0 && 0, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            if (r > 60) return n[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1];
            return n[0] + t + " " + e.join(", ") + " " + n[1];
          }(s, p, d)) : d[0] + p + d[1];
        }
        function E(e) {
          return "[" + Error.prototype.toString.call(e) + "]";
        }
        function _(e, t, n, r, o, i) {
          var a, c, l;
          if ((l = Object.getOwnPropertyDescriptor(t, o) || {
            value: t[o]
          }).get ? c = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (c = e.stylize("[Setter]", "special")), S(r, o) || (a = "[" + o + "]"), c || (e.seen.indexOf(l.value) < 0 ? (c = I(n) ? f(e, l.value, null) : f(e, l.value, n - 1)).indexOf("\n") > -1 && (c = i ? c.split("\n").map(function (e) {
            return "  " + e;
          }).join("\n").slice(2) : "\n" + c.split("\n").map(function (e) {
            return "   " + e;
          }).join("\n")) : c = e.stylize("[Circular]", "special")), g(a)) {
            if (i && o.match(/^\d+$/)) return c;
            (a = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.slice(1, -1), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
          }
          return a + ": " + c;
        }
        function m(e) {
          return Array.isArray(e);
        }
        function v(e) {
          return "boolean" == typeof e;
        }
        function I(e) {
          return null === e;
        }
        function y(e) {
          return "number" == typeof e;
        }
        function O(e) {
          return "string" == typeof e;
        }
        function g(e) {
          return void 0 === e;
        }
        function N(e) {
          return L(e) && "[object RegExp]" === A(e);
        }
        function L(e) {
          return "object" == typeof e && null !== e;
        }
        function T(e) {
          return L(e) && "[object Date]" === A(e);
        }
        function h(e) {
          return L(e) && ("[object Error]" === A(e) || e instanceof Error);
        }
        function b(e) {
          return "function" == typeof e;
        }
        function A(e) {
          return Object.prototype.toString.call(e);
        }
        function w(e) {
          return e < 10 ? "0" + e.toString(10) : e.toString(10);
        }
        t.debuglog = function (e) {
          if (e = e.toUpperCase(), !c[e]) if (l.test(e)) {
            var n = r.pid;
            c[e] = function () {
              var r = t.format.apply(t, arguments);
              o.error("%s %d: %s", e, n, r);
            };
          } else c[e] = function () {};
          return c[e];
        }, t.inspect = p, p.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39]
        }, p.styles = {
          special: "cyan",
          number: "yellow",
          boolean: "yellow",
          undefined: "grey",
          null: "bold",
          string: "green",
          date: "magenta",
          regexp: "red"
        }, t.types = n(9032), t.isArray = m, t.isBoolean = v, t.isNull = I, t.isNullOrUndefined = function (e) {
          return null == e;
        }, t.isNumber = y, t.isString = O, t.isSymbol = function (e) {
          return "symbol" == typeof e;
        }, t.isUndefined = g, t.isRegExp = N, t.types.isRegExp = N, t.isObject = L, t.isDate = T, t.types.isDate = T, t.isError = h, t.types.isNativeError = h, t.isFunction = b, t.isPrimitive = function (e) {
          return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
        }, t.isBuffer = n(1135);
        var R = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        function S(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
        t.log = function () {
          var e, n;
          o.log("%s - %s", (e = new Date(), n = [w(e.getHours()), w(e.getMinutes()), w(e.getSeconds())].join(":"), [e.getDate(), R[e.getMonth()], n].join(" ")), t.format.apply(t, arguments));
        }, t.inherits = n(6698), t._extend = function (e, t) {
          if (!t || !L(t)) return e;
          for (var n = Object.keys(t), r = n.length; r--;) e[n[r]] = t[n[r]];
          return e;
        };
        var D = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
        function x(e, t) {
          if (!e) {
            var n = new Error("Promise was rejected with a falsy value");
            n.reason = e, e = n;
          }
          return t(e);
        }
        t.promisify = function (e) {
          if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
          if (D && e[D]) {
            var t;
            if ("function" != typeof (t = e[D])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(t, D, {
              value: t,
              enumerable: !1,
              writable: !1,
              configurable: !0
            }), t;
          }
          function t() {
            for (var t, n, r = new Promise(function (e, r) {
                t = e, n = r;
              }), o = [], i = 0; i < arguments.length; i++) o.push(arguments[i]);
            o.push(function (e, r) {
              e ? n(e) : t(r);
            });
            try {
              e.apply(this, o);
            } catch (e) {
              n(e);
            }
            return r;
          }
          return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), D && Object.defineProperty(t, D, {
            value: t,
            enumerable: !1,
            writable: !1,
            configurable: !0
          }), Object.defineProperties(t, i(e));
        }, t.promisify.custom = D, t.callbackify = function (e) {
          if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
          function t() {
            for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n]);
            var o = t.pop();
            if ("function" != typeof o) throw new TypeError("The last argument must be of type Function");
            var i = this,
              a = function () {
                return o.apply(i, arguments);
              };
            e.apply(this, t).then(function (e) {
              r.nextTick(a.bind(null, null, e));
            }, function (e) {
              r.nextTick(x.bind(null, e, a));
            });
          }
          return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, i(e)), t;
        };
      },
      5767: (e, t, n) => {
        "use strict";

        var r = n(2682),
          o = n(9209),
          i = n(487),
          a = n(8075),
          c = n(5795),
          l = a("Object.prototype.toString"),
          s = n(9092)(),
          p = "undefined" == typeof globalThis ? n.g : globalThis,
          u = o(),
          d = a("String.prototype.slice"),
          f = Object.getPrototypeOf,
          E = a("Array.prototype.indexOf", !0) || function (e, t) {
            for (var n = 0; n < e.length; n += 1) if (e[n] === t) return n;
            return -1;
          },
          _ = {
            __proto__: null
          };
        r(u, s && c && f ? function (e) {
          var t = new p[e]();
          if (Symbol.toStringTag in t) {
            var n = f(t),
              r = c(n, Symbol.toStringTag);
            if (!r) {
              var o = f(n);
              r = c(o, Symbol.toStringTag);
            }
            _["$" + e] = i(r.get);
          }
        } : function (e) {
          var t = new p[e]();
          _["$" + e] = i(t.slice);
        });
        e.exports = function (e) {
          if (!e || "object" != typeof e) return !1;
          if (!s) {
            var t = d(l(e), 8, -1);
            return E(u, t) > -1 ? t : "Object" === t && function (e) {
              var t = !1;
              return r(_, function (n, r) {
                if (!t) try {
                  n(e), t = d(r, 1);
                } catch (e) {}
              }), t;
            }(e);
          }
          return c ? function (e) {
            var t = !1;
            return r(_, function (n, r) {
              if (!t) try {
                "$" + n(e) === r && (t = d(r, 1));
              } catch (e) {}
            }), t;
          }(e) : null;
        };
      },
      4633: (e, t, n) => {
        var r = n(3738).default;
        function o() {
          "use strict";

          e.exports = o = function () {
            return n;
          }, e.exports.__esModule = !0, e.exports.default = e.exports;
          var t,
            n = {},
            i = Object.prototype,
            a = i.hasOwnProperty,
            c = Object.defineProperty || function (e, t, n) {
              e[t] = n.value;
            },
            l = "function" == typeof Symbol ? Symbol : {},
            s = l.iterator || "@@iterator",
            p = l.asyncIterator || "@@asyncIterator",
            u = l.toStringTag || "@@toStringTag";
          function d(e, t, n) {
            return Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), e[t];
          }
          try {
            d({}, "");
          } catch (t) {
            d = function (e, t, n) {
              return e[t] = n;
            };
          }
          function f(e, t, n, r) {
            var o = t && t.prototype instanceof O ? t : O,
              i = Object.create(o.prototype),
              a = new M(r || []);
            return c(i, "_invoke", {
              value: R(e, n, a)
            }), i;
          }
          function E(e, t, n) {
            try {
              return {
                type: "normal",
                arg: e.call(t, n)
              };
            } catch (e) {
              return {
                type: "throw",
                arg: e
              };
            }
          }
          n.wrap = f;
          var _ = "suspendedStart",
            m = "suspendedYield",
            v = "executing",
            I = "completed",
            y = {};
          function O() {}
          function g() {}
          function N() {}
          var L = {};
          d(L, s, function () {
            return this;
          });
          var T = Object.getPrototypeOf,
            h = T && T(T(P([])));
          h && h !== i && a.call(h, s) && (L = h);
          var b = N.prototype = O.prototype = Object.create(L);
          function A(e) {
            ["next", "throw", "return"].forEach(function (t) {
              d(e, t, function (e) {
                return this._invoke(t, e);
              });
            });
          }
          function w(e, t) {
            function n(o, i, c, l) {
              var s = E(e[o], e, i);
              if ("throw" !== s.type) {
                var p = s.arg,
                  u = p.value;
                return u && "object" == r(u) && a.call(u, "__await") ? t.resolve(u.__await).then(function (e) {
                  n("next", e, c, l);
                }, function (e) {
                  n("throw", e, c, l);
                }) : t.resolve(u).then(function (e) {
                  p.value = e, c(p);
                }, function (e) {
                  return n("throw", e, c, l);
                });
              }
              l(s.arg);
            }
            var o;
            c(this, "_invoke", {
              value: function (e, r) {
                function i() {
                  return new t(function (t, o) {
                    n(e, r, t, o);
                  });
                }
                return o = o ? o.then(i, i) : i();
              }
            });
          }
          function R(e, n, r) {
            var o = _;
            return function (i, a) {
              if (o === v) throw new Error("Generator is already running");
              if (o === I) {
                if ("throw" === i) throw a;
                return {
                  value: t,
                  done: !0
                };
              }
              for (r.method = i, r.arg = a;;) {
                var c = r.delegate;
                if (c) {
                  var l = S(c, r);
                  if (l) {
                    if (l === y) continue;
                    return l;
                  }
                }
                if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if (o === _) throw o = I, r.arg;
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                o = v;
                var s = E(e, n, r);
                if ("normal" === s.type) {
                  if (o = r.done ? I : m, s.arg === y) continue;
                  return {
                    value: s.arg,
                    done: r.done
                  };
                }
                "throw" === s.type && (o = I, r.method = "throw", r.arg = s.arg);
              }
            };
          }
          function S(e, n) {
            var r = n.method,
              o = e.iterator[r];
            if (o === t) return n.delegate = null, "throw" === r && e.iterator.return && (n.method = "return", n.arg = t, S(e, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), y;
            var i = E(o, e.iterator, n.arg);
            if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
            var a = i.arg;
            return a ? a.done ? (n[e.resultName] = a.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, y) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
          }
          function D(e) {
            var t = {
              tryLoc: e[0]
            };
            1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
          }
          function x(e) {
            var t = e.completion || {};
            t.type = "normal", delete t.arg, e.completion = t;
          }
          function M(e) {
            this.tryEntries = [{
              tryLoc: "root"
            }], e.forEach(D, this), this.reset(!0);
          }
          function P(e) {
            if (e || "" === e) {
              var n = e[s];
              if (n) return n.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function n() {
                    for (; ++o < e.length;) if (a.call(e, o)) return n.value = e[o], n.done = !1, n;
                    return n.value = t, n.done = !0, n;
                  };
                return i.next = i;
              }
            }
            throw new TypeError(r(e) + " is not iterable");
          }
          return g.prototype = N, c(b, "constructor", {
            value: N,
            configurable: !0
          }), c(N, "constructor", {
            value: g,
            configurable: !0
          }), g.displayName = d(N, u, "GeneratorFunction"), n.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
          }, n.mark = function (e) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(e, N) : (e.__proto__ = N, d(e, u, "GeneratorFunction")), e.prototype = Object.create(b), e;
          }, n.awrap = function (e) {
            return {
              __await: e
            };
          }, A(w.prototype), d(w.prototype, p, function () {
            return this;
          }), n.AsyncIterator = w, n.async = function (e, t, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new w(f(e, t, r, o), i);
            return n.isGeneratorFunction(t) ? a : a.next().then(function (e) {
              return e.done ? e.value : a.next();
            });
          }, A(b), d(b, u, "Generator"), d(b, s, function () {
            return this;
          }), d(b, "toString", function () {
            return "[object Generator]";
          }), n.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var r in t) n.push(r);
            return n.reverse(), function e() {
              for (; n.length;) {
                var r = n.pop();
                if (r in t) return e.value = r, e.done = !1, e;
              }
              return e.done = !0, e;
            };
          }, n.values = P, M.prototype = {
            constructor: M,
            reset: function (e) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(x), !e) for (var n in this) "t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function r(r, o) {
                return c.type = "throw", c.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
              }
              for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                var i = this.tryEntries[o],
                  c = i.completion;
                if ("root" === i.tryLoc) return r("end");
                if (i.tryLoc <= this.prev) {
                  var l = a.call(i, "catchLoc"),
                    s = a.call(i, "finallyLoc");
                  if (l && s) {
                    if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                  } else if (l) {
                    if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  } else {
                    if (!s) throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];
                if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var o = r;
                  break;
                }
              }
              o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
              var i = o ? o.completion : {};
              return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(i);
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), x(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    x(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return this.delegate = {
                iterator: P(e),
                resultName: n,
                nextLoc: r
              }, "next" === this.method && (this.arg = t), y;
            }
          }, n;
        }
        e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      3738: e => {
        function t(n) {
          return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
        }
        e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      4756: (e, t, n) => {
        var r = n(4633)();
        e.exports = r;
        try {
          regeneratorRuntime = r;
        } catch (e) {
          "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
        }
      },
      9209: (e, t, n) => {
        "use strict";

        var r = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"],
          o = "undefined" == typeof globalThis ? n.g : globalThis;
        e.exports = function () {
          for (var e = [], t = 0; t < r.length; t++) "function" == typeof o[r[t]] && (e[e.length] = r[t]);
          return e;
        };
      }
    },
    t = {};
  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var i = t[r] = {
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, n), i.exports;
  }
  n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t;
  }, n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.p = "";
  var r = {};
  return (() => {
    "use strict";

    n.r(r), n.d(r, {
      CardMetadata: () => e.CardMetadata,
      CardType: () => xe,
      CollectContainer: () => Lo,
      CollectElement: () => Cr,
      CollectElementInput: () => e.CollectElementInput,
      CollectElementOptions: () => e.CollectElementOptions,
      CollectElementUpdateOptions: () => e.CollectElementUpdateOptions,
      CollectOptions: () => e.ICollectOptions,
      CollectResponse: () => e.CollectResponse,
      ComposableContainer: () => fi,
      ComposableElement: () => Gr,
      ContainerOptions: () => e.ContainerOptions,
      ContainerType: () => hi,
      DeleteOptions: () => e.IDeleteOptions,
      DeleteRecord: () => e.IDeleteRecord,
      DeleteRequest: () => e.IDeleteRecordInput,
      DeleteResponse: () => e.DeleteResponse,
      DetokenizeRecord: () => e.DetokenizeRecord,
      DetokenizeRequest: () => e.IDetokenizeInput,
      DetokenizeResponse: () => e.DetokenizeResponse,
      ElementState: () => e.ElementState,
      ElementType: () => De,
      Env: () => ct,
      ErrorTextStyles: () => e.ErrorTextStyles,
      EventName: () => it,
      GetByIdRequest: () => e.IGetByIdInput,
      GetByIdResponse: () => e.GetByIdResponse,
      GetOptions: () => e.IGetOptions,
      GetRecord: () => e.IGetRecord,
      GetRequest: () => e.IGetInput,
      GetResponse: () => e.GetResponse,
      InputStyles: () => e.InputStyles,
      InsertOptions: () => e.IInsertOptions,
      InsertRecord: () => e.IInsertRecord,
      InsertRequest: () => e.IInsertRecordInput,
      InsertResponse: () => e.InsertResponse,
      LabelStyles: () => e.LabelStyles,
      LogLevel: () => at,
      RedactionType: () => rt,
      RenderFileResponse: () => e.RenderFileResponse,
      RevealContainer: () => rr,
      RevealElement: () => Cn,
      RevealElementInput: () => t.IRevealElementInput,
      RevealElementOptions: () => t.IRevealElementOptions,
      RevealRecord: () => e.IRevealRecord,
      RevealResponse: () => e.RevealResponse,
      SkyflowConfig: () => i.ISkyflow,
      ThreeDS: () => gi,
      ThreeDSBrowserDetails: () => o.ThreeDSBrowserDetails,
      UploadFilesResponse: () => e.UploadFilesResponse,
      ValidationRule: () => e.IValidationRule,
      ValidationRuleType: () => st,
      default: () => ji
    });
    var e = {};
    n.r(e), n.d(e, {
      o9: () => ct,
      Ur: () => it,
      $b: () => at,
      Go: () => lt,
      eb: () => rt,
      dF: () => ot,
      UL: () => st
    });
    var t = {};
    n.r(t), n.d(t, {
      A: () => rr
    });
    var o = {};
    n.r(o), n.d(o, {
      A: () => gi
    });
    var i = {};
    function a(e) {
      return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, a(e);
    }
    function c(e) {
      var t = function (e, t) {
        if ("object" !== a(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, t || "default");
          if ("object" !== a(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" === a(t) ? t : String(t);
    }
    function l(e, t, n) {
      return (t = c(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function s(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function p(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, c(r.key), r);
      }
    }
    function u(e, t, n) {
      return t && p(e.prototype, t), n && p(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function d(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
      return t.get(e);
    }
    function f(e, t, n) {
      return function (e, t, n) {
        if (t.set) t.set.call(e, n);else {
          if (!t.writable) throw new TypeError("attempted to set read only private field");
          t.value = n;
        }
      }(e, d(e, t, "set"), n), n;
    }
    function E(e, t) {
      return function (e, t) {
        return t.get ? t.get.call(e) : t.value;
      }(e, d(e, t, "get"));
    }
    n.r(i), n.d(i, {
      K: () => hi,
      A: () => Vi
    });
    var _ = n(2281),
      m = n.n(_);
    function v() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = crypto.getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32) * 16 | 0;
        return ("x" === e ? t : 3 & t | 8).toString(16);
      });
    }
    const I = n.p + "2afb5d11fb02e9292eaf.svg",
      y = n.p + "5408d9cd30b616684aa0.svg",
      O = n.p + "a9431336dd9f3e17b880.svg",
      g = n.p + "9b996d698afd3d404564.svg",
      N = n.p + "404966085770d8ec21ca.svg",
      L = n.p + "8062a86943450f142966.svg",
      T = n.p + "407dfd9c3fd800945b74.svg",
      h = n.p + "08ad88dee7d4519954ec.svg",
      b = n.p + "d418de915d45f039ac22.svg",
      A = n.p + "cbee67fb3d652dad9e25.svg",
      w = (n.p, n.p, n.p, n.p + "bcd5969a8a86792c2995.svg");
    const R = {
      infoLogs: {
        INITIALIZE_CLIENT: "%s1 - Initializing skyflow client.",
        CLIENT_INITIALIZED: "%s1 - Initialized skyflow client successfully.",
        CREATE_COLLECT_CONTAINER: "%s1 - Creating Collect container.",
        COLLECT_CONTAINER_CREATED: "%s1 - Created Collect container successfully.",
        CREATE_REVEAL_CONTAINER: "%s1 - Creating Reveal container.",
        REVEAL_CONTAINER_CREATED: "%s1 - Created Reveal container successfully.",
        VALIDATE_RECORDS: "%s1 - Validating insert records.",
        VALIDATE_DETOKENIZE_INPUT: "%s1 - Validating detokenize input.",
        VALIDATE_GET_INPUT: "%s1 - Validating get input.",
        VALIDATE_DELETE_INPUT: "%s1 - Validating delete input.",
        VALIDATE_COLLECT_RECORDS: "%s1 - Validating collect element input.",
        VALIDATE_REVEAL_RECORDS: "%s1 - Validating reveal element input.",
        VALIDATE_RENDER_RECORDS: "%s1 - Validating file render element input.",
        CREATED_ELEMENT: "%s1 - Created %s2 element.",
        ELEMENT_MOUNTED: "%s1 - %s2 Element mounted.",
        ELEMENT_REVEALED: "%s1 - %s2 Element revealed.",
        FILE_RENDERED: "%s1 - %s2 File rendered.",
        COLLECT_SUBMIT_SUCCESS: "%s1 - Data has been collected successfully.",
        REVEAL_SUBMIT_SUCCESS: "%s1 - Data has been revealed successfully.",
        RENDER_SUBMIT_SUCCESS: "%s1 - File download URL has been fetched successfully.",
        INSERT_DATA_SUCCESS: "%s1 - Data has been inserted successfully.",
        DETOKENIZE_SUCCESS: "%s1 - Data has been revealed successfully.",
        GET_SUCCESS: "%s1 - Data has been revealed successfully.",
        DELETE_SUCCESS: "%s1 - Data has been deleted successfully.",
        BEARER_TOKEN_LISTENER: "%s1 - Get bearer token listener added.",
        CAPTURED_BEARER_TOKEN_EVENT: "%s1 - Captured bearer token event.",
        BEARER_TOKEN_RESOLVED: "%s1 - GetBearerToken promise resolved successfully.",
        REUSE_BEARER_TOKEN: "%s1 - Reusing the bearer token.",
        PUREJS_CONTROLLER_INITIALIZED: "%s1 - SkyflowController initialized.",
        PUREJS_LISTENER_READY: "%s1 - Purejs listener ready.",
        EMIT_PURE_JS_CONTROLLER: "%s1 - Emitted Skyflow controller event.",
        INSERT_TRIGGERED: "%s1 - Insert method triggered.",
        DETOKENIZE_TRIGGERED: "%s1 - Detokenize method triggered.",
        GET_TRIGGERED: "%s1 - Get method triggered.",
        GET_BY_ID_TRIGGERED: "%s1 - Get method triggered.",
        DELETE_TRIGGERED: "%s1 - Delete method triggered.",
        EMIT_PURE_JS_REQUEST: "%s1 - Emitted %s2 request.",
        CAPTURE_PURE_JS_REQUEST: "%s1 - Captured %s2 event.",
        LISTEN_PURE_JS_REQUEST: "%s1 - Listening to %s2 event.",
        CAPTURE_PUREJS_FRAME: "%s1 - Captured SkyflowController frame ready event.",
        FETCH_RECORDS_RESOLVED: "%s1 - Detokenize request is resolved.",
        INSERT_RECORDS_RESOLVED: "%s1 - Insert request is resolved.",
        GET_RESOLVED: "%s1 - Get request is resolved.",
        GET_BY_SKYFLOWID_RESOLVED: "%s1 - GetById request is resolved.",
        DELETE_RESOLVED: "%s1 - Delete request is resolved",
        EMIT_EVENT: "%s1 - %s2 event emitted",
        CAPTURE_EVENT: "%s1 - Captured event %s2",
        METRIC_CAPTURE_EVENT: "Metric event captured Successfully",
        UNKNOWN_METRIC_CAPTURE_EVENT: "Metric event capturing Failed with %s1",
        UNKNOWN_RESPONSE_FROM_METRIC_EVENT: "Metric event Captured with Unknown Response",
        LISTEN_COLLECT_FRAME_READY: "%s1 - Listening to collect FRAME_READY event",
        EMIT_COLLECT_ELEMENT_FRAME_READY: "%s1 - Emitting collect element %s2 FRAME_READY event",
        ENTERED_COLLECT_FRAME_READY_CB: "%s1 - In IFrameForm constructor, Entered FRAME_READY callback",
        EXECUTE_COLLECT_ELEMENT_FRAME_READY_CB: "%s1 - In IFrameForm, executing collect element, %s2 FRAME_READY callback",
        CLIENT_METADATA_NOT_SET: "%s1 - Client metadata not set",
        EXECUTE_COLLECT_ELEMENT_INIT: "%s1 - calling Collect element init",
        INSIDE__COLLECT_ELEMENT_INIT: "%s1 - Inside Collect element init for %s2",
        CREATING_COLLECT_ELEMENT_FORM: "%s1 - Start, creating iframe form for %s2",
        COLLECT_FRAME_READY_CB: "%s1 - In FrameElements, executing collect element FRAME_READY cb for %s2, sending metadata",
        INSIDE_FRAME_ELEMENTS_CONSTRUCOTR: "%s1 - Inside FrameElements constructor",
        SETUP_IN_START: "%s1 - Inside FrameElements start(), calling setup",
        SETUP_IN_CONSTRUCTOR: "%s1 - Inside FrameElements constructor, calling setup",
        COLLECT_ELEMET_START: "%s1 - %s2, Collect Element start",
        COLLECT_CONTROLLER_START: "%s1 - %s2, Collect Controller start",
        REVEAL_ELEMENT_START: "%s1 - %s2, Reveal Element start",
        EMIT_COLLECT_FRAME_CONTROLLER_EVENT: "%s1 - Emit collect FrameController FRAME_READY event",
        EXECUTE_COLLECT_CONTROLLER_READY_CB: "%s1 - Executing collect FrameController FRAME_READY callback, set client metadata",
        IFRAMEFORM_CONSTRUCTOR_FRAME_READY_LISTNER: "%s1 - In IFrameForm constructor, Adding listener for FRAME_READY event",
        IFRAMEFORM_CONSTRUCTOR_TOKENIZATION_LISTNER: "%s1 - In IFrameForm constructor, Adding listener for TOKENIZATION_REQUEST event",
        CURRENT_ENV: "%s1 - Client Env is %s2",
        CURRENT_LOG_LEVEL: "%s1 - Client LogLevel is %s2",
        VALIDATE_GET_BY_ID_INPUT: "%s1 - Validating getByID input."
      },
      errorLogs: {
        NO_ELEMENTS_IN_COLLECT: "Validation error. No elements found in collect container",
        NO_ELEMENTS_IN_COMPOSABLE: "Validation error. No elements found in composable container",
        NO_ELEMENTS_IN_REVEAL: "Validation error. No elements found in reveal container",
        INVALID_FILE_NAMES: "Invalid File Name. Only alphanumeric characters and !-_.*() are allowed.",
        INVALID_FILE_NAME: "Invalid File Name. Only alphanumeric characters and !-_.*() are allowed.",
        CLIENT_CONNECTION: "client connection not established. client info has not reached iframes",
        INVALID_BEARER_TOKEN: "Token generated from 'getBearerToken' callback function is invalid. Make sure the implementation of 'getBearerToken' is correct.",
        BEARER_TOKEN_REJECTED: "'getBearerToken' callback function call failed with rejected promise. Make sure the implementation of 'getBearerToken' is correct.",
        VAULTID_IS_REQUIRED: "Initialization failed. Invalid credentials. Specify a valid 'vaultID'.",
        EMPTY_VAULTID_IN_INIT: "Initialization failed. Invalid credentials. Specify a valid 'vaultID'.",
        VAULTURL_IS_REQUIRED: "Initialization failed. Invalid credentials. Specify a valid 'vaultURL'",
        EMPTY_VAULTURL_IN_INIT: "Initialization failed. Invalid credentials. Specify a valid 'vaultURL'",
        INVALID_VAULTURL_IN_INIT: "Initialization failed. Invalid client credentials. 'vaultURL' must be begin with 'https://.'",
        GET_BEARER_TOKEN_IS_REQUIRED: "Initialization failed. Invalid client credentials. Specify a valid bearer token.",
        EMPTY_CONTAINER_TYPE: "Container creation failed. 'containerType' is invalid. Specify a valid container type.",
        INVALID_CONTAINER_TYPE: "Container creation failed. '%s1' is invalid. Specify a valid container type.",
        INVALID_COLLECT_VALUE: "Invalid value",
        INVALID_COLLECT_VALUE_WITH_LABEL: "Invalid %s1",
        REQUIRED_COLLECT_VALUE: "%s1 is required",
        DEFAULT_REQUIRED_COLLECT_VALUE: "Field is required",
        RECORDS_KEY_NOT_FOUND: "Validation error. Invalid 'records' key found. Specify a value of type array instead.",
        INVALID_RECORDS_IN_INSERT: "Validation error. Invalid records. Specify a value of type array instead.",
        EMPTY_RECORDS_IN_INSERT: "Validation error. 'records' key cannot be empty. Provide a non-empty value instead.",
        MISSING_TABLE_IN_INSERT: "Validation error. Missing 'table' key in records at index %s1. Provide a valid 'table' key.",
        EMPTY_TABLE_IN_INSERT: "Validation error. 'table' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        INVALID_TABLE_IN_INSERT: "Validation error. Invalid 'table' key in records at index %s1. Specify a value of type string instead.",
        EMPTY_FIELDS_IN_INSERT: "Validation error. Missing 'fields' key in records at index %s1. Provide a valid 'fields' key.",
        MISSING_FIELDS_IN_INSERT: "Validation error. 'fields' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        INVALID_FIELDS_IN_INSERT: "Validation error. Invalid 'fields' key in records at index %s1. Specify a value of type object instead.",
        INVALID_TOKENS_IN_INSERT: "Validation error.Invalid 'tokens' key in insert options. Specify a boolean value for tokens.",
        RECORDS_KEY_NOT_FOUND_DELETE: "Validation error. Missing 'records' key. Provide a valid 'records' key.",
        INVALID_RECORDS_IN_DELETE: "Validation error. Invalid 'records' key found. Specify a value of type array instead.",
        EMPTY_RECORDS_IN_DELETE: "Validation error. 'records' key cannot be empty. Provide a non-empty value instead.",
        MISSING_TABLE_IN_DELETE: "Validation error. Missing 'table' key in records at index %s1. Provide a valid 'table' key.",
        EMPTY_TABLE_IN_DELETE: "Validation error. 'table' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        INVALID_TABLE_IN_DELETE: "Validation error. Invalid 'table' key in records at index %s1. Specify a value of type string instead.",
        MISSING_ID_IN_DELETE: "Validation error. Missing 'id' key in records at index %s1. Provide a valid 'id' key.",
        EMPTY_ID_IN_DELETE: "Validation error. 'id' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        INVALID_ID_IN_DELETE: "Validation error. Invalid 'id' key in records at index %s1. Specify a value of type string instead.",
        DELETE_RECORDS_REJECTED: "Delete failed. Delete request is rejected.",
        INVALID_TOKENS_IN_COLLECT: "Validation error. Invalid tokens. Specify a boolean value for tokens.",
        RECORDS_KEY_NOT_FOUND_IN_ADDITIONAL_FIELDS: "Validation error.records key not found in additionalFields. Specify a records key in addtionalFields.",
        INVALID_RECORDS_IN_ADDITIONAL_FIELDS: "Validation error.'records' must be an array within additionalFields.",
        EMPTY_RECORDS_IN_ADDITIONAL_FIELDS: "Validation error. 'records' object cannot be empty within additionalFields. Specify a non-empty value instead.",
        MISSING_TABLE_IN_ADDITIONAL_FIELDS: "Validation error. 'table' key not found in additionalFields record at index %s1",
        INVALID_TABLE_IN_ADDITIONAL_FIELDS: "Validation error.Invalid table key value in additionalFields record at index %s1. Specify a value of type string for table key.",
        INVALID_SKYFLOW_ID_IN_ADDITIONAL_FIELDS: "Validation error.Invalid 'skyflow_id' key value in additionalFields record at index %s1. Specify a valid value for 'skyflow_id' key.",
        MISSING_FIELDS_IN_ADDITIONAL_FIELDS: "Validation error.'fields' key not found in additionalFields record at index %s1. Specify a 'fields' key in additionalFields record at index %s1.",
        INVALID_FIELDS_IN_ADDITIONAL_FIELDS: "Validation error.invaid 'fields' key value in additionalFields record at index %s1. Specify a value of type array for 'fields' key.",
        RECORDS_KEY_NOT_FOUND_DETOKENIZE: "Delete failed. Delete request is rejected.",
        EMPTY_RECORDS_DETOKENIZE: "Validation error. Invalid 'records' key found. Specify a value of type array instead.",
        INVALID_RECORDS_IN_DETOKENIZE: "Validation error. 'records' key cannot be empty. Provide a non-empty value instead.",
        MISSING_TOKEN_IN_DETOKENIZE: "Validation error. Missing 'token' key in records at index %s1. Provide a valid 'token' key.",
        INVALID_TOKEN_IN_DETOKENIZE: "Validation error. Invalid 'token' key in records at index %s1. Specify a value of type string instead.",
        RECORDS_KEY_NOT_FOUND_GET: "Validation error. Missing 'records' key. Provide a valid 'records' key.",
        INVALID_RECORDS_IN_GET: "Validation error. Invalid 'records' key found. Specify a value of type array instead.",
        EMPTY_RECORDS_GET: "Validation error. 'records' key cannot be empty. Provide a non-empty value instead.",
        MISSING_IDS_IN_GET: "Validation error. Missing 'ids' key in records at index %s1. Provide a valid 'ids' key.",
        INVALID_IDS_IN_GET: "Validation error. Invalid 'ids' key found. Specify a value of type array instead.",
        INVALID_COLUMN_VALUES_IN_GET: "Validation error. Invalid 'columnValues' key found. Specify a value of type array instead.",
        EMPTY_IDS_IN_GET: "Validation error. 'ids' key cannot be an array of empty strings in records at index %s1. Specify non-empty values instead.",
        INVALID_SKYFLOWID_TYPE_IN_GET: "Validation error. Invalid 'id' found in 'ids' array in 'records' at index %s1 . Specify a value of type string instead.",
        MISSING_TABLE_IN_GET: "Validation error. Missing 'table' key in records at index %s1. Provide a valid 'table' key.",
        INVALID_TABLE_IN_GET: "Validation error. Invalid 'table' key in records at index %s1. Specify a value of type string instead.",
        MISSING_REDACTION_IN_GET: "Validation error. Missing 'redaction' key in records at index %s1. Provide a valid 'redaction' key.",
        INVALID_REDACTION_TYPE_IN_GET: "Validation error. Invalid 'redaction' key in records at index %s1. Specify a valid redaction type.",
        INVALID_TOKENS_IN_GET: "Validation error. Invalid tokens in get options. Specify a boolean value for tokens.",
        TOKENS_GET_COLUMN_NOT_SUPPORTED: "Validation error. 'columnName' and 'columnValues' cannot be used when 'tokens' are set to true in get options. Either set 'tokens' to false or use 'ids' instead.",
        REDACTION_WITH_TOKENS_NOT_SUPPORTED: "Get failed. Redaction cannot be applied when 'tokens' are set to true in get options. Either remove redaction or set 'tokens' to false.",
        INVALID_REDACTION_TYPE_IN_DETOKENIZE: "Validation error. Invalid 'redaction' key in records at index %s1. Specify a valid redaction type.",
        EMPTY_RECORDS_REVEAL: "Validation error. 'records' key cannot be empty. Provide a non-empty value instead.",
        MISSING_TOKEN_KEY_REVEAL: "Validation error. Missing 'token' key for reveal element. Specify a valid value for token.",
        MISSING_SKYFLOWID_KEY_REVEAL: "Validation error. Missing 'skyflowID' key for file render element. Provide a valid 'skyflowID' key.",
        MISSING_TABLE_KEY_REVEAL: "Validation error.'table' key not found for file render element. Specify a valid value for 'table' key.",
        MISSING_COLUMN_KEY_REVEAL: "Validation error.'column' key not found for file render element. Specify a valid value for 'column' key.",
        INVALID_SKYFLOW_ID_REVEAL: "Validation error. Invalid 'skyflowID' key for file render element. Specify a value of type string instead.",
        INVALID_TABLE_REVEAL: "Validation error. Invalid 'table' key for file render element. Specify a value of type string instead.",
        INVALID_COLUMN_NAME_REVEAL: "Validation error. Invalid 'column' key for file render element. Specify a value of type string instead.",
        EMPTY_SKYFLOW_ID_REVEAL: "Validation error. 'skyflowID' key cannot be empty for file render element. Specify a non-empty value instead.",
        EMPTY_TABLE_REVEAL: "Validation error. 'table' key cannot be empty for file render element. Specify a non-empty value instead.",
        EMPTY_COLUMN_NAME_REVEAL: "Validation error. 'column' key cannot be empty for file render element. Specify a non-empty value instead.",
        INVALID_TOKEN_ID_REVEAL: "Validation error. Invalid 'token' key found for reveal element. Specify a value of type string instead.",
        INVALID_LABEL_REVEAL: "Validation error. Invalid 'label' key found for reveal element. Specify a value of type string instead.",
        INVALID_ALT_TEXT_REVEAL: "Validation error. Invalid 'altText' key found for reveal element. Specify a value of type string instead.",
        INVALID_ALT_TEXT_RENDER: "Validation error. Invalid 'altText' key found for reveal element. Specify a value of type string instead.",
        INVALID_FORMAT_REVEAL: "Validation error. Invalid 'format' key found for reveal element. Specify a value of type string instead.",
        EMPTY_FORMAT_REVEAL: "Validation error. 'format' key cannot be empty for reveal element. Specify a non-empty value instead.",
        INVALID_FORMAT_VALUE_REVEAL: "Validation error. Invalid 'format' key found for reveal element. Specify a value of type string instead.",
        INVALID_REDACTION_TYPE_REVEAL: "Validation error. Invalid 'redaction' key found for reveal element. Specify a valid redaction type.",
        ELEMENTS_NOT_MOUNTED_REVEAL: "Reveal failed. Make sure to mount all elements before invoking 'reveal' function.",
        EMPTY_TABLE_IN_ADDITIONAL_FIELDS: "Validation error.'table' field cannot be empty in additionalFields record at index %s1. Specify a non-empty value instead.",
        EMPTY_FIELDS_IN_ADDITIONAL_FIELDS: "Validation error.'fields' object cannot be empty in additionalFields record at index %s1. Specify a non-empty value instead.",
        EMPTY_TOKEN_IN_DETOKENIZE: "Validation error. 'token' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        EMPTY_SKYFLOWID_IN_GET: "Validation error. 'id' cannot be empty in 'ids' array in 'records' at index %s1. Specify non-empty values instead.",
        EMPTY_TABLE_IN_GET: "Validation error. 'table' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        EMPTY_REDACTION_TYPE_IN_GET: "Validation error. 'redaction' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        EMPTY_TOKEN_ID_REVEAL: "Validation error. 'token' key cannot be empty for reveal element. Specify a non-empty value instead.",
        FETCH_RECORDS_REJECTED: "Detokenize failed. Detokenize request is rejected.",
        INSERT_RECORDS_REJECTED: "Insert failed. Insert request is rejected.",
        GET_REJECTED: "Get failed. Get request is rejected.",
        FAILED_REVEAL: "Reveal failed. Some errors were encountered.",
        FAILED_RENDER: "Failed to render file. Some errors were encountered.",
        SKYFLOW_IDS_AND_TOKEN_BOTH_SPECIFIED: "Validation error. skyflowID and token can not be specified together.",
        MISSING_TABLE_IN_COLLECT: "Validation error.'table' key not found for collect element. Specify a valid value for 'table' key.",
        EMPTY_TABLE_IN_COLLECT: "Validation error.'table' cannot be empty for collect element. Specify a non-empty value for 'table'.",
        EMPTY_SKYFLOW_ID_IN_ADDITIONAL_FIELDS: "Validation error.'id' cannot be empty in addtionalFields record at index %s1. Specify a non-empty value for 'id'.",
        EMPTY_SKYFLOW_ID_COLLECT: "Validation error.'skyflowID' cannot be empty for collect element. Specify a non-empty value for 'skyflowID'.",
        INVALID_TABLE_IN_COLLECT: "Validation error. Invalid type for 'table' key value for collect element. Specify a value of type string instead.",
        INVALID_SKYFLOWID_IN_COLLECT: "Validation error. Invalid type for 'skyflowID' key value for collect element. Specify a value of type string instead.",
        MISSING_COLUMN_IN_COLLECT: "Validation error. 'column' key not found for collect element. Specify a valid column.",
        MISSING_SKYFLOWID_IN_COLLECT: "Validation error. 'skyflow_id' key not found for collect element. Specify a valid skyflowID.",
        EMPTY_COLUMN_IN_COLLECT: "Validation error. 'column' key cannot be empty for collect element. Specify a non-empty value instead.",
        INVALID_COLUMN_IN_COLLECT: "Validation error. Invalid type for 'column' key for collect element. Specify a value of type string instead.",
        UNIQUE_ELEMENT_NAME: "Validation error.Element name must be unique: %s1. Please enter a unique element name.",
        ELEMENTS_NOT_MOUNTED: "Collect failed. Make sure all elements are mounted before calling 'collect' on the container.",
        DUPLICATE_ELEMENT: "Mount failed.'%s1' appeared multiple times in '%s2'. Make sure each column in a record is unique.",
        DUPLICATE_ELEMENT_ADDITIONAL_FIELDS: "Mount failed. '%s1' appeared in record index '%s2' in the additional fields. Make sure each column in a record is unique.",
        MISSING_ELEMENT_TYPE: "Mount failed. Invalid element type. Specify a valid 'type'.",
        EMPTY_ELEMENT_TYPE: "Mount failed. Invalid element type. Specify a valid 'type'",
        INVALID_ELEMENT_TYPE: "Mount failed. Invalid element type. Specify a valid 'type'",
        INVALID_ELEMENT_SELECTOR: "Mount failed. 'div' element not found. Specify a valid 'div'.",
        CANNOT_CHANGE_ELEMENT: "Element can't be changed.",
        INVALID_IFRAME: "Error occured while creating an iframe",
        INVALID_FIELD: "Invalid Field.",
        FRAME_NOT_FOUND: "Frame %s1 not found. Could not initialise element.",
        COMPLETE_AND_VALID_INPUTS: "Mount failed. Incomplete inputs for '%s1'. Make sure all inputs are complete and valid.",
        REQUIRED_PARAMS_NOT_PROVIDED: "Initialisation error. Couldn't find iframe name for element.",
        INVALID_EVENT_TYPE: "Invalid event type. Specify a valid event type.",
        INVALID_EVENT_LISTENER: " Invalid event listener. Please specify a valid event listener.",
        MISSING_HANDLER_IN_EVENT_LISTENER: "Event handler callback is missing. Provide a valid event handler callback function.",
        INVALID_HANDLER_IN_EVENT_LISTENER: "Validation error. Invalid type for 'validations' key. Specify a value of type array instead.",
        UNKNOWN_ERROR: "Unknown Error.",
        NETWORK_ERROR: "A network error occurred. This could be a CORS issue or a dropped internet connection. It is not possible for us to know. Please reach out to skyflow if you see this error",
        CONNECTION_ERROR: "Error while initializing the connection.",
        ERROR_OCCURED: "Error occurred.",
        INVALID_VALIDATIONS_TYPE: "Validation error. Invalid validations type.",
        MISSING_VALIDATION_RULE_TYPE: "Validation error. 'type' for validation rule missing in validations array at index %s1. Specify a valid 'type' for each rule in validations array.",
        INVALID_VALIDATION_RULE_TYPE: "Validation error. Invalid 'type' for validation rule found in validations array at index %s1 . Specify a valid rule type for validation rule.",
        MISSING_VALIDATION_RULE_PARAMS: "Validation error. 'params' for validation rule missing in validations array at index %s1. Specify valid 'params' for each rule in validations array.",
        INVALID_VALIDATION_RULE_PARAMS: "Validation error. Invalid 'params' for validation rule found in validations array at index %s1 . Specify valid params for validation rule.",
        MISSING_REGEX_IN_REGEX_MATCH_RULE: "Validation error. Missing 'regex' param in validations array at index %s1. Specify a valid value for regex param.",
        INVALID_REGEX_IN_REGEX_MATCH_RULE: "Validation error. Invalid value for 'regex' param found for regex in validations array at index %s1. Provide a valid value regular expression for regex param.",
        MISSING_MIN_AND_MAX_IN_LENGTH_MATCH_RULE: "Validation error. Missing both 'min' and 'max' params in validations array at index %s1. Specify either one or both params.",
        MISSING_ELEMENT_IN_ELEMENT_MATCH_RULE: "Validation error. Missing 'element' param in validations array at index %s1. Specify a valid value for element param. ",
        INVALID_ELEMENT_IN_ELEMENT_MATCH_RULE: "Validation error. Invalid 'element' provided in validations array at index %s1. Specify a value of type collect element instead.",
        ELEMENT_NOT_MOUNTED_IN_ELEMENT_MATCH_RULE: "Validation error. Element provided in validations array at index %s1 is not mounted. Make sure the element is mounted.",
        EMPTY_ELEMENT_IN_MOUNT: "mount element with type %s1 - Mount cannot be empty.",
        VALIDATION_FAILED: "Validation failed",
        REVEAL_ELEMENT_ERROR_STATE: "Reveal failed. 'setError' is invoked on one or more elements. Make sure to reset any custom errors on all elements before invoking 'reveal' function.",
        INVALID_FILE_TYPE: "Invalid File Type.",
        INVALID_FILE_SIZE: "Invalid File Size",
        NO_FILE_SELECTED: "No File Selected",
        INVALID_UPSERT_OPTION_TYPE: "Validation error. Invalid 'upsert' key in insert options. Specify a value of type array instead",
        EMPTY_UPSERT_OPTIONS_ARRAY: "Validation error. 'upsert' key cannot be an empty array in insert options. Make sure to add atleast one table column object in upsert array.",
        INVALID_UPSERT_OPTION_OBJECT_TYPE: "Validation error. Invalid value in upsert array at index %s1 in insert options. Specify objects with 'table' and 'column' keys instead.",
        MISSING_TABLE_IN_UPSERT_OPTION: "Validation error. Missing 'table' key in upsert array at index %s1. Provide a valid 'table' key.",
        MISSING_COLUMN_IN_UPSERT_OPTION: "Validation error. Missing 'column' key in upsert array at index %s1. Provide a valid 'column' key",
        INVALID_TABLE_IN_UPSERT_OPTION: "Validation error. Invalid 'table' key in upsert array at index %s1. Specify a value of type string instead.",
        INVALID_COLUMN_IN_UPSERT_OPTION: "Validation error. Invalid 'column' key in upsert array at index %s1. Specify a value of type string instead.",
        INVALID_RECORD_COLUMN_VALUE: "Validation error. Invalid 'column' key. Specify a value of type string instead.",
        MISSING_RECORD_COLUMN_VALUE: "Validation error. Column Values is required when Column Name is specified.",
        MISSING_RECORD_COLUMN_NAME: "Validation error. Column Name is required when Column Values are specified.",
        INVALID_RECORD_COLUMN_VALUE_TYPE: "Validation error. Invalid Type of Records Column Values in records at index %s1",
        INVALID_COLUMN_VALUES_TYPE: "Validation error. Invalid column values type, should be an Array.",
        EMPTY_RECORD_COLUMN_VALUES: "Validation error. Record column values cannot be empty in records at index %s1",
        EMPTY_COLUMN_VALUE: "Validation error. Column Value is empty in records at index %s1",
        MISSING_IDS_OR_COLUMN_VALUES_IN_GET: "Validation error. Both 'ids' or 'columnValues' keys are missing. Either provide 'ids' or 'columnValues' with 'columnName' to fetch records.",
        SKYFLOW_IDS_AND_COLUMN_NAME_BOTH_SPECIFIED: "Validation error. ids and columnName can not be specified together.",
        GET_BY_SKYFLOWID_RESOLVED: "%s1 - GetById request is resolved.",
        RECORDS_KEY_NOT_FOUND_GETBYID: "Validation error. Missing 'records' key. Provide a valid 'records' key.",
        INVALID_RECORDS_IN_GETBYID: "Validation error. Invalid 'records' key found. Specify a value of type array instead.",
        EMPTY_RECORDS_GETBYID: "Validation error. 'records' key cannot be empty. Provide a non-empty value instead.",
        MISSING_IDS_IN_GETBYID: "Validation error. Missing 'ids' key in records at index %s1. Provide a valid 'ids' key.",
        INVALID_IDS_IN_GETBYID: "Validation error. Invalid 'ids' key in records at index %s1. ids object should be an array.",
        EMPTY_IDS_IN_GETBYID: "Validation error. 'ids' key cannot be an empty array in records at index %s1. Make sure to provide atleast one id in array.",
        INVALID_SKYFLOWID_TYPE_IN_GETBYID: "Validation error. Invalid value in ids array in records at index %s1. Specify a value of type string instead.",
        MISSING_TABLE_IN_GETBYID: "Validation error. Missing 'table' key in records at index %s1. Provide a valid 'table' key.",
        INVALID_TABLE_IN_GETBYID: "Validation error. Invalid 'table' key in records at index %s1. Specify a value of type string instead.",
        MISSING_REDACTION_IN_GETBYID: "Validation error. Missing 'redaction' key in records at index %s1. Provide a valid 'redaction' key.",
        INVALID_REDACTION_TYPE_IN_GETBYID: "Validation error. Invalid 'redaction' key in records at index %s1. Specify a valid redaction type.",
        EMPTY_SKYFLOWID_IN_GETBYID: "Validation error. 'ids' key cannot be an array of empty strings in records at index %s1. Specify non-empty values instead.",
        EMPTY_TABLE_IN_GETBYID: "Validation error. 'table' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        EMPTY_REDACTION_TYPE_IN_GETBYID: "Validation error. 'redaction' key cannot be empty in records at index %s1. Specify a non-empty value instead.",
        GET_BY_SKYFLOWID_REJECTED: "GetById failed. GetById request is rejected.",
        MISSING_COMPOSABLE_LAYOUT_KEY: "Mount failed. Layout is not specified in composable container options. Specify a valid layout.",
        EMPTY_COMPOSABLE_LAYOUT_ARRAY: "Mount failed. Layout array is empty in composable container options. Specify a valid layout array.",
        INVALID_COMPOSABLE_LAYOUT_TYPE: "Mount failed. Invalid layout array values. Make sure all values in the layout array are positive numbers.",
        NEGATIVE_VALUES_COMPOSABLE_LAYOUT: "Mount failed. layout array should only have positive numbers in composable container options.",
        MISMATCH_ELEMENT_COUNT_LAYOUT_SUM: "Mount failed. Invalid layout array values. Make sure all values in the layout array are positive numbers.",
        MISSING_COMPOSABLE_CONTAINER_OPTIONS: "Mount failed. An options object is required for composable containers. Specify a valid options object.",
        INVALID_COMPOSABLE_CONTAINER_OPTIONS: "Mount failed. Invalid options object. Specify a valid options object.",
        COMPOSABLE_CONTAINER_NOT_MOUNTED: "Mount elements first. Make sure all elements are mounted before calling 'collect' on the container.",
        INVALID_BOOLEAN_OPTIONS: "Validation error. Invalid %s1 found in collect options. Specify a value of type boolean instead.",
        INVALID_MASKING_CHARACTER: "Validation error. Invalid masking character. Specify a valid masking character. ",
        INVALID_INPUT_OPTIONS_FORMAT: "Mount failed. Format must be a non-empty string. Specify a valid format.",
        INVALID_INPUT_OPTIONS_TRANSLATION: "Mount failed. Translation must be a non-empty object. Specify a valid translation.",
        EMPTY_COLLECT_CUSTOM_FORMAT: "Mount failed. '%s1' can not be an empty object. Specify a valid object.",
        INVALID_ALLOWED_OPTIONS: "Validation error. Invalid options, allowedFileType must be of string array type.",
        EMPTY_ALLOWED_OPTIONS_ARRAY: "Validation error. Invalid options value, allowedFileType array is empty.",
        INVALID_ALLOWED_FILETYPE_ARRAY: "Validation error. Invalid options value, allowedFileType array must contain only string elements.",
        INVALID_OPTION_CARD_METADATA: "Validation error. container create - Invalid type, cardMetadata must be of non-empty object type.",
        INVALID_OPTION_CARD_SCHEME: "Validation error. container create - Invalid options, scheme must be of string array type.",
        INVALID_FIELD_SHOW_3DS_CHALLEGNGE: "Invalid field '%s1'. Cannot initiate 3DS Challenge. Verify '%s1'"
      },
      warnLogs: {
        INVALID_EXPIRATION_DATE_FORMAT: "EXPIRATION_DATE format must be in one of %s1, the format is set to default MM/YY",
        INVALID_EXPIRATION_YEAR_FORMAT: "EXPIRATION_YEAR format must be in one of %s1, the format is set to default YY",
        UNABLE_TO_SET_VALUE_IN_PROD_ENV: "%s1 setValue() cannot invoked while in PROD env. It is Not Recommeded",
        UNABLE_TO_CLEAR_VALUE_IN_PROD_ENV: "%s1 clearValue() cannot invoked while in PROD env. It is Not Recommeded",
        COLLECT_ALT_TEXT_DEPERECATED: "altText is DEPERECATED, passing altText will not have any effect",
        GET_BY_ID_DEPRECATED: "getById is deprecated, use new get method",
        INPUT_FORMATTING_NOT_SUPPROTED: "format or translation are not supported on %s1 element type.",
        INVALID_INPUT_TRANSLATION: "invalid or unsupported translation provided for %s1 element type."
      }
    };
    var S,
      D,
      x,
      M,
      P,
      C,
      k,
      V,
      j = "collect_controller",
      U = "element",
      F = {
        COLLECT: "COLLECT",
        REVEAL: "REVEAL",
        COMPOSE: "COMPOSABLE"
      },
      Y = {
        MOUNTED: "MOUNTED",
        READY: "FRAME_READY"
      },
      G = "element_type",
      B = "div_id",
      X = "container_name",
      W = Y,
      K = "events",
      q = "mount_start_time",
      z = "mount_end_time",
      H = "error",
      J = {
        SUCCESS: "SUCCESS",
        INITIALIZED: "INITIALIZED",
        PARTIAL_RENDER: "PARTIAL_RENDER",
        FAILED: "FAILED"
      },
      Z = "INSERT",
      $ = "DETOKENIZE",
      Q = "GET_BY_SKYFLOWID",
      ee = "GET",
      te = "DELETE",
      ne = "COLLECT",
      re = "FILE_UPLOAD",
      oe = "REVEAL",
      ie = "RENDER_FILE",
      ae = {
        CHANGE: "CHANGE",
        READY: "READY",
        FOCUS: "FOCUS",
        BLUR: "BLUR",
        ESCAPE: "ESCAPE",
        CLICK: "CLICK",
        ERROR: "ERROR",
        SUCCESS: "SUCCESS",
        SUBMIT: "SUBMIT",
        CREATED: "CREATED",
        MOUNTED: "MOUNTED",
        HEIGHT: "HEIGHT"
      },
      ce = "COLLECT_CALL_REQUESTS",
      le = "REVEAL_CALL_REQUESTS",
      se = "TOKENIZATION_REQUEST",
      pe = "INPUT_EVENT",
      ue = "DESTROY FRAME",
      de = "SET_VALUE",
      fe = "PUREJS_REQUEST",
      Ee = "PUREJS_FRAME_READY",
      _e = "GET_BEARER_TOKEN",
      me = "COLLECT_ELEMENT_SET_ERROR",
      ve = "COLLECT_ELEMENT_SET_ERROR_OVERRIDE",
      Ie = "REVEAL_ELEMENT_SET_ERROR",
      ye = "REVEAL_ELEMENT_UPDATE_OPTIONS",
      Oe = "FILE_UPLOAD",
      ge = "COMPOSABLE_UPDATE_OPTIONS",
      Ne = "RENDER_FILE_REQUEST",
      Le = "PUSH_EVENT",
      Te = "SKYFLOW_FRAME_CONTROLLER_READY",
      he = "COLLECT_ELEMENT_READY",
      be = "TOKEN",
      Ae = "ALT_TEXT",
      we = "ELEMENT_PROPS",
      Re = "ELEMENT_MOUNTED",
      Se = "ALL_ELEMENTS_MOUNTED",
      De = function (e) {
        return e.CVV = "CVV", e.EXPIRATION_DATE = "EXPIRATION_DATE", e.CARD_NUMBER = "CARD_NUMBER", e.CARDHOLDER_NAME = "CARDHOLDER_NAME", e.INPUT_FIELD = "INPUT_FIELD", e.PIN = "PIN", e.EXPIRATION_MONTH = "EXPIRATION_MONTH", e.EXPIRATION_YEAR = "EXPIRATION_YEAR", e.FILE_INPUT = "FILE_INPUT", e;
      }({}),
      xe = function (e) {
        return e.VISA = "VISA", e.MASTERCARD = "MASTERCARD", e.AMEX = "AMEX", e.DINERS_CLUB = "DINERS_CLUB", e.DISCOVER = "DISCOVER", e.JCB = "JCB", e.MAESTRO = "MAESTRO", e.UNIONPAY = "UNIONPAY", e.HIPERCARD = "HIPERCARD", e.DEFAULT = "DEFAULT", e.UNKNOWN = "UNKNOWN", e.CARTES_BANCAIRES = "CARTES BANCAIRES", e;
      }({}),
      Me = (l(S = {}, xe.VISA, "Visa"), l(S, xe.MASTERCARD, "Mastercard"), l(S, xe.AMEX, "Amex"), l(S, xe.DINERS_CLUB, "DinersClub"), l(S, xe.DISCOVER, "Discover"), l(S, xe.JCB, "Jcb"), l(S, xe.MAESTRO, "Maestro"), l(S, xe.UNIONPAY, "Unionpay"), l(S, xe.HIPERCARD, "Hipercard"), l(S, xe.DEFAULT, "Default"), l(S, xe.UNKNOWN, "Unknown"), l(S, xe.CARTES_BANCAIRES, "Cartes Bancaires"), l(D = {}, xe.AMEX, ["XXXX XXXXXX XXXXX", {
        X: "[0-9]"
      }]), l(D, xe.VISA, ["XXXX XXXX XXXX XXXX", {
        X: "[0-9]"
      }]), l(D, xe.MASTERCARD, ["XXXX XXXX XXXX XXXX", {
        X: "[0-9]"
      }]), l(D, xe.DISCOVER, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), l(D, xe.DINERS_CLUB, ["XXXX XXXXXX XXXXXX", {
        X: "[0-9]"
      }]), l(D, xe.JCB, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), l(D, xe.MAESTRO, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), l(D, xe.UNIONPAY, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), l(D, xe.HIPERCARD, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), l(D, xe.DEFAULT, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), l(D, xe.UNKNOWN, ["XXXX XXXX XXXX XXXX XXX", {
        X: "[0-9]"
      }]), D),
      Pe = (l(x = {
        textarea: {
          name: "textarea",
          attributes: {
            type: "textarea"
          },
          sensitive: !1
        },
        checkbox: {
          name: "checkbox",
          attributes: {
            type: "checkbox"
          },
          sensitive: !1
        },
        radio: {
          name: "radio",
          attributes: {
            type: "radio"
          },
          sensitive: !1
        },
        dropdown: {
          name: "dropdown",
          attributes: {
            type: "select"
          },
          sensitive: !1
        }
      }, De.CARDHOLDER_NAME, {
        name: "cardHolderName",
        attributes: {
          type: "text",
          autocomplete: "cc-name"
        },
        sensitive: !0,
        regex: /^([a-zA-Z\\ \\,\\.\\-\\']{2,})$/
      }), l(x, De.CARD_NUMBER, {
        name: "CARD_NUMBER",
        attributes: {
          type: "text",
          autocomplete: "cc-number",
          inputmode: "numeric"
        },
        sensitive: !0,
        mask: Me[xe.DEFAULT],
        regex: /$|^[\s]*?([0-9]{2,6}[ -]?){3,5}[\s]*/
      }), l(x, De.EXPIRATION_DATE, {
        name: "EXPIRATION_DATE",
        attributes: {
          type: "text",
          autocomplete: "cc-exp",
          inputmode: "numeric"
        },
        sensitive: !0
      }), l(x, De.EXPIRATION_MONTH, {
        name: "EXPIRATION_MONTH",
        attributes: {
          maxLength: 2,
          type: "text",
          inputmode: "numeric",
          autocomplete: "cc-exp-month"
        },
        sensitive: !0,
        mask: ["XX", {
          X: "[0-9]"
        }]
      }), l(x, De.EXPIRATION_YEAR, {
        name: "EXPIRATION_YEAR",
        attributes: {
          type: "text",
          inputmode: "numeric",
          autocomplete: "cc-exp-year"
        },
        sensitive: !0
      }), l(x, De.CVV, {
        name: "CVV",
        attributes: {
          type: "text",
          inputmode: "numeric",
          maxLength: 4
        },
        sensitive: !0,
        regex: /^$|^[0-9]{3,4}$/
      }), l(x, De.INPUT_FIELD, {
        name: "INPUT_FIELD",
        sensitive: !0,
        attributes: {
          type: "text"
        }
      }), l(x, De.PIN, {
        name: "PIN",
        attributes: {
          type: "text",
          inputmode: "numeric",
          maxLength: 12,
          minLength: 4
        },
        sensitive: !0,
        regex: /^$|^[0-9]{4,12}$/
      }), l(x, De.FILE_INPUT, {
        name: "FILE_INPUT",
        sensitive: !0,
        attributes: {
          type: "file"
        }
      }), x),
      Ce = "XXXX-XXXX-XXXX-XXXX",
      ke = {
        height: "100%",
        width: "100%",
        margin: 0,
        padding: 0,
        border: 0,
        position: "absolute",
        top: 0,
        left: 0,
        "user-select": "none"
      },
      Ve = {
        position: "absolute",
        top: 0,
        width: 0,
        height: 0,
        visibility: "hidden",
        left: "-99999999px",
        "user-select": "none"
      },
      je = {
        width: "100%",
        height: "100%",
        border: "0",
        padding: "0",
        margin: "0",
        outline: "none"
      },
      Ue = {
        WEBPACKAUTOFILL: "-webkit-autofill",
        BASE: "base",
        FOCUS: "focus",
        COMPLETE: "complete",
        EMPTY: "empty",
        INVALID: "invalid",
        GLOBAL: "global",
        REQUIRED_ASTERISK: "requiredAsterisk"
      },
      Fe = (l({}, Ue.BASE, {
        maxHeight: "100%",
        maxWidth: "100%"
      }), l({}, Ue.BASE, {
        "margin-bottom": "4px"
      }), l({}, Ue.BASE, {
        "margin-bottom": "4px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }), l({}, Ue.BASE, {
        marginTop: "4px"
      }), l(M = {}, Ue.BASE, {
        marginBottom: "4px"
      }), l(M, Ue.REQUIRED_ASTERISK, {
        display: "inline",
        color: "red"
      }), l(P = {}, xe.VISA, {
        regex: /^4\d*/,
        maxCardLength: 19,
        cardLengthRange: [13, 16]
      }), l(P, xe.MASTERCARD, {
        regex: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)\d*/,
        maxCardLength: 16,
        cardLengthRange: [16]
      }), l(P, xe.AMEX, {
        regex: /^3[47]\d*/,
        maxCardLength: 15,
        cardLengthRange: [15]
      }), l(P, xe.DINERS_CLUB, {
        regex: /^(36|38|30[0-5])\d*/,
        maxCardLength: 16,
        cardLengthRange: [14, 15, 16, 17, 18, 19]
      }), l(P, xe.DISCOVER, {
        regex: /^(6011|65|64[4-9]|622)\d*/,
        maxCardLength: 16,
        cardLengthRange: [16, 17, 18, 19]
      }), l(P, xe.JCB, {
        regex: /^35\d*/,
        maxCardLength: 19,
        cardLengthRange: [16, 17, 18, 19]
      }), l(P, xe.HIPERCARD, {
        regex: /^606282\d*/,
        maxCardLength: 19,
        cardLengthRange: [14, 15, 16, 17, 18, 19]
      }), l(P, xe.UNIONPAY, {
        regex: /^62\d*/,
        maxCardLength: 19,
        cardLengthRange: [16, 17, 18, 19]
      }), l(P, xe.MAESTRO, {
        regex: /^(5018|5020|5038|5043|5[6-9]|6020|6304|6703|6759|676[1-3])\d*/,
        maxCardLength: 19,
        cardLengthRange: [12, 13, 14, 15, 16, 17, 18, 19]
      }), P),
      Ye = (l(C = {}, xe.DEFAULT, I), l(C, xe.AMEX, y), l(C, xe.CARTES_BANCAIRES, w), l(C, xe.DINERS_CLUB, O), l(C, xe.DISCOVER, g), l(C, xe.HIPERCARD, N), l(C, xe.JCB, L), l(C, xe.MAESTRO, T), l(C, xe.MASTERCARD, h), l(C, xe.UNIONPAY, b), l(C, xe.VISA, A), "MM/YY"),
      Ge = [Ye, "YYYY/MM", "YY/MM", "MM/YYYY"],
      Be = ["YY", "YYYY"],
      Xe = function (e) {
        return e.APPLICATIONORJSON = "application/json", e.TEXTORPLAIN = "text/plain", e.TEXTORXML = "text/xml", e.FORMURLENCODED = "application/x-www-form-urlencoded", e.FORMDATA = "multipart/form-data", e;
      }({}),
      We = (De.CARD_NUMBER, De.EXPIRATION_DATE, De.EXPIRATION_MONTH, De.EXPIRATION_YEAR, l(k = {}, De.CVV, "Invalid cvv"), l(k, De.EXPIRATION_DATE, "Invalid expiration date"), l(k, De.CARD_NUMBER, "Invalid card number"), l(k, De.CARDHOLDER_NAME, "Invalid cardholder name"), l(k, De.INPUT_FIELD, R.errorLogs.INVALID_COLLECT_VALUE), l(k, De.PIN, "Invalid pin"), l(k, De.EXPIRATION_MONTH, "Invalid expiration month"), l(k, De.EXPIRATION_YEAR, "Invalid expiration year"), l(k, De.FILE_INPUT, R.errorLogs.INVALID_COLLECT_VALUE), l(V = {}, De.CVV, "cvv is required"), l(V, De.EXPIRATION_DATE, "expiration date is required"), l(V, De.CARD_NUMBER, "card number is required"), l(V, De.CARDHOLDER_NAME, "cardholder name is required"), l(V, De.INPUT_FIELD, R.errorLogs.DEFAULT_REQUIRED_COLLECT_VALUE), l(V, De.PIN, "pin is required"), l(V, De.EXPIRATION_MONTH, "expiration month is required"), l(V, De.EXPIRATION_YEAR, "expiration year is required"), l(V, De.FILE_INPUT, R.errorLogs.DEFAULT_REQUIRED_COLLECT_VALUE), [De.CARDHOLDER_NAME, De.EXPIRATION_MONTH, De.FILE_INPUT, De.PIN, De.CVV]),
      Ke = {
        X: "[0-9]"
      };
    function qe(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function ze(e, t) {
      if (e) {
        if ("string" == typeof e) return qe(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? qe(e, t) : void 0;
      }
    }
    function He(e) {
      return function (e) {
        if (Array.isArray(e)) return qe(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || ze(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function Je(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Ze(e, t) {
      return Ze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, Ze(e, t);
    }
    function $e(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Ze(e, t);
    }
    function Qe(e, t) {
      if (t && ("object" === a(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Je(e);
    }
    function et(e) {
      return et = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, et(e);
    }
    function tt(e, t, n) {
      return tt = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }() ? Reflect.construct.bind() : function (e, t, n) {
        var r = [null];
        r.push.apply(r, t);
        var o = new (Function.bind.apply(e, r))();
        return n && Ze(o, n.prototype), o;
      }, tt.apply(null, arguments);
    }
    function nt(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return nt = function (e) {
        if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
        var n;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }
        function r() {
          return tt(e, arguments, et(this).constructor);
        }
        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Ze(r, e);
      }, nt(e);
    }
    var rt = function (e) {
        return e.DEFAULT = "DEFAULT", e.PLAIN_TEXT = "PLAIN_TEXT", e.MASKED = "MASKED", e.REDACTED = "REDACTED", e;
      }({}),
      ot = function (e) {
        return e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.DELETE = "DELETE", e;
      }({}),
      it = function (e) {
        return e.CHANGE = "CHANGE", e.READY = "READY", e.FOCUS = "FOCUS", e.BLUR = "BLUR", e.SUBMIT = "SUBMIT", e;
      }({}),
      at = function (e) {
        return e.WARN = "WARN", e.INFO = "INFO", e.DEBUG = "DEBUG", e.ERROR = "ERROR", e;
      }({}),
      ct = function (e) {
        return e.DEV = "DEV", e.PROD = "PROD", e;
      }({}),
      lt = function (e) {
        return e.LOG = "LOG", e.WARN = "WARN", e.ERROR = "ERROR", e;
      }({}),
      st = function (e) {
        return e.REGEX_MATCH_RULE = "REGEX_MATCH_RULE", e.LENGTH_MATCH_RULE = "LENGTH_MATCH_RULE", e.ELEMENT_VALUE_MATCH_RULE = "ELEMENT_VALUE_MATCH_RULE", e;
      }({});
    const pt = {
      INVALID_FILE_NAME: {
        code: 400,
        description: R.errorLogs.INVALID_FILE_NAME
      },
      INVALID_FIELD: {
        code: 400,
        description: R.errorLogs.INVALID_FIELD
      },
      VAULTID_IS_REQUIRED: {
        code: 400,
        description: R.errorLogs.VAULTID_IS_REQUIRED
      },
      EMPTY_VAULTID_IN_INIT: {
        code: 400,
        description: R.errorLogs.EMPTY_VAULTID_IN_INIT
      },
      VAULTURL_IS_REQUIRED: {
        code: 400,
        description: R.errorLogs.VAULTURL_IS_REQUIRED
      },
      EMPTY_VAULTURL_IN_INIT: {
        code: 400,
        description: R.errorLogs.EMPTY_VAULTURL_IN_INIT
      },
      INVALID_VAULTURL_IN_INIT: {
        code: 400,
        description: R.errorLogs.INVALID_VAULTURL_IN_INIT
      },
      GET_BEARER_TOKEN_IS_REQUIRED: {
        code: 400,
        description: R.errorLogs.GET_BEARER_TOKEN_IS_REQUIRED
      },
      EMPTY_CONTAINER_TYPE: {
        code: 400,
        description: R.errorLogs.EMPTY_CONTAINER_TYPE
      },
      INVALID_CONTAINER_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_CONTAINER_TYPE
      },
      UNIQUE_ELEMENT_NAME: {
        code: 400,
        description: R.errorLogs.UNIQUE_ELEMENT_NAME
      },
      ELEMENTS_NOT_MOUNTED: {
        code: 400,
        description: R.errorLogs.ELEMENTS_NOT_MOUNTED
      },
      MISSING_TABLE_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_COLLECT
      },
      MISSING_SKYFLOWID_KEY_REVEAL: {
        code: 400,
        description: R.errorLogs.MISSING_SKYFLOWID_KEY_REVEAL
      },
      EMPTY_TABLE_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_COLLECT
      },
      EMPTY_SKYFLOW_ID_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.EMPTY_SKYFLOW_ID_IN_ADDITIONAL_FIELDS
      },
      EMPTY_SKYFLOW_ID_COLLECT: {
        code: 400,
        description: R.errorLogs.EMPTY_SKYFLOW_ID_COLLECT
      },
      INVALID_TABLE_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_COLLECT
      },
      INVALID_SKYFLOWID_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.INVALID_SKYFLOWID_IN_COLLECT
      },
      MISSING_COLUMN_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.MISSING_COLUMN_IN_COLLECT
      },
      MISSING_SKYFLOWID_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.MISSING_SKYFLOWID_IN_COLLECT
      },
      EMPTY_COLUMN_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_COLLECT
      },
      INVALID_COLUMN_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.INVALID_COLUMN_IN_COLLECT
      },
      CLIENT_CONNECTION: {
        code: 400,
        description: R.errorLogs.CLIENT_CONNECTION
      },
      RECORDS_KEY_NOT_FOUND: {
        code: 404,
        description: R.errorLogs.RECORDS_KEY_NOT_FOUND
      },
      EMPTY_RECORDS_IN_INSERT: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_IN_INSERT
      },
      INVALID_RECORDS_IN_INSERT: {
        code: 404,
        description: R.errorLogs.INVALID_RECORDS_IN_INSERT
      },
      INVALID_TABLE_IN_INSERT: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_INSERT
      },
      EMPTY_TABLE_IN_INSERT: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_INSERT
      },
      MISSING_TABLE_IN_INSERT: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_INSERT
      },
      EMPTY_FIELDS_IN_INSERT: {
        code: 400,
        description: R.errorLogs.EMPTY_FIELDS_IN_INSERT
      },
      MISSING_FIELDS_IN_INSERT: {
        code: 404,
        description: R.errorLogs.MISSING_FIELDS_IN_INSERT
      },
      INVALID_FIELDS_IN_INSERT: {
        code: 404,
        description: R.errorLogs.INVALID_FIELDS_IN_INSERT
      },
      INVALID_TOKENS_IN_INSERT: {
        code: 404,
        description: R.errorLogs.INVALID_TOKENS_IN_INSERT
      },
      RECORDS_KEY_NOT_FOUND_DETOKENIZE: {
        code: 404,
        description: R.errorLogs.RECORDS_KEY_NOT_FOUND_DETOKENIZE
      },
      EMPTY_RECORDS_DETOKENIZE: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_DETOKENIZE
      },
      INVALID_RECORDS_IN_DETOKENIZE: {
        code: 404,
        description: R.errorLogs.INVALID_RECORDS_IN_DETOKENIZE
      },
      MISSING_TOKEN_IN_DETOKENIZE: {
        code: 400,
        description: R.errorLogs.MISSING_TOKEN_IN_DETOKENIZE
      },
      INVALID_TOKEN_IN_DETOKENIZE: {
        code: 400,
        description: R.errorLogs.INVALID_TOKEN_IN_DETOKENIZE
      },
      RECORDS_KEY_NOT_FOUND_GET: {
        code: 400,
        description: R.errorLogs.RECORDS_KEY_NOT_FOUND_GET
      },
      INVALID_RECORDS_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_RECORDS_IN_GET
      },
      EMPTY_RECORDS_GET: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_GET
      },
      MISSING_IDS_IN_GET: {
        code: 400,
        description: R.errorLogs.MISSING_IDS_IN_GET
      },
      INVALID_IDS_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_IDS_IN_GET
      },
      INVALID_COLUMN_VALUES_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_COLUMN_VALUES_IN_GET
      },
      EMPTY_IDS_IN_GET: {
        code: 400,
        description: R.errorLogs.EMPTY_IDS_IN_GET
      },
      INVALID_SKYFLOWID_TYPE_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_SKYFLOWID_TYPE_IN_GET
      },
      MISSING_TABLE_IN_GET: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_GET
      },
      INVALID_TABLE_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_GET
      },
      MISSING_REDACTION_IN_GET: {
        code: 400,
        description: R.errorLogs.MISSING_REDACTION_IN_GET
      },
      INVALID_REDACTION_TYPE_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_REDACTION_TYPE_IN_GET
      },
      INVALID_TOKENS_IN_GET: {
        code: 400,
        description: R.errorLogs.INVALID_TOKENS_IN_GET
      },
      TOKENS_GET_COLUMN_NOT_SUPPORTED: {
        code: 400,
        description: R.errorLogs.TOKENS_GET_COLUMN_NOT_SUPPORTED
      },
      REDACTION_WITH_TOKENS_NOT_SUPPORTED: {
        code: 400,
        description: R.errorLogs.REDACTION_WITH_TOKENS_NOT_SUPPORTED
      },
      INVALID_REDACTION_TYPE_IN_DETOKENIZE: {
        code: 400,
        description: R.errorLogs.INVALID_REDACTION_TYPE_IN_DETOKENIZE
      },
      INVALID_TOKENS_IN_COLLECT: {
        code: 404,
        description: R.errorLogs.INVALID_TOKENS_IN_COLLECT
      },
      RECORDS_KEY_NOT_FOUND_IN_ADDITIONAL_FIELDS: {
        code: 404,
        description: R.errorLogs.RECORDS_KEY_NOT_FOUND_IN_ADDITIONAL_FIELDS
      },
      INVALID_RECORDS_IN_ADDITIONAL_FIELDS: {
        code: 404,
        description: R.errorLogs.INVALID_RECORDS_IN_ADDITIONAL_FIELDS
      },
      EMPTY_RECORDS_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_IN_ADDITIONAL_FIELDS
      },
      MISSING_TABLE_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_ADDITIONAL_FIELDS
      },
      INVALID_TABLE_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_ADDITIONAL_FIELDS
      },
      INVALID_SKYFLOW_ID_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.INVALID_SKYFLOW_ID_IN_ADDITIONAL_FIELDS
      },
      MISSING_FIELDS_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.MISSING_FIELDS_IN_ADDITIONAL_FIELDS
      },
      INVALID_FIELDS_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.INVALID_FIELDS_IN_ADDITIONAL_FIELDS
      },
      RECORDS_KEY_NOT_FOUND_DELETE: {
        code: 400,
        description: R.errorLogs.RECORDS_KEY_NOT_FOUND_DELETE
      },
      EMPTY_RECORDS_IN_DELETE: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_IN_DELETE
      },
      INVALID_RECORDS_IN_DELETE: {
        code: 404,
        description: R.errorLogs.INVALID_RECORDS_IN_DELETE
      },
      INVALID_TABLE_IN_DELETE: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_DELETE
      },
      EMPTY_TABLE_IN_DELETE: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_DELETE
      },
      MISSING_TABLE_IN_DELETE: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_DELETE
      },
      EMPTY_ID_IN_DELETE: {
        code: 400,
        description: R.errorLogs.EMPTY_ID_IN_DELETE
      },
      MISSING_ID_IN_DELETE: {
        code: 404,
        description: R.errorLogs.MISSING_ID_IN_DELETE
      },
      INVALID_ID_IN_DELETE: {
        code: 404,
        description: R.errorLogs.INVALID_ID_IN_DELETE
      },
      EMPTY_RECORDS_REVEAL: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_REVEAL
      },
      MISSING_TOKEN_KEY_REVEAL: {
        code: 400,
        description: R.errorLogs.MISSING_TOKEN_KEY_REVEAL
      },
      INVALID_TOKEN_ID_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_TOKEN_ID_REVEAL
      },
      INVALID_LABEL_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_LABEL_REVEAL
      },
      INVALID_ALT_TEXT_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_ALT_TEXT_REVEAL
      },
      INVALID_ALT_TEXT_RENDER: {
        code: 400,
        description: R.errorLogs.INVALID_ALT_TEXT_RENDER
      },
      INVALID_FORMAT_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_FORMAT_REVEAL
      },
      EMPTY_FORMAT_REVEAL: {
        code: 400,
        description: R.errorLogs.EMPTY_FORMAT_REVEAL
      },
      INVALID_FORMAT_VALUE_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_FORMAT_VALUE_REVEAL
      },
      INVALID_REDACTION_TYPE_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_REDACTION_TYPE_REVEAL
      },
      EMPTY_TABLE_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_ADDITIONAL_FIELDS
      },
      EMPTY_FIELDS_IN_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.EMPTY_FIELDS_IN_ADDITIONAL_FIELDS
      },
      EMPTY_TOKEN_IN_DETOKENIZE: {
        code: 400,
        description: R.errorLogs.EMPTY_TOKEN_IN_DETOKENIZE
      },
      EMPTY_SKYFLOWID_IN_GET: {
        code: 400,
        description: R.errorLogs.EMPTY_SKYFLOWID_IN_GET
      },
      EMPTY_TABLE_IN_GET: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_GET
      },
      EMPTY_REDACTION_TYPE_IN_GET: {
        code: 400,
        description: R.errorLogs.EMPTY_REDACTION_TYPE_IN_GET
      },
      EMPTY_TOKEN_ID_REVEAL: {
        code: 400,
        description: R.errorLogs.EMPTY_TOKEN_ID_REVEAL
      },
      DUPLICATE_ELEMENT: {
        code: 400,
        description: R.errorLogs.DUPLICATE_ELEMENT
      },
      DUPLICATE_ELEMENT_ADDITIONAL_FIELDS: {
        code: 400,
        description: R.errorLogs.DUPLICATE_ELEMENT_ADDITIONAL_FIELDS
      },
      MISSING_ELEMENT_TYPE: {
        code: 400,
        description: R.errorLogs.MISSING_ELEMENT_TYPE
      },
      EMPTY_ELEMENT_TYPE: {
        code: 400,
        description: R.errorLogs.EMPTY_ELEMENT_TYPE
      },
      INVALID_ALLOWED_OPTIONS: {
        code: 400,
        description: R.errorLogs.INVALID_ALLOWED_OPTIONS
      },
      EMPTY_ALLOWED_OPTIONS_ARRAY: {
        code: 400,
        description: R.errorLogs.EMPTY_ALLOWED_OPTIONS_ARRAY
      },
      INVALID_ALLOWED_FILETYPE_ARRAY: {
        code: 400,
        description: R.errorLogs.INVALID_ALLOWED_FILETYPE_ARRAY
      },
      INVALID_ELEMENT_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_ELEMENT_TYPE
      },
      INVALID_ELEMENT_SELECTOR: {
        code: 400,
        description: R.errorLogs.INVALID_ELEMENT_SELECTOR
      },
      FRAME_NOT_FOUND: {
        code: 400,
        description: R.errorLogs.FRAME_NOT_FOUND
      },
      REQUIRED_PARAMS_NOT_PROVIDED: {
        code: 400,
        description: R.errorLogs.REQUIRED_PARAMS_NOT_PROVIDED
      },
      INVALID_RECORD_COLUMN_VALUE: {
        code: 400,
        description: R.errorLogs.INVALID_RECORD_COLUMN_VALUE
      },
      MISSING_RECORD_COLUMN_VALUE: {
        code: 400,
        description: R.errorLogs.MISSING_RECORD_COLUMN_VALUE
      },
      MISSING_RECORD_COLUMN_NAME: {
        code: 400,
        description: R.errorLogs.MISSING_RECORD_COLUMN_NAME
      },
      INVALID_EVENT_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_EVENT_TYPE
      },
      INVALID_EVENT_LISTENER: {
        code: 400,
        description: R.errorLogs.INVALID_EVENT_LISTENER
      },
      MISSING_HANDLER_IN_EVENT_LISTENER: {
        code: 400,
        description: R.errorLogs.MISSING_HANDLER_IN_EVENT_LISTENER
      },
      INVALID_HANDLER_IN_EVENT_LISTENER: {
        code: 400,
        description: R.errorLogs.INVALID_HANDLER_IN_EVENT_LISTENER
      },
      UNKNOWN_ERROR: {
        code: 400,
        description: R.errorLogs.UNKNOWN_ERROR
      },
      CONNECTION_ERROR: {
        code: 400,
        description: R.errorLogs.CONNECTION_ERROR
      },
      NETWORK_ERROR: {
        code: 500,
        description: R.errorLogs.NETWORK_ERROR
      },
      COMPLETE_AND_VALID_INPUTS: {
        code: 400,
        description: R.errorLogs.COMPLETE_AND_VALID_INPUTS
      },
      INVALID_VALIDATIONS_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_VALIDATIONS_TYPE
      },
      MISSING_VALIDATION_RULE_TYPE: {
        code: 400,
        description: R.errorLogs.MISSING_VALIDATION_RULE_TYPE
      },
      INVALID_VALIDATION_RULE_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_VALIDATION_RULE_TYPE
      },
      MISSING_VALIDATION_RULE_PARAMS: {
        code: 400,
        description: R.errorLogs.MISSING_VALIDATION_RULE_PARAMS
      },
      INVALID_VALIDATION_RULE_PARAMS: {
        code: 400,
        description: R.errorLogs.INVALID_VALIDATION_RULE_PARAMS
      },
      MISSING_REGEX_IN_REGEX_MATCH_RULE: {
        code: 400,
        description: R.errorLogs.MISSING_REGEX_IN_REGEX_MATCH_RULE
      },
      INVALID_REGEX_IN_REGEX_MATCH_RULE: {
        code: 400,
        description: R.errorLogs.INVALID_REGEX_IN_REGEX_MATCH_RULE
      },
      MISSING_MIN_AND_MAX_IN_LENGTH_MATCH_RULE: {
        code: 400,
        description: R.errorLogs.MISSING_MIN_AND_MAX_IN_LENGTH_MATCH_RULE
      },
      MISSING_ELEMENT_IN_ELEMENT_MATCH_RULE: {
        code: 400,
        description: R.errorLogs.MISSING_ELEMENT_IN_ELEMENT_MATCH_RULE
      },
      INVALID_ELEMENT_IN_ELEMENT_MATCH_RULE: {
        code: 400,
        description: R.errorLogs.INVALID_ELEMENT_IN_ELEMENT_MATCH_RULE
      },
      ELEMENT_NOT_MOUNTED_IN_ELEMENT_MATCH_RULE: {
        code: 400,
        description: R.errorLogs.ELEMENT_NOT_MOUNTED_IN_ELEMENT_MATCH_RULE
      },
      EMPTY_ELEMENT_IN_MOUNT: {
        code: 400,
        description: R.errorLogs.EMPTY_ELEMENT_IN_MOUNT
      },
      REVEAL_ELEMENT_ERROR_STATE: {
        code: 400,
        description: R.errorLogs.REVEAL_ELEMENT_ERROR_STATE
      },
      INVALID_FILE_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_FILE_TYPE
      },
      INVALID_FILE_SIZE: {
        code: 400,
        description: R.errorLogs.INVALID_FILE_SIZE
      },
      NO_FILE_SELECTED: {
        code: 400,
        description: R.errorLogs.NO_FILE_SELECTED
      },
      INVALID_TABLE_IN_UPSERT_OPTION: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_UPSERT_OPTION
      },
      INVALID_COLUMN_IN_UPSERT_OPTION: {
        code: 400,
        description: R.errorLogs.INVALID_COLUMN_IN_UPSERT_OPTION
      },
      INVALID_UPSERT_OPTION_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_UPSERT_OPTION_TYPE
      },
      EMPTY_UPSERT_OPTIONS_ARRAY: {
        code: 400,
        description: R.errorLogs.EMPTY_UPSERT_OPTIONS_ARRAY
      },
      INVALID_UPSERT_OPTION_OBJECT_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_UPSERT_OPTION_OBJECT_TYPE
      },
      MISSING_TABLE_IN_UPSERT_OPTION: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_UPSERT_OPTION
      },
      MISSING_COLUMN_IN_UPSERT_OPTION: {
        code: 400,
        description: R.errorLogs.MISSING_COLUMN_IN_UPSERT_OPTION
      },
      INVALID_RECORD_COLUMN_VALUE_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_RECORD_COLUMN_VALUE_TYPE
      },
      INVALID_COLUMN_VALUES_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_COLUMN_VALUES_TYPE
      },
      EMPTY_RECORD_COLUMN_VALUES: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORD_COLUMN_VALUES
      },
      EMPTY_COLUMN_VALUE: {
        code: 400,
        description: R.errorLogs.EMPTY_COLUMN_VALUE
      },
      MISSING_IDS_OR_COLUMN_VALUES_IN_GET: {
        code: 400,
        description: R.errorLogs.MISSING_IDS_OR_COLUMN_VALUES_IN_GET
      },
      SKYFLOW_IDS_AND_COLUMN_NAME_BOTH_SPECIFIED: {
        code: 400,
        description: R.errorLogs.SKYFLOW_IDS_AND_COLUMN_NAME_BOTH_SPECIFIED
      },
      SKYFLOW_IDS_AND_TOKEN_BOTH_SPECIFIED: {
        code: 400,
        description: R.errorLogs.SKYFLOW_IDS_AND_TOKEN_BOTH_SPECIFIED
      },
      MISSING_TABLE_KEY_REVEAL: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_KEY_REVEAL
      },
      MISSING_COLUMN_KEY_REVEAL: {
        code: 400,
        description: R.errorLogs.MISSING_COLUMN_KEY_REVEAL
      },
      INVALID_SKYFLOW_ID_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_SKYFLOW_ID_REVEAL
      },
      INVALID_TABLE_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_REVEAL
      },
      INVALID_COLUMN_NAME_REVEAL: {
        code: 400,
        description: R.errorLogs.INVALID_COLUMN_NAME_REVEAL
      },
      EMPTY_SKYFLOW_ID_REVEAL: {
        code: 400,
        description: R.errorLogs.EMPTY_SKYFLOW_ID_REVEAL
      },
      EMPTY_TABLE_REVEAL: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_REVEAL
      },
      EMPTY_COLUMN_NAME_REVEAL: {
        code: 400,
        description: R.errorLogs.EMPTY_COLUMN_NAME_REVEAL
      },
      RECORDS_KEY_NOT_FOUND_GETBYID: {
        code: 400,
        description: R.errorLogs.RECORDS_KEY_NOT_FOUND_GETBYID
      },
      INVALID_RECORDS_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.INVALID_RECORDS_IN_GETBYID
      },
      EMPTY_RECORDS_GETBYID: {
        code: 400,
        description: R.errorLogs.EMPTY_RECORDS_GETBYID
      },
      MISSING_IDS_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.MISSING_IDS_IN_GETBYID
      },
      INVALID_IDS_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.INVALID_IDS_IN_GETBYID
      },
      EMPTY_IDS_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.EMPTY_IDS_IN_GETBYID
      },
      INVALID_SKYFLOWID_TYPE_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.INVALID_SKYFLOWID_TYPE_IN_GETBYID
      },
      MISSING_TABLE_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.MISSING_TABLE_IN_GETBYID
      },
      INVALID_TABLE_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.INVALID_TABLE_IN_GETBYID
      },
      MISSING_REDACTION_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.MISSING_REDACTION_IN_GETBYID
      },
      INVALID_REDACTION_TYPE_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.INVALID_REDACTION_TYPE_IN_GETBYID
      },
      EMPTY_SKYFLOWID_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.EMPTY_SKYFLOWID_IN_GETBYID
      },
      EMPTY_TABLE_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.EMPTY_TABLE_IN_GETBYID
      },
      EMPTY_REDACTION_TYPE_IN_GETBYID: {
        code: 400,
        description: R.errorLogs.EMPTY_REDACTION_TYPE_IN_GETBYID
      },
      MISSING_COMPOSABLE_LAYOUT_KEY: {
        code: 400,
        description: R.errorLogs.MISSING_COMPOSABLE_LAYOUT_KEY
      },
      EMPTY_COMPOSABLE_LAYOUT_ARRAY: {
        code: 400,
        description: R.errorLogs.EMPTY_COMPOSABLE_LAYOUT_ARRAY
      },
      INVALID_COMPOSABLE_LAYOUT_TYPE: {
        code: 400,
        description: R.errorLogs.INVALID_COMPOSABLE_LAYOUT_TYPE
      },
      NEGATIVE_VALUES_COMPOSABLE_LAYOUT: {
        code: 400,
        description: R.errorLogs.NEGATIVE_VALUES_COMPOSABLE_LAYOUT
      },
      MISMATCH_ELEMENT_COUNT_LAYOUT_SUM: {
        code: 400,
        description: R.errorLogs.MISMATCH_ELEMENT_COUNT_LAYOUT_SUM
      },
      MISSING_COMPOSABLE_CONTAINER_OPTIONS: {
        code: 400,
        description: R.errorLogs.MISSING_COMPOSABLE_CONTAINER_OPTIONS
      },
      INVALID_COMPOSABLE_CONTAINER_OPTIONS: {
        code: 400,
        description: R.errorLogs.INVALID_COMPOSABLE_CONTAINER_OPTIONS
      },
      COMPOSABLE_CONTAINER_NOT_MOUNTED: {
        code: 400,
        description: R.errorLogs.COMPOSABLE_CONTAINER_NOT_MOUNTED
      },
      INVALID_BOOLEAN_OPTIONS: {
        code: 400,
        description: R.errorLogs.INVALID_BOOLEAN_OPTIONS
      },
      INVALID_MASKING_CHARACTER: {
        code: 400,
        description: R.errorLogs.INVALID_MASKING_CHARACTER
      },
      EMPTY_COLLECT_CUSTOM_FORMAT: {
        code: 400,
        description: R.errorLogs.EMPTY_COLLECT_CUSTOM_FORMAT
      },
      INVALID_INPUT_OPTIONS_FORMAT: {
        code: 400,
        description: R.errorLogs.INVALID_INPUT_OPTIONS_FORMAT
      },
      INVALID_INPUT_OPTIONS_TRANSLATION: {
        code: 400,
        description: R.errorLogs.INVALID_INPUT_OPTIONS_TRANSLATION
      },
      INVALID_OPTION_CARD_METADATA: {
        code: 400,
        description: R.errorLogs.INVALID_OPTION_CARD_METADATA
      },
      INVALID_OPTION_CARD_SCHEME: {
        code: 400,
        description: R.errorLogs.INVALID_OPTION_CARD_SCHEME
      },
      INVALID_FIELD_SHOW_3DS_CHALLEGNGE: {
        code: 400,
        description: R.errorLogs.INVALID_FIELD_SHOW_3DS_CHALLEGNGE
      },
      NO_ELEMENTS_IN_COLLECT: {
        code: 400,
        description: R.errorLogs.NO_ELEMENTS_IN_COLLECT
      },
      NO_ELEMENTS_IN_COMPOSABLE: {
        code: 400,
        description: R.errorLogs.NO_ELEMENTS_IN_COMPOSABLE
      },
      NO_ELEMENTS_IN_REVEAL: {
        code: 400,
        description: R.errorLogs.NO_ELEMENTS_IN_REVEAL
      }
    };
    function ut(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            o,
            i,
            a,
            c = [],
            l = !0,
            s = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              l = !1;
            } else for (; !(l = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); l = !0);
          } catch (e) {
            s = !0, o = e;
          } finally {
            try {
              if (!l && null != n.return && (a = n.return(), Object(a) !== a)) return;
            } finally {
              if (s) throw o;
            }
          }
          return c;
        }
      }(e, t) || ze(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    var dt = function () {
        var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").replace(/[\s-]/g, ""),
          t = xe.DEFAULT;
        return Object.entries(Fe).forEach(function (n) {
          var r = ut(n, 2),
            o = r[0];
          r[1].regex.test(e) && (t = o);
        }), t;
      },
      ft = function (e, t) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "records")) throw new Gt(pt.RECORDS_KEY_NOT_FOUND, [], !0);
        var n = e.records;
        if (!n || !Array.isArray(n)) throw new Gt(pt.INVALID_RECORDS_IN_INSERT, [], !0);
        if (0 === n.length) throw new Gt(pt.EMPTY_RECORDS_IN_INSERT, [], !0);
        if (n.forEach(function (e, t) {
          if (!e || !Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_IN_INSERT, ["".concat(t)], !0);
          if (!e.table) throw new Gt(pt.EMPTY_TABLE_IN_INSERT, ["".concat(t)], !0);
          if (!("string" == typeof e.table || e.table instanceof String)) throw new Gt(pt.INVALID_TABLE_IN_INSERT, ["".concat(t)], !0);
          if (!Object.prototype.hasOwnProperty.call(e, "fields")) throw new Gt(pt.MISSING_FIELDS_IN_INSERT, ["".concat(t)], !0);
          if (!e.fields) throw new Gt(pt.EMPTY_FIELDS_IN_INSERT, ["".concat(t)], !0);
          if ("object" !== a(e.fields) || Array.isArray(e.fields)) throw new Gt(pt.INVALID_FIELDS_IN_INSERT, ["".concat(t)], !0);
        }), t && t.tokens && "boolean" != typeof t.tokens) throw new Gt(pt.INVALID_TOKENS_IN_INSERT, [], !0);
      },
      Et = function (e) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "records")) throw new Gt(pt.RECORDS_KEY_NOT_FOUND_IN_ADDITIONAL_FIELDS, [], !0);
        var t = e.records;
        if (!t || !Array.isArray(t)) throw new Gt(pt.INVALID_RECORDS_IN_ADDITIONAL_FIELDS, [], !0);
        if (0 === t.length) throw new Gt(pt.EMPTY_RECORDS_IN_ADDITIONAL_FIELDS, [], !0);
        t.forEach(function (e, t) {
          var n;
          if (!e || !Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
          if (!e.table) throw new Gt(pt.EMPTY_TABLE_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
          if (void 0 !== (null === (n = e.fields) || void 0 === n ? void 0 : n.skyflowID)) {
            var r, o, i;
            if (null === (r = e.fields) || void 0 === r || !r.skyflowID) throw new Gt(pt.EMPTY_SKYFLOW_ID_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
            if (!("string" == typeof (null === (o = e.fields) || void 0 === o ? void 0 : o.skyflowID) || (null === (i = e.fields) || void 0 === i ? void 0 : i.skyflowID) instanceof String)) throw new Gt(pt.INVALID_SKYFLOW_ID_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
          }
          if (!("string" == typeof e.table || e.table instanceof String)) throw new Gt(pt.INVALID_TABLE_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
          if (!Object.prototype.hasOwnProperty.call(e, "fields")) throw new Gt(pt.MISSING_FIELDS_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
          if (!e.fields) throw new Gt(pt.EMPTY_FIELDS_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
          if ("object" !== a(e.fields) || Array.isArray(e.fields)) throw new Gt(pt.INVALID_FIELDS_IN_ADDITIONAL_FIELDS, ["".concat(t)], !0);
        });
      },
      _t = function (e) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "records")) throw new Gt(pt.RECORDS_KEY_NOT_FOUND_DETOKENIZE, []);
        var t = e.records;
        if (!t || !Array.isArray(t)) throw new Gt(pt.INVALID_RECORDS_IN_DETOKENIZE, []);
        if (0 === t.length) throw new Gt(pt.EMPTY_RECORDS_DETOKENIZE, []);
        t.forEach(function (e, t) {
          if (!e || !Object.prototype.hasOwnProperty.call(e, "token")) throw new Gt(pt.MISSING_TOKEN_IN_DETOKENIZE, ["".concat(t)]);
          if (!e.token) throw new Gt(pt.EMPTY_TOKEN_IN_DETOKENIZE, ["".concat(t)]);
          if (!("string" == typeof e.token || e.token instanceof String)) throw new Gt(pt.INVALID_TOKEN_IN_DETOKENIZE, ["".concat(t)]);
          var n = e.redaction;
          if (n && !Object.values(rt).includes(n)) throw new Gt(pt.INVALID_REDACTION_TYPE_IN_DETOKENIZE, ["".concat(t)]);
        });
      },
      mt = function (e, t) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "records")) throw new Gt(pt.RECORDS_KEY_NOT_FOUND_GET, []);
        var n = e.records;
        if (!n || !Array.isArray(n)) throw new Gt(pt.INVALID_RECORDS_IN_GET, []);
        if (0 === n.length) throw new Gt(pt.EMPTY_RECORDS_GET, []);
        if (t && Object.prototype.hasOwnProperty.call(t, "tokens") && "boolean" != typeof (null == t ? void 0 : t.tokens)) throw new Gt(pt.INVALID_TOKENS_IN_GET, []);
        n.forEach(function (e, n) {
          var r, o, i;
          if (0 === Object.keys(e).length) throw new Gt(pt.EMPTY_RECORDS_GET, []);
          if (0 === (null === (r = e.ids) || void 0 === r ? void 0 : r.length)) throw new Gt(pt.EMPTY_IDS_IN_GET, ["".concat(n)]);
          if (!(null == e.ids || e.ids && Array.isArray(e.ids))) throw new Gt(pt.INVALID_IDS_IN_GET, ["".concat(n)]);
          if (null === (o = e.ids) || void 0 === o || o.forEach(function (e) {
            if (!e) throw new Gt(pt.EMPTY_SKYFLOWID_IN_GET, ["".concat(n)]);
            if (!("string" == typeof e || e instanceof String)) throw new Gt(pt.INVALID_SKYFLOWID_TYPE_IN_GET, ["".concat(n)]);
          }), !Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_IN_GET, ["".concat(n)]);
          if (!e.table) throw new Gt(pt.EMPTY_TABLE_IN_GET, ["".concat(n)]);
          if (!("string" == typeof e.table || e.table instanceof String)) throw new Gt(pt.INVALID_TABLE_IN_GET, ["".concat(n)]);
          if (!t || !Object.prototype.hasOwnProperty.call(t, "tokens") || !0 !== (null == t ? void 0 : t.tokens)) {
            if (!Object.prototype.hasOwnProperty.call(e, "redaction")) throw new Gt(pt.MISSING_REDACTION_IN_GET, ["".concat(n)]);
            if (!e.redaction) throw new Gt(pt.EMPTY_REDACTION_TYPE_IN_GET, ["".concat(n)]);
            if (!Object.values(rt).includes(e.redaction)) throw new Gt(pt.INVALID_REDACTION_TYPE_IN_GET, ["".concat(n)]);
          }
          if (!0 === Object.prototype.hasOwnProperty.call(e, "ids") && !0 === Object.prototype.hasOwnProperty.call(e, "columnName")) throw new Gt(pt.SKYFLOW_IDS_AND_COLUMN_NAME_BOTH_SPECIFIED, ["".concat(n)]);
          if (Object.prototype.hasOwnProperty.call(e, "columnName")) {
            if (!Object.prototype.hasOwnProperty.call(e, "columnName") || !Object.prototype.hasOwnProperty.call(e, "columnValues")) throw new Gt(pt.MISSING_RECORD_COLUMN_VALUE, ["".concat(n)]);
          } else if (!1 === Object.prototype.hasOwnProperty.call(e, "ids") && !1 === Object.prototype.hasOwnProperty.call(e, "columnValues")) throw new Gt(pt.MISSING_IDS_OR_COLUMN_VALUES_IN_GET, ["".concat(n)]);
          if (0 === (null === (i = e.columnValues) || void 0 === i ? void 0 : i.length)) throw new Gt(pt.EMPTY_RECORD_COLUMN_VALUES, ["".concat(n)]);
          if (!(null == e.columnValues || e.columnValues && Array.isArray(e.columnValues))) throw new Gt(pt.INVALID_COLUMN_VALUES_IN_GET, ["".concat(n)]);
          if (void 0 !== e.columnName && void 0 === e.columnValues) throw new Gt(pt.MISSING_RECORD_COLUMN_VALUE, ["".concat(n)]);
          if (void 0 === e.columnName && void 0 !== e.columnValues) throw new Gt(pt.MISSING_RECORD_COLUMN_NAME, ["".concat(n)]);
          var a = e.columnName;
          if (null != a && "string" != typeof a) throw new Gt(pt.INVALID_RECORD_COLUMN_VALUE, ["".concat(n)]);
          var c = e.columnValues;
          if (null != c) {
            if (0 === c.length || null === c) throw new Gt(pt.EMPTY_RECORD_COLUMN_VALUES, ["".concat(n)]);
            c.forEach(function (e) {
              if ("" === e || null === e) throw new Gt(pt.EMPTY_COLUMN_VALUE, ["".concat(n)]);
              if ("string" != typeof e) throw new Gt(pt.INVALID_RECORD_COLUMN_VALUE_TYPE, ["".concat(n)]);
            });
          }
          if (t && Object.prototype.hasOwnProperty.call(t, "tokens") && !0 === (null == t ? void 0 : t.tokens)) {
            if (a || c) throw new Gt(pt.TOKENS_GET_COLUMN_NOT_SUPPORTED, []);
            if (e.redaction) throw new Gt(pt.REDACTION_WITH_TOKENS_NOT_SUPPORTED, []);
          }
        });
      },
      vt = function (e) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "records")) throw new Gt(pt.RECORDS_KEY_NOT_FOUND_GETBYID, []);
        var t = e.records;
        if (!t || !Array.isArray(t)) throw new Gt(pt.INVALID_RECORDS_IN_GETBYID, []);
        if (0 === t.length) throw new Gt(pt.EMPTY_RECORDS_GETBYID, []);
        t.forEach(function (e, t) {
          if (!e || !Object.prototype.hasOwnProperty.call(e, "ids")) throw new Gt(pt.MISSING_IDS_IN_GETBYID, ["".concat(t)]);
          if (!e.ids || !Array.isArray(e.ids)) throw new Gt(pt.INVALID_IDS_IN_GETBYID, ["".concat(t)]);
          if (0 === e.ids.length) throw new Gt(pt.EMPTY_IDS_IN_GETBYID, ["".concat(t)]);
          if (e.ids.forEach(function (e) {
            if (!e) throw new Gt(pt.EMPTY_SKYFLOWID_IN_GETBYID, ["".concat(t)]);
            if (!("string" == typeof e || e instanceof String)) throw new Gt(pt.INVALID_SKYFLOWID_TYPE_IN_GETBYID, ["".concat(t)]);
          }), !Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_IN_GETBYID, ["".concat(t)]);
          if (!e.table) throw new Gt(pt.EMPTY_TABLE_IN_GETBYID, ["".concat(t)]);
          if (!("string" == typeof e.table || e.table instanceof String)) throw new Gt(pt.INVALID_TABLE_IN_GETBYID, ["".concat(t)]);
          if (!Object.prototype.hasOwnProperty.call(e, "redaction")) throw new Gt(pt.MISSING_REDACTION_IN_GETBYID, ["".concat(t)]);
          if (!e.redaction) throw new Gt(pt.EMPTY_REDACTION_TYPE_IN_GETBYID, ["".concat(t)]);
          if (!Object.values(rt).includes(e.redaction)) throw new Gt(pt.INVALID_REDACTION_TYPE_IN_GETBYID, ["".concat(t)]);
        });
      },
      It = function (e, t) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "records")) throw new Gt(pt.RECORDS_KEY_NOT_FOUND_DELETE, [], !0);
        var n = e.records;
        if (!n || !Array.isArray(n)) throw new Gt(pt.INVALID_RECORDS_IN_DELETE, [], !0);
        if (0 === n.length) throw new Gt(pt.EMPTY_RECORDS_IN_DELETE, [], !0);
        n.forEach(function (e, t) {
          if (!e || !Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_IN_DELETE, ["".concat(t)], !0);
          if (!e.table) throw new Gt(pt.EMPTY_TABLE_IN_DELETE, ["".concat(t)], !0);
          if (!("string" == typeof e.table || e.table instanceof String)) throw new Gt(pt.INVALID_TABLE_IN_DELETE, ["".concat(t)], !0);
          if (!Object.prototype.hasOwnProperty.call(e, "id")) throw new Gt(pt.MISSING_ID_IN_DELETE, ["".concat(t)], !0);
          if (!e.id) throw new Gt(pt.EMPTY_ID_IN_DELETE, ["".concat(t)], !0);
          if (!("string" == typeof e.id || e.id instanceof String)) throw new Gt(pt.INVALID_ID_IN_DELETE, ["".concat(t)], !0);
        });
      },
      yt = function (e) {
        if (0 === e.length) throw new Gt(pt.EMPTY_RECORDS_REVEAL, []);
        e.forEach(function (e) {
          if (!e || !Object.prototype.hasOwnProperty.call(e, "skyflowID")) {
            if (!e || !Object.prototype.hasOwnProperty.call(e, "token")) throw new Gt(pt.MISSING_TOKEN_KEY_REVEAL, []);
            if (!e.token) throw new Gt(pt.EMPTY_TOKEN_ID_REVEAL, []);
            if (!("string" == typeof e.token || e.token instanceof String)) throw new Gt(pt.INVALID_TOKEN_ID_REVEAL, []);
          }
          var t = e.redaction;
          if (t && !Object.values(rt).includes(t)) throw new Gt(pt.INVALID_REDACTION_TYPE_REVEAL, []);
          if (Object.prototype.hasOwnProperty.call(e, "label") && "string" != typeof e.label) throw new Gt(pt.INVALID_LABEL_REVEAL, []);
          if (Object.prototype.hasOwnProperty.call(e, "altText") && "string" != typeof e.altText) throw new Gt(pt.INVALID_ALT_TEXT_REVEAL, []);
          if (Object.prototype.hasOwnProperty.call(e, "format") && "string" != typeof e.format) throw new Gt(pt.INVALID_FORMAT_REVEAL, []);
          if (Object.prototype.hasOwnProperty.call(e, "format") && "" === e.format) throw new Gt(pt.EMPTY_FORMAT_REVEAL, []);
        });
      },
      Ot = function (e) {
        if (!e || !Object.prototype.hasOwnProperty.call(e, "skyflowID")) throw new Gt(pt.MISSING_SKYFLOWID_KEY_REVEAL, []);
        if (!e.skyflowID) throw new Gt(pt.EMPTY_SKYFLOW_ID_REVEAL, []);
        if (Object.prototype.hasOwnProperty.call(e, "skyflowID") && "string" != typeof e.skyflowID) throw new Gt(pt.INVALID_SKYFLOW_ID_REVEAL, []);
        if (Object.prototype.hasOwnProperty.call(e, "skyflowID") && Object.prototype.hasOwnProperty.call(e, "token")) throw new Gt(pt.SKYFLOW_IDS_AND_TOKEN_BOTH_SPECIFIED, []);
        if (!e || !Object.prototype.hasOwnProperty.call(e, "column")) throw new Gt(pt.MISSING_COLUMN_KEY_REVEAL, []);
        if (!e.column) throw new Gt(pt.EMPTY_COLUMN_NAME_REVEAL, []);
        if (Object.prototype.hasOwnProperty.call(e, "column") && "string" != typeof e.column) throw new Gt(pt.INVALID_COLUMN_NAME_REVEAL, []);
        if (!e || !Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_KEY_REVEAL, []);
        if (!e.table) throw new Gt(pt.EMPTY_TABLE_REVEAL, []);
        if (Object.prototype.hasOwnProperty.call(e, "table") && "string" != typeof e.table) throw new Gt(pt.INVALID_TABLE_REVEAL, []);
        if (Object.prototype.hasOwnProperty.call(e, "altText") && "string" != typeof e.altText) throw new Gt(pt.INVALID_ALT_TEXT_RENDER, []);
      },
      gt = function (e) {
        if (!e || "https" !== e.substring(0, 5).toLowerCase()) return !1;
        try {
          if (new URL(e)) return !0;
        } catch (e) {
          return !1;
        }
        return !0;
      },
      Nt = function (e) {
        var t = !0;
        try {
          new RegExp(e);
        } catch (e) {
          t = !1;
        }
        return t;
      },
      Lt = function (e) {
        if (!Object.prototype.hasOwnProperty.call(e, "vaultID")) throw new Gt(pt.VAULTID_IS_REQUIRED, [], !0);
        if (!e.vaultID) throw new Gt(pt.EMPTY_VAULTID_IN_INIT, [], !0);
        if (!Object.prototype.hasOwnProperty.call(e, "vaultURL")) throw new Gt(pt.VAULTURL_IS_REQUIRED, [], !0);
        if (!e.vaultURL) throw new Gt(pt.EMPTY_VAULTURL_IN_INIT, [], !0);
        if (e.vaultURL && !gt(e.vaultURL)) throw new Gt(pt.INVALID_VAULTURL_IN_INIT, [], !0);
        if (!Object.prototype.hasOwnProperty.call(e, "getBearerToken")) throw new Gt(pt.GET_BEARER_TOKEN_IS_REQUIRED, [], !0);
      },
      Tt = function (e, t) {
        if (!Object.prototype.hasOwnProperty.call(e, "type")) throw new Gt(pt.MISSING_ELEMENT_TYPE, [], !0);
        if (!e.type) throw new Gt(pt.EMPTY_ELEMENT_TYPE, [], !0);
        if (Object.prototype.hasOwnProperty.call(e, "altText") && Ut(R.warnLogs.COLLECT_ALT_TEXT_DEPERECATED, lt.WARN, t), Object.prototype.hasOwnProperty.call(e, "skyflowID") && "string" != typeof e.skyflowID) throw new Gt(pt.INVALID_SKYFLOWID_IN_COLLECT, [], !0);
        if (e.type === De.FILE_INPUT && !Object.keys(e).includes("skyflowID")) throw new Gt(pt.MISSING_SKYFLOWID_IN_COLLECT, [], !0);
      },
      ht = function (e) {
        if (!e || !Array.isArray(e)) throw new Gt(pt.INVALID_UPSERT_OPTION_TYPE, [], !0);
        if (!e.length) throw new Gt(pt.EMPTY_UPSERT_OPTIONS_ARRAY, [], !0);
        e.forEach(function (e, t) {
          if (!e || "object" !== a(e)) throw new Gt(pt.INVALID_UPSERT_OPTION_OBJECT_TYPE, [t], !0);
          if (!Object.prototype.hasOwnProperty.call(e, "table")) throw new Gt(pt.MISSING_TABLE_IN_UPSERT_OPTION, [t], !0);
          if (!e.table || "string" != typeof e.table || !e.table.length) throw new Gt(pt.INVALID_TABLE_IN_UPSERT_OPTION, [t], !0);
          if (!Object.prototype.hasOwnProperty.call(e, "column")) throw new Gt(pt.MISSING_COLUMN_IN_UPSERT_OPTION, [t], !0);
          if (!e.column || "string" != typeof e.column || !e.column.length) throw new Gt(pt.INVALID_COLUMN_IN_UPSERT_OPTION, [t], !0);
        });
      },
      bt = function (e) {
        return "boolean" == typeof e;
      },
      At = function (e) {
        if (e) {
          if (Object.prototype.hasOwnProperty.call(e, "format") && "string" != typeof e.format) throw new Gt(pt.INVALID_INPUT_OPTIONS_FORMAT, [], !0);
          if (Object.prototype.hasOwnProperty.call(e, "translation") && ("object" !== a(e.translation) || "[object Object]" !== Object.prototype.toString.call(e.translation))) throw new Gt(pt.INVALID_INPUT_OPTIONS_TRANSLATION, [], !0);
        }
      };
    const wt = {
        IFRAME_SECURE_SITE: "".concat("https://js.skyflow.com", "/").concat("v2.4.1/elements/index.html"),
        IFRAME_SECURE_ORIGIN: "https://js.skyflow.com"
      },
      Rt = JSON.parse('{"name":"skyflow-js","preferGlobal":true,"analyze":false,"version":"2.4.1","author":"Skyflow","description":"Skyflow JavaScript SDK","homepage":"https://github.com/skyflowapi/skyflow-js","main":"./dist/sdkNodeBuild/index.js","types":"./types/index-node.d.ts","files":["dist/sdkNodeBuild","types"],"license":"MIT","keywords":["client","sdk","javascript"],"scripts":{"type-check":"tsc --noEmit","type-check:watch":"npm run type-check -- --watch","build:types":"tsc --emitDeclarationOnly","dev":"webpack serve --config=webpack.dev.js --open --hot ","build-browser-sdk":"webpack --config=webpack.skyflow-browser.js","build-node-sdk":"webpack --config=webpack.skyflow-node.js","build-iframe":"webpack --config=webpack.iframe.js","test":"jest --config=jest.config.json"},"repository":{"type":"git","url":"https://github.com/skyflowapi/skyflow-js.git"},"dependencies":{"core-js":"^3.6.5","framebus":"^4.0.0","inject-stylesheet":"^2.0.0","jquery":"^3.5.1","jquery-mask-plugin":"^1.14.16","jss":"^10.7.1","jss-preset-default":"^10.7.1","jwt-decode":"^3.1.2","lodash":"^4.17.21","mime":"3.0.0","regex-parser":"^2.2.11","set-value":"^4.0.1"},"engines":{"node":">=12.0","npm":">=6.0"},"devDependencies":{"@babel/core":"^7.23.2","@babel/plugin-proposal-class-properties":"^7.10.1","@babel/plugin-proposal-decorators":"^7.10.1","@babel/plugin-proposal-object-rest-spread":"^7.10.1","@babel/plugin-transform-runtime":"^7.10.1","@babel/preset-env":"^7.9.6","@babel/preset-typescript":"^7.10.1","@babel/runtime":"^7.10.2","@types/jest":"^27.0.1","@types/jquery-mask-plugin":"^1.14.3","@types/mime":"^3.0.4","@types/node":"^14.0.5","@typescript-eslint/eslint-plugin":"^4.31.2","@typescript-eslint/parser":"^4.31.2","babel-loader":"^9.1.2","clean-webpack-plugin":"^4.0.0-alpha.0","compression-webpack-plugin":"^8.0.1","eslint":"^7.32.0","eslint-config-airbnb-base":"^14.2.1","eslint-config-airbnb-typescript":"^14.0.0","eslint-plugin-import":"^2.26.0","fork-ts-checker-webpack-plugin":"^6.3.2","html-webpack-plugin":"^5.5.0","jest":"^27.2.1","node-polyfill-webpack-plugin":"^2.0.1","typescript":"^4.6.3","webpack":"^5.97.1","webpack-bundle-analyzer":"^4.4.2","webpack-cli":"^4.8.0","webpack-dev-server":"^4.7.4","webpack-manifest-plugin":"^4.0.2","webpack-merge":"^5.8.0"}}');
    function St(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Dt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? St(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : St(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    n(125).getType;
    function xt(e) {
      var t = null == e ? void 0 : e.split(":");
      return t && t.length > 2 ? "".concat(t[0], ":").concat(t[1], ":").concat(t[2]) : "";
    }
    function Mt(e, t, n) {
      var r,
        o,
        i,
        a,
        c,
        l,
        s = {
          sdkName: e.name,
          sdkVersion: e.version
        },
        p = function (e, t) {
          return e && "" !== e ? "".concat(e) : "".concat(t.sdkName, "@").concat(t.sdkVersion);
        }(null == t ? void 0 : t.sdkVersion, s),
        u = function (e) {
          var t,
            n,
            r = null,
            o = null;
          if (/Windows/.test(e)) r = "Windows", o = null !== (t = null === (n = /Windows NT (\d+\.\d+)/.exec(e)) || void 0 === n ? void 0 : n[1]) && void 0 !== t ? t : null;else if (/Android/.test(e)) {
            var i, a;
            r = "Android", o = null !== (i = null === (a = /Android (\d+\.\d+)/.exec(e)) || void 0 === a ? void 0 : a[1]) && void 0 !== i ? i : null;
          } else if (/iOS/.test(e) || /iPhone/.test(e)) {
            var c, l;
            r = "iOS", o = null !== (c = null === (l = /OS (\d+[._]\d+[._]?\d*)/.exec(e)) || void 0 === l || null === (l = l[1]) || void 0 === l ? void 0 : l.replace(/_/g, ".")) && void 0 !== c ? c : null;
          } else if (/Mac OS X/.test(e)) {
            var s, p;
            r = "Mac OS X", o = null !== (s = null === (p = /Mac OS X (\d+([._]\d+)*)/.exec(e)) || void 0 === p || null === (p = p[1]) || void 0 === p ? void 0 : p.replace(/_/g, ".")) && void 0 !== s ? s : null;
          } else if (/Linux/.test(e)) {
            var u, d;
            r = "Linux", o = null !== (u = null === (d = /Linux( \w+)*?\/([\w.]+)/.exec(e)) || void 0 === d ? void 0 : d[2]) && void 0 !== u ? u : null;
          }
          return {
            os: r,
            version: o
          };
        }(n.userAgent),
        d = function (e) {
          var t = "",
            n = "";
          if (-1 !== e.indexOf("MSIE") || -1 !== e.indexOf("Trident/")) {
            t = "Internet Explorer";
            var r = e.match(/(MSIE|rv:)\s?([\d.]+)/);
            r && (n = r[2]);
          } else if (-1 !== e.indexOf("Edge")) {
            t = "Microsoft Edge";
            var o = e.match(/Edge\/([\d.]+)/);
            o && (n = o[1]);
          } else if (-1 !== e.indexOf("Chrome")) {
            t = "Google Chrome";
            var i = e.match(/Chrome\/([\d.]+)/);
            i && (n = i[1]);
          } else if (-1 !== e.indexOf("Firefox")) {
            t = "Mozilla Firefox";
            var a = e.match(/Firefox\/([\d.]+)/);
            a && (n = a[1]);
          } else if (-1 !== e.indexOf("Safari")) {
            t = "Apple Safari";
            var c = e.match(/Version\/([\d.]+)/);
            c && (n = c[1]);
          }
          return {
            browserName: t,
            browserVersion: n
          };
        }(n.userAgent);
      return {
        sdk_name_version: p,
        sdk_client_device_model: (l = n.userAgent, /(ipad|tablet)/gi.test(l) ? "tablet" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile/.test(l) ? "mobile" : "desktop"),
        sdk_os_version: null !== (r = n.platform) && void 0 !== r ? r : "".concat(null !== (o = u.os) && void 0 !== o ? o : "", " ").concat(null !== (i = u.version) && void 0 !== i ? i : ""),
        sdk_runtime_details: "".concat(null !== (a = d.browserName) && void 0 !== a ? a : "", " ").concat(null !== (c = d.browserVersion) && void 0 !== c ? c : "")
      };
    }
    var Pt = function () {
        var e = function (e) {
            var t = {
              sdkName: Rt.name,
              sdkVersion: Rt.version
            };
            return e && "" !== e && e.split("@").length > 1 && (t.sdkName = e.split("@")[0], t.sdkVersion = e.split("@")[1]), t;
          }(localStorage.getItem("sdk_version") || ""),
          t = "skyflow-js" === e.sdkName ? "JS" : "React";
        return {
          sdkLanguageAndVersion: "".concat(t, " SDK v").concat(e.sdkVersion),
          sdkOwner: "Skyflow"
        };
      },
      Ct = n(6763),
      kt = {
        DEBUG: {
          showDebugLogs: !0,
          showInfoLogs: !0,
          showWarnLogs: !0,
          showErrorLogs: !0
        },
        INFO: {
          showDebugLogs: !1,
          showInfoLogs: !0,
          showWarnLogs: !0,
          showErrorLogs: !0
        },
        WARN: {
          showDebugLogs: !1,
          showInfoLogs: !1,
          showWarnLogs: !0,
          showErrorLogs: !0
        },
        ERROR: {
          showDebugLogs: !1,
          showInfoLogs: !1,
          showWarnLogs: !1,
          showErrorLogs: !0
        }
      },
      Vt = {
        PROD: {
          doesReturnValue: !1
        },
        DEV: {
          doesReturnValue: !0
        }
      },
      jt = "[Skyflow]",
      Ut = function (e, t, n) {
        var r = Pt(),
          o = r.sdkLanguageAndVersion,
          i = r.sdkOwner;
        if (n && kt[n]) {
          var a = kt[n],
            c = a.showDebugLogs,
            l = a.showInfoLogs,
            s = a.showWarnLogs,
            p = a.showErrorLogs;
          t === lt.LOG && c ? Ct.log("".concat(at.DEBUG, ": ").concat(jt, " ").concat(e)) : t === lt.LOG && l ? Ct.log("".concat(at.INFO, ": ").concat(jt, " ").concat(e)) : t === lt.WARN && s ? Ct.warn("".concat(at.WARN, ": ").concat(jt, " ").concat(e)) : t === lt.ERROR && p && Ct.error("".concat(at.ERROR, ": ").concat(i, " ").concat(o, " ").concat(e));
        }
      },
      Ft = function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        var r = t[0],
          o = t.filter(function (e, t) {
            return 0 !== t;
          });
        return r ? r.replace(/%s[0-9]+/g, function (e) {
          var t = e.replace("%s", "") - 1;
          return o[t];
        }) : "";
      };
    function Yt(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = et(e);
        if (t) {
          var o = et(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return Qe(this, n);
      };
    }
    var Gt = function (e) {
      $e(n, e);
      var t = Yt(n);
      function n(e, r) {
        var o,
          i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        s(this, n);
        var a = {
          code: e.code,
          description: r && (null == r ? void 0 : r.length) > 0 ? Ft.apply(void 0, [e.description].concat(He(r))) : e.description
        };
        return l(Je(o = t.call(this, a.description)), "error", void 0), l(Je(o), "errors", void 0), i ? o.error = a : o.errors = [a], o;
      }
      return u(n);
    }(nt(Error));
    function Bt(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Xt(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var Wt = new WeakMap(),
      Kt = function () {
        function e(t, n) {
          var r = this;
          s(this, e), l(this, "config", void 0), Xt(this, Wt, {
            writable: !0,
            value: void 0
          }), l(this, "request", function (e) {
            return new Promise(function (t, n) {
              var o,
                i,
                a = new XMLHttpRequest();
              if (a) {
                if (a.open(e.requestMethod, e.url), e.headers) {
                  var c = Mt(Rt, E(r, Wt), navigator);
                  e.headers["sky-metadata"] = JSON.stringify(c);
                  var s = e.headers;
                  Object.keys(e.headers).forEach(function (e) {
                    "content-type" === e && s[e] && s[e].includes(Xe.FORMDATA) || a.setRequestHeader(e, s[e]);
                  });
                }
                null !== (o = e.headers) && void 0 !== o && null !== (o = o["content-type"]) && void 0 !== o && o.includes(Xe.FORMURLENCODED) || null !== (i = e.headers) && void 0 !== i && null !== (i = i["content-type"]) && void 0 !== i && i.includes(Xe.FORMDATA) ? a.send(e.body) : a.send(JSON.stringify(function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Bt(Object(n), !0).forEach(function (t) {
                      l(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bt(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                  }
                  return e;
                }({}, e.body))), a.onload = function () {
                  var e = a.getAllResponseHeaders().trim().split(/[\r\n]+/),
                    r = {};
                  e.forEach(function (e) {
                    var t = e.split(": "),
                      n = t.shift() || "",
                      o = t.join(": ");
                    r[n] = o;
                  });
                  var o = r["content-type"],
                    i = r["x-request-id"];
                  if (a.status < 200 || a.status >= 400) if (o && o.includes("application/json")) {
                    var c,
                      l,
                      s,
                      p = JSON.parse(a.response);
                    if (null !== (c = p) && void 0 !== c && null !== (c = c.error) && void 0 !== c && c.message) p = i ? "".concat(null === (l = p) || void 0 === l || null === (l = l.error) || void 0 === l ? void 0 : l.message, " - requestId: ").concat(i) : null === (s = p) || void 0 === s || null === (s = s.error) || void 0 === s ? void 0 : s.message;
                    n(new Gt({
                      code: a.status,
                      description: p
                    }, [], !0));
                  } else o && o.includes("text/plain") ? n(new Gt({
                    code: a.status,
                    description: i ? "".concat(a.response, " - requestId: ").concat(i) : a.response
                  }, [], !0)) : n(new Gt({
                    code: a.status,
                    description: i ? "".concat(R.errorLogs.ERROR_OCCURED, " - requestId: ").concat(i) : R.errorLogs.ERROR_OCCURED
                  }, [], !0));
                  o && o.includes("application/json") && t(JSON.parse(a.response)), t(a.response);
                }, a.onerror = function () {
                  n(new Gt(pt.NETWORK_ERROR, [], !0));
                };
              } else n(new Gt(pt.CONNECTION_ERROR, [], !0));
            });
          }), this.config = t, f(this, Wt, n);
        }
        return u(e, [{
          key: "toJSON",
          value: function () {
            return {
              config: this.config,
              metaData: E(this, Wt)
            };
          }
        }], [{
          key: "fromJSON",
          value: function (t) {
            return new e(t.config, t.metaData);
          }
        }]), e;
      }();
    const qt = Kt;
    const zt = function () {
      function e() {
        s(this, e), l(this, "events", void 0), this.events = {};
      }
      return u(e, [{
        key: "on",
        value: function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          this.events[e] ? this.events[e].push({
            priority: n,
            callback: t
          }) : this.events[e] = [{
            priority: n,
            callback: t
          }];
        }
      }, {
        key: "off",
        value: function (e, t) {
          var n = this.events[e];
          if (n) {
            var r = n.findIndex(function (e) {
              return e.callback === t;
            });
            n.splice(r, 1);
          }
        }
      }, {
        key: "_emit",
        value: function (e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          var o = this.events[e];
          o && o.forEach(function (e) {
            e.callback.apply(e, n);
          });
        }
      }, {
        key: "hasListener",
        value: function (e) {
          var t = this.events[e];
          return !!t && t.length > 0;
        }
      }, {
        key: "resetEvents",
        value: function () {
          var e = this,
            t = {};
          Object.keys(this.events).forEach(function (n) {
            var r = e.events[n];
            if (r && r.length > 0) {
              var o = [];
              r.forEach(function (e) {
                e.priority && o.push(e);
              }), t[n] = o;
            }
          }), this.events = t;
        }
      }], [{
        key: "createChild",
        value: function (t) {
          t.prototype = Object.create(e.prototype, {
            constructor: t
          });
        }
      }]), e;
    }();
    function Ht(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Jt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ht(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ht(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var Zt = {
        src: "about:blank",
        frameBorder: 0,
        allowtransparency: !0,
        scrolling: "no",
        style: "width: 100%;",
        allow: "clipboard-read; clipboard-write"
      },
      $t = function (e, t) {
        Object.keys(t).forEach(function (n) {
          if (Object.prototype.hasOwnProperty.call(t, n)) {
            var r = t[n];
            null == r ? e.removeAttribute(n) : e.setAttribute(n, r);
          }
        });
      };
    const Qt = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = document.createElement("iframe"),
        n = Jt(Jt({}, Zt), e);
      return Object.assign(t.style, ke), $t(t, n), t.getAttribute("id") || (t.id = t.name), t;
    };
    var en = function () {
        return wt.IFRAME_SECURE_SITE;
      },
      tn = function (e, t) {
        Object.keys(t).forEach(function (n) {
          Object.prototype.hasOwnProperty.call(t, n) && (e.style[n] = t[n]);
        });
      };
    const nn = u(function e() {
      s(this, e);
    });
    function rn(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function on(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? rn(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rn(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var an = {
      records: []
    };
    function cn(e, t) {
      var n,
        r,
        o,
        i = Mt(Rt, e, navigator),
        a = {
          element_id: t,
          element_type: [],
          div_id: "",
          container_name: "",
          container_id: (null == e ? void 0 : e.uuid) || "",
          session_id: (null == e ? void 0 : e.session_id) || "",
          vault_id: (null == e || null === (n = e.clientJSON) || void 0 === n || null === (n = n.config) || void 0 === n ? void 0 : n.vaultID) || "",
          vault_url: (null == e || null === (r = e.clientJSON) || void 0 === r || null === (r = r.config) || void 0 === r ? void 0 : r.vaultURL) || "",
          events: [],
          created_at: Date.now(),
          region: (null === (o = Intl) || void 0 === o || null === (o = o.DateTimeFormat()) || void 0 === o || null === (o = o.resolvedOptions()) || void 0 === o ? void 0 : o.timeZone) || "",
          status: J.INITIALIZED,
          sdk_name_version: i.sdk_name_version,
          sdk_client_device_model: i.sdk_client_device_model || "",
          sdk_client_os_details: i.sdk_os_version || "",
          sdk_runtime_details: i.sdk_runtime_details || ""
        };
      an.records.push(a);
    }
    function ln(e, t, n) {
      an.records.forEach(function (r) {
        r.element_id === e && (t === K || t === G ? r[t].push(n) : t === z && r.mount_start_time ? (r[t] = n, r.latency = n - r.mount_start_time) : r[t] = n);
      });
    }
    function sn(e) {
      var t = an.records.filter(function (t) {
        return t.element_id === e;
      });
      if (t && t[0]) {
        var n = t[0];
        n.status = function (e) {
          var t = e.status;
          return e.events && e.events.filter(function (e) {
            return e.includes(Y.MOUNTED);
          }).length > 0 ? t = J.SUCCESS : e.events.length > 0 ? t = J.PARTIAL_RENDER : (0 === e.events.length || e.error) && (t = J.FAILED), t;
        }(n);
        var r = on(on({}, n), {}, {
          time: Math.floor(Date.now() / 1e3)
        });
        "" !== n.vault_id && "" !== n.vault_url && m().emit(Le + n.container_id, {
          event: r
        });
      }
    }
    function pn(e) {
      setTimeout(function () {
        sn(e);
      }, 2e4);
    }
    var un = n(6763),
      dn = u(function e(t, n, r, o) {
        var i = this;
        s(this, e), l(this, "name", void 0), l(this, "metadata", void 0), l(this, "iframe", void 0), l(this, "container", void 0), l(this, "mount", function (e, t, n) {
          var r;
          i.unmount();
          try {
            if ("string" == typeof e) {
              if (i.container = document.querySelector(e) || void 0, !i.container) throw new Gt(pt.INVALID_ELEMENT_SELECTOR, [], !0);
            } else {
              if (!(e instanceof HTMLElement)) throw new Gt(pt.INVALID_ELEMENT_SELECTOR, [], !0);
              i.container = e;
            }
          } catch (e) {
            un.error(e), t && ln(t, H, e.message);
          }
          $t(i.iframe, {
            src: "".concat(en()).concat(n ? "?".concat(btoa(null == n ? void 0 : n.record)) : "")
          }), null === (r = i.container) || void 0 === r || r.appendChild(i.iframe);
        }), l(this, "setIframeHeight", function (e) {
          i.iframe.getAttribute("height") !== e && i.iframe.setAttribute("height", "".concat(e, "px"));
        }), l(this, "unmount", function () {
          i.iframe.remove();
        });
        var a = n.clientDomain || "";
        this.name = "".concat(t, ":").concat(r, ":").concat(o, ":").concat(btoa(a)), this.metadata = n, this.iframe = Qt({
          name: this.name,
          referrer: a
        });
      });
    const fn = u(function e() {
      s(this, e);
    });
    n(4756);
    var En = function (e, t) {
      var n = {};
      if (e.fields) {
        var r = {
          skyflow_id: e.fields.skyflow_id,
          column: t
        };
        n.success = r;
      } else e.errors && (n.errors = {
        skyflowId: e.errors.skyflowId,
        column: e.errors.column,
        error: e.errors.error
      });
      return n;
    };
    function _n(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function mn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _n(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _n(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function vn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = et(e);
        if (t) {
          var o = et(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return Qe(this, n);
      };
    }
    function In(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var yn = "RevealElement",
      On = new WeakMap(),
      gn = new WeakMap(),
      Nn = new WeakMap(),
      Ln = new WeakMap(),
      Tn = new WeakMap(),
      hn = new WeakMap(),
      bn = new WeakMap(),
      An = new WeakMap(),
      wn = new WeakMap(),
      Rn = new WeakMap(),
      Sn = new WeakMap(),
      Dn = new WeakMap(),
      xn = new WeakMap(),
      Mn = new WeakMap(),
      Pn = function (e) {
        $e(n, e);
        var t = vn(n);
        function n(e) {
          var r,
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = arguments.length > 2 ? arguments[2] : void 0,
            a = arguments.length > 3 ? arguments[3] : void 0,
            c = arguments.length > 4 ? arguments[4] : void 0,
            l = arguments.length > 5 ? arguments[5] : void 0;
          return s(this, n), In(Je(r = t.call(this)), On, {
            writable: !0,
            value: void 0
          }), In(Je(r), gn, {
            writable: !0,
            value: void 0
          }), In(Je(r), Nn, {
            writable: !0,
            value: void 0
          }), In(Je(r), Ln, {
            writable: !0,
            value: void 0
          }), In(Je(r), Tn, {
            writable: !0,
            value: !1
          }), In(Je(r), hn, {
            writable: !0,
            value: !1
          }), In(Je(r), bn, {
            writable: !0,
            value: void 0
          }), In(Je(r), An, {
            writable: !0,
            value: void 0
          }), In(Je(r), wn, {
            writable: !0,
            value: !1
          }), In(Je(r), Rn, {
            writable: !0,
            value: void 0
          }), In(Je(r), Sn, {
            writable: !0,
            value: void 0
          }), In(Je(r), Dn, {
            writable: !0,
            value: void 0
          }), In(Je(r), xn, {
            writable: !0,
            value: void 0
          }), In(Je(r), Mn, {
            writable: !0,
            value: !1
          }), f(Je(r), An, c), f(Je(r), gn, i), f(Je(r), xn, E(Je(r), gn).uuid), f(Je(r), Nn, mn(mn({}, e), function (e) {
            var t = {};
            if (e) {
              if (t = Dt({}, e), Object.prototype.hasOwnProperty.call(t, "enableCopy") && !bt(t.enableCopy)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["enableCopy"], !0);
              if (Object.prototype.hasOwnProperty.call(t, "format") || Object.prototype.hasOwnProperty.call(t, "translation")) {
                var n,
                  r,
                  o = [];
                t.format && o.push(t.format), o.push(null), t.translation ? o.push(t.translation) : t.format && o.push(Ke), null === (n = t = Dt(Dt({}, t), 3 === o.length ? {
                  mask: o
                } : {})) || void 0 === n || delete n.format, null === (r = t) || void 0 === r || delete r.translation;
              }
            }
            return t;
          }(o))), f(Je(r), Ln, a.containerId), f(Je(r), wn, a.isMounted), f(Je(r), Rn, a.eventEmitter), f(Je(r), bn, l), cn(i, c), ln(E(Je(r), An), G, F.REVEAL), ln(E(Je(r), An), X, F.REVEAL), f(Je(r), On, new dn("".concat("reveal", ":").concat(btoa(v())), i, E(Je(r), Ln), E(Je(r), bn).logLevel)), f(Je(r), Dn, ""), f(Je(r), Sn, !1), f(Je(r), wn, !0), f(Je(r), Mn, i.skyflowContainer.isControllerFrameReady), m().on(ae.HEIGHT + E(Je(r), On).name, function (e) {
            E(Je(r), On).setIframeHeight(e.height);
          }), r;
        }
        return u(n, [{
          key: "getID",
          value: function () {
            return E(this, An);
          }
        }, {
          key: "mount",
          value: function (e) {
            var t,
              n,
              r = this;
            if (!e) throw new Gt(pt.EMPTY_ELEMENT_IN_MOUNT, ["RevealElement"], !0);
            ln(E(this, An), B, e), null !== (t = E(this, gn)) && void 0 !== t && null !== (t = t.clientJSON) && void 0 !== t && null !== (t = t.config) && void 0 !== t && null !== (t = t.options) && void 0 !== t && t.trackMetrics && null !== (n = E(this, gn).clientJSON.config) && void 0 !== n && null !== (n = n.options) && void 0 !== n && n.trackingKey && pn(E(this, An)), f(this, wn, !0), E(this, wn) && (E(this, On).mount(e, void 0, {
              record: JSON.stringify(mn(mn({}, E(this, gn)), {}, {
                record: E(this, Nn),
                context: E(this, bn),
                containerId: E(this, Ln)
              }))
            }), m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(r, Tn, !0), E(r, Nn).skyflowID ? (m().emit(Re + E(r, Ln), {
                skyflowID: E(r, Nn).skyflowID,
                containerId: E(r, Ln)
              }), ln(E(r, An), z, Date.now()), ln(E(r, An), K, Y.MOUNTED)) : (m().emit(Re + E(r, Ln), {
                id: E(r, Nn).token,
                containerId: E(r, Ln)
              }), ln(E(r, An), z, Date.now()), ln(E(r, An), K, Y.MOUNTED)), Object.prototype.hasOwnProperty.call(E(r, Nn), "skyflowID") && m().emit(ae.HEIGHT + E(r, On).name, {}, function (e) {
                E(r, On).setIframeHeight(e.height);
              });
            }), ln(E(this, An), K, Y.READY), ln(E(this, An), q, Date.now()));
          }
        }, {
          key: "renderFile",
          value: function () {
            var e = this;
            f(this, Mn, E(this, gn).skyflowContainer.isControllerFrameReady);
            var t = "";
            Object.prototype.hasOwnProperty.call(E(this, Nn), "altText") && (t = E(this, Nn).altText), this.setAltText("loading...");
            var n = E(this, bn).logLevel;
            return E(this, Mn) ? new Promise(function (r, o) {
              try {
                Lt(E(e, gn).clientJSON.config), Ut(Ft(R.infoLogs.VALIDATE_RENDER_RECORDS, yn), lt.LOG, n), Ot(E(e, Nn)), m().emit(le + E(e, gn).uuid, {
                  type: ie,
                  records: E(e, Nn),
                  containerId: E(e, Ln),
                  iframeName: E(e, On).name
                }, function (n) {
                  n.errors ? (Ut(Ft(R.errorLogs.FAILED_RENDER), lt.ERROR, E(e, bn).logLevel), Object.prototype.hasOwnProperty.call(E(e, Nn), "altText") && e.setAltText(t), o(En(n, E(e, Nn).column))) : (Ut(Ft(R.infoLogs.RENDER_SUBMIT_SUCCESS, yn), lt.LOG, E(e, bn).logLevel), Ut(Ft(R.infoLogs.FILE_RENDERED, yn, E(e, Nn).skyflowID), lt.LOG, E(e, bn).logLevel), r(En(n, E(e, Nn).column)));
                }), Ut(Ft(R.infoLogs.EMIT_EVENT, yn, Ne), lt.LOG, n);
              } catch (e) {
                Ut("Error: ".concat(e.message), lt.ERROR, n), o(e);
              }
            }) : new Promise(function (r, o) {
              try {
                Lt(E(e, gn).clientJSON.config), Ut(Ft(R.infoLogs.VALIDATE_RENDER_RECORDS, yn), lt.LOG, n), Ot(E(e, Nn)), m().target(wt.IFRAME_SECURE_ORIGIN).on(Te + E(e, gn).uuid, function () {
                  m().emit(le + E(e, gn).uuid, {
                    type: ie,
                    records: E(e, Nn),
                    containerId: E(e, Ln),
                    iframeName: E(e, On).name
                  }, function (n) {
                    n.errors ? (Ut(Ft(R.errorLogs.FAILED_RENDER), lt.ERROR, E(e, bn).logLevel), Object.prototype.hasOwnProperty.call(E(e, Nn), "altText") && e.setAltText(t), o(En(n, E(e, Nn).column))) : (Ut(Ft(R.infoLogs.RENDER_SUBMIT_SUCCESS, yn), lt.LOG, E(e, bn).logLevel), Ut(Ft(R.infoLogs.FILE_RENDERED, yn, E(e, Nn).skyflowID), lt.LOG, E(e, bn).logLevel), r(En(n, E(e, Nn).column)));
                  }), Ut(Ft(R.infoLogs.EMIT_EVENT, yn, Ne), lt.LOG, n);
                }), Ut(Ft(R.infoLogs.EMIT_EVENT, yn, Ne), lt.LOG, n);
              } catch (e) {
                Ut("Error: ".concat(e.message), lt.ERROR, n), o(e);
              }
            });
          }
        }, {
          key: "iframeName",
          value: function () {
            return E(this, On).name;
          }
        }, {
          key: "isMounted",
          value: function () {
            return E(this, Tn);
          }
        }, {
          key: "hasToken",
          value: function () {
            return !!E(this, Nn).token;
          }
        }, {
          key: "isClientSetError",
          value: function () {
            return E(this, hn);
          }
        }, {
          key: "getRecordData",
          value: function () {
            return E(this, Nn);
          }
        }, {
          key: "setErrorOverride",
          value: function (e) {
            var t = this;
            E(this, Tn) ? m().emit(Ie + E(this, On).name, {
              name: E(this, On).name,
              isTriggerError: !0,
              clientErrorText: e
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              m().emit(Ie + E(t, On).name, {
                name: E(t, On).name,
                isTriggerError: !0,
                clientErrorText: e
              });
            }), f(this, hn, !0);
          }
        }, {
          key: "setError",
          value: function (e) {
            var t = this;
            E(this, Tn) ? m().emit(Ie + E(this, On).name, {
              name: E(this, On).name,
              isTriggerError: !0,
              clientErrorText: e
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(t, Tn, !0), m().emit(Ie + E(t, On).name, {
                name: E(t, On).name,
                isTriggerError: !0,
                clientErrorText: e
              });
            }), f(this, hn, !0);
          }
        }, {
          key: "resetError",
          value: function () {
            var e = this;
            E(this, Tn) ? m().emit(Ie + E(this, On).name, {
              name: E(this, On).name,
              isTriggerError: !1
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(e, Tn, !0), m().emit(Ie + E(e, On).name, {
                name: E(e, On).name,
                isTriggerError: !1
              });
            }), f(this, hn, !1);
          }
        }, {
          key: "setAltText",
          value: function (e) {
            var t = this;
            E(this, Tn) ? m().emit(ye + E(this, On).name, {
              name: E(this, On).name,
              updateType: Ae,
              updatedValue: e
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(t, Tn, !0), m().emit(ye + E(t, On).name, {
                name: E(t, On).name,
                updateType: Ae,
                updatedValue: e
              });
            });
          }
        }, {
          key: "clearAltText",
          value: function () {
            var e = this;
            E(this, Tn) ? m().emit(ye + E(this, On).name, {
              name: E(this, On).name,
              updateType: Ae,
              updatedValue: null
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(e, Tn, !0), m().emit(ye + E(e, On).name, {
                name: E(e, On).name,
                updateType: Ae,
                updatedValue: null
              });
            });
          }
        }, {
          key: "setToken",
          value: function (e) {
            var t = this;
            f(this, Nn, mn(mn({}, E(this, Nn)), {}, {
              token: e
            })), E(this, Tn) ? m().emit(ye + E(this, On).name, {
              name: E(this, On).name,
              updateType: be,
              updatedValue: e
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(t, Tn, !0), m().emit(ye + E(t, On).name, {
                name: E(t, On).name,
                updateType: be,
                updatedValue: e
              });
            });
          }
        }, {
          key: "unmount",
          value: function () {
            var e;
            E(this, Nn).skyflowID && (f(this, Tn, !1), null === (e = E(this, On).container) || void 0 === e || e.remove());
            f(this, Tn, !1), E(this, On).unmount();
          }
        }, {
          key: "update",
          value: function (e) {
            var t = this;
            f(this, Nn, mn(mn({}, E(this, Nn)), e)), E(this, Tn) ? m().emit(ye + E(this, On).name, {
              name: E(this, On).name,
              updateType: we,
              updatedValue: e
            }) : m().target(wt.IFRAME_SECURE_ORIGIN).on(ae.MOUNTED + E(this, On).name, function () {
              f(t, Tn, !0), m().emit(ye + E(t, On).name, {
                name: E(t, On).name,
                updateType: we,
                updatedValue: e
              });
            });
          }
        }]), n;
      }(fn);
    const Cn = Pn;
    function kn(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Vn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? kn(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kn(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function jn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = et(e);
        if (t) {
          var o = et(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return Qe(this, n);
      };
    }
    function Un(e, t, n) {
      Fn(e, t), t.set(e, n);
    }
    function Fn(e, t) {
      if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function Yn(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
      return n;
    }
    var Gn = "RevealContainer",
      Bn = new WeakMap(),
      Xn = new WeakMap(),
      Wn = new WeakMap(),
      Kn = new WeakMap(),
      qn = new WeakMap(),
      zn = new WeakMap(),
      Hn = new WeakMap(),
      Jn = new WeakMap(),
      Zn = new WeakMap(),
      $n = new WeakMap(),
      Qn = new WeakMap(),
      er = new WeakMap(),
      tr = new WeakSet();
    function nr(e, t) {
      var n = this;
      m().emit(le + E(this, Kn).uuid, {
        type: oe,
        records: E(this, Bn),
        containerId: E(this, qn)
      }, function (r) {
        f(n, Wn, []), r.error ? (Ut(Ft(R.errorLogs.FAILED_REVEAL), lt.ERROR, E(n, Zn).logLevel), t(r.error)) : (Ut(Ft(R.infoLogs.REVEAL_SUBMIT_SUCCESS, Gn), lt.LOG, E(n, Zn).logLevel), e(r));
      });
    }
    const rr = function (e) {
      $e(n, e);
      var t = jn(n);
      function n(e, r, o) {
        var i,
          a,
          c,
          p,
          u,
          d = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        s(this, n), c = t.call(this), Fn(p = Je(c), u = tr), u.add(p), Un(Je(c), Bn, {
          writable: !0,
          value: []
        }), Un(Je(c), Xn, {
          writable: !0,
          value: []
        }), Un(Je(c), Wn, {
          writable: !0,
          value: []
        }), Un(Je(c), Kn, {
          writable: !0,
          value: void 0
        }), Un(Je(c), qn, {
          writable: !0,
          value: void 0
        }), Un(Je(c), zn, {
          writable: !0,
          value: void 0
        }), Un(Je(c), Hn, {
          writable: !0,
          value: !1
        }), Un(Je(c), Jn, {
          writable: !0,
          value: !1
        }), Un(Je(c), Zn, {
          writable: !0,
          value: void 0
        }), Un(Je(c), $n, {
          writable: !0,
          value: void 0
        }), Un(Je(c), Qn, {
          writable: !0,
          value: void 0
        }), l(Je(c), "type", hi.REVEAL), Un(Je(c), er, {
          writable: !0,
          value: !1
        }), f(Je(c), er, e.skyflowContainer.isControllerFrameReady), f(Je(c), Kn, Vn(Vn({}, e), {}, {
          clientJSON: Vn(Vn({}, e.clientJSON), {}, {
            config: Vn(Vn({}, null === (i = e.clientJSON) || void 0 === i ? void 0 : i.config), {}, {
              options: Vn(Vn({}, null === (a = e.clientJSON) || void 0 === a || null === (a = a.config) || void 0 === a ? void 0 : a.options), d)
            })
          })
        })), f(Je(c), $n, r), f(Je(c), qn, v()), f(Je(c), zn, new zt()), f(Je(c), Zn, o);
        var _ = E(Je(c), Kn).clientDomain || "",
          I = Qt({
            name: "".concat("reveal_controller", ":").concat(E(Je(c), qn), ":").concat(btoa(_)),
            referrer: _
          });
        return $t(I, {
          src: en()
        }), tn(I, Vn({}, Ve)), Ut(Ft(R.infoLogs.CREATE_REVEAL_CONTAINER, Gn), lt.LOG, E(Je(c), Zn).logLevel), m().target(window.location.origin).on(Re + E(Je(c), qn), function (e) {
          e.skyflowID || E(Je(c), Wn).push(e);
          var t = 0;
          E(Je(c), Xn).forEach(function (e) {
            e.getRecordData().skyflowID || (t += 1);
          }), f(Je(c), Jn, E(Je(c), Wn).length === t), E(Je(c), Hn) && E(Je(c), Jn) && E(Je(c), zn)._emit(Se + E(Je(c), qn), {
            containerId: E(Je(c), qn)
          });
        }), c;
      }
      return u(n, [{
        key: "create",
        value: function (e, t) {
          var n = v();
          At(t);
          var r = new Cn(e, t, E(this, Kn), {
            containerId: E(this, qn),
            isMounted: E(this, Qn),
            eventEmitter: E(this, zn)
          }, n, E(this, Zn));
          return E(this, Xn).push(r), E(this, $n)[n] = r, r;
        }
      }, {
        key: "reveal",
        value: function () {
          var e = this;
          return f(this, Hn, !0), f(this, Bn, []), E(this, Kn).skyflowContainer.isControllerFrameReady ? new Promise(function (t, n) {
            try {
              if (Lt(E(e, Kn).clientJSON.config), Ut(Ft(R.infoLogs.VALIDATE_REVEAL_RECORDS, Gn), lt.LOG, E(e, Zn).logLevel), E(e, Xn).forEach(function (t) {
                if (t.isClientSetError()) throw new Gt(pt.REVEAL_ELEMENT_ERROR_STATE);
                t.getRecordData().skyflowID || E(e, Bn).push(t.getRecordData());
              }), 0 === E(e, Bn).length) throw new Gt(pt.NO_ELEMENTS_IN_REVEAL, [], !0);
              if (yt(E(e, Bn)), E(e, Jn)) Yn(e, tr, nr).call(e, t, n);else {
                var r = setTimeout(function () {
                  Ut(R.errorLogs.ELEMENTS_NOT_MOUNTED_REVEAL, lt.ERROR, E(e, Zn).logLevel), n(new Error(R.errorLogs.ELEMENTS_NOT_MOUNTED_REVEAL));
                }, 1e4);
                E(e, zn).on(Se + E(e, qn), function () {
                  clearTimeout(r), Yn(e, tr, nr).call(e, t, n);
                });
              }
            } catch (t) {
              Ut("Error: ".concat(t.message), lt.ERROR, E(e, Zn).logLevel), n(t);
            }
          }) : new Promise(function (t, n) {
            try {
              if (Lt(E(e, Kn).clientJSON.config), Ut(Ft(R.infoLogs.VALIDATE_REVEAL_RECORDS, Gn), lt.LOG, E(e, Zn).logLevel), E(e, Xn).forEach(function (t) {
                if (t.isClientSetError()) throw new Gt(pt.REVEAL_ELEMENT_ERROR_STATE);
                t.getRecordData().skyflowID || E(e, Bn).push(t.getRecordData());
              }), 0 === E(e, Bn).length) throw new Gt(pt.NO_ELEMENTS_IN_REVEAL, [], !0);
              if (yt(E(e, Bn)), E(e, Jn)) m().target(wt.IFRAME_SECURE_ORIGIN).on(Te + E(e, Kn).uuid, function () {
                Yn(e, tr, nr).call(e, t, n);
              });else {
                var r = setTimeout(function () {
                  Ut(R.errorLogs.ELEMENTS_NOT_MOUNTED_REVEAL, lt.ERROR, E(e, Zn).logLevel), n(new Error(R.errorLogs.ELEMENTS_NOT_MOUNTED_REVEAL));
                }, 1e4);
                E(e, zn).on(Se + E(e, qn), function () {
                  clearTimeout(r), E(e, Kn).skyflowContainer.isControllerFrameReady ? Yn(e, tr, nr).call(e, t, n) : m().target(wt.IFRAME_SECURE_ORIGIN).on(Te + E(e, Kn).uuid, function () {
                    Yn(e, tr, nr).call(e, t, n);
                  });
                });
              }
            } catch (t) {
              Ut("Error: ".concat(t.message), lt.ERROR, E(e, Zn).logLevel), n(t);
            }
          });
        }
      }]), n;
    }(nn);
    function or(e) {
      return JSON.parse(JSON.stringify(e));
    }
    function ir(e, t) {
      if (null == e) return {};
      var n,
        r,
        o = function (e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            i = Object.keys(e);
          for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
      return o;
    }
    const ar = function () {
      function e() {
        s(this, e), l(this, "listeners", void 0), l(this, "isDestroyed", void 0), this.listeners = [], this.isDestroyed = !1;
      }
      return u(e, [{
        key: "on",
        value: function (e, t) {
          m().on(e, t), this.listeners.push({
            eventName: e,
            callback: t
          });
        }
      }, {
        key: "off",
        value: function (e, t) {
          m().off(e, t);
          var n = this.listeners.findIndex(function (t) {
            return t.eventName === e;
          });
          -1 !== n && this.listeners.splice(n, 1);
        }
      }, {
        key: "emit",
        value: function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
          m().emit(e, t, n);
        }
      }, {
        key: "hasListener",
        value: function (e) {
          return -1 !== this.listeners.findIndex(function (t) {
            return t.eventName === e;
          });
        }
      }, {
        key: "teardown",
        value: function () {
          this.listeners.forEach(function (e) {
            m().off(e.eventName, e.handler);
          }), this.listeners = [];
        }
      }]), e;
    }();
    var cr = ["name"];
    function lr(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function sr(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lr(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lr(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function pr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = et(e);
        if (t) {
          var o = et(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return Qe(this, n);
      };
    }
    function ur(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var dr = new WeakMap(),
      fr = new WeakMap(),
      Er = new WeakMap(),
      _r = new WeakMap(),
      mr = new WeakMap(),
      vr = new WeakMap(),
      Ir = new WeakMap(),
      yr = new WeakMap(),
      Or = new WeakMap(),
      gr = new WeakMap(),
      Nr = new WeakMap(),
      Lr = new WeakMap(),
      Tr = new WeakMap(),
      hr = new WeakMap(),
      br = new WeakMap(),
      Ar = new WeakMap(),
      wr = new WeakMap(),
      Rr = new WeakMap(),
      Sr = new WeakMap(),
      Dr = new WeakMap(),
      xr = new WeakMap(),
      Mr = new WeakMap(),
      Pr = function (e) {
        $e(n, e);
        var t = pr(n);
        function n(e, r, o, i) {
          var a,
            c = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            p = arguments.length > 5 ? arguments[5] : void 0,
            u = arguments.length > 6 ? arguments[6] : void 0,
            d = arguments.length > 7 ? arguments[7] : void 0,
            _ = arguments.length > 8 ? arguments[8] : void 0;
          return s(this, n), l(Je(a = t.call(this)), "elementType", void 0), l(Je(a), "type", hi.COLLECT), ur(Je(a), dr, {
            writable: !0,
            value: void 0
          }), l(Je(a), "containerId", void 0), ur(Je(a), fr, {
            writable: !0,
            value: !1
          }), ur(Je(a), Er, {
            writable: !0,
            value: void 0
          }), ur(Je(a), _r, {
            writable: !0,
            value: void 0
          }), l(Je(a), "resizeObserver", void 0), ur(Je(a), mr, {
            writable: !0,
            value: {
              isEmpty: !0,
              isComplete: !1,
              isValid: !1,
              isFocused: !1,
              value: void 0,
              isRequired: !1,
              selectedCardScheme: ""
            }
          }), ur(Je(a), vr, {
            writable: !0,
            value: void 0
          }), ur(Je(a), Ir, {
            writable: !0,
            value: void 0
          }), ur(Je(a), yr, {
            writable: !0,
            value: new zt()
          }), ur(Je(a), Or, {
            writable: !0,
            value: void 0
          }), ur(Je(a), gr, {
            writable: !0,
            value: new ar()
          }), ur(Je(a), Nr, {
            writable: !0,
            value: void 0
          }), ur(Je(a), Lr, {
            writable: !0,
            value: []
          }), ur(Je(a), Tr, {
            writable: !0,
            value: !1
          }), ur(Je(a), hr, {
            writable: !0,
            value: void 0
          }), ur(Je(a), br, {
            writable: !0,
            value: void 0
          }), ur(Je(a), Ar, {
            writable: !0,
            value: !1
          }), ur(Je(a), wr, {
            writable: !0,
            value: !1
          }), l(Je(a), "getID", function () {
            return E(Je(a), dr);
          }), l(Je(a), "mount", function (e) {
            var t;
            if (!e) throw new Gt(pt.EMPTY_ELEMENT_IN_MOUNT, ["CollectElement"], !0);
            if (a.resizeObserver = new ResizeObserver(function () {
              E(Je(a), gr).emit(ae.HEIGHT + E(Je(a), Nr).name, {}, function (e) {
                E(Je(a), Nr).setIframeHeight(e.height);
              });
            }), ln(E(Je(a), dr), B, e), null !== (t = E(Je(a), Ir)) && void 0 !== t && null !== (t = t.clientJSON) && void 0 !== t && null !== (t = t.config) && void 0 !== t && null !== (t = t.options) && void 0 !== t && t.trackMetrics && E(Je(a), Ir).clientJSON.config.options.trackingKey && pn(E(Je(a), dr)), "string" == typeof e) {
              var n,
                r = document.querySelector(e);
              if (r) null === (n = a.resizeObserver) || void 0 === n || n.observe(r);
            } else if (e instanceof HTMLElement) {
              var o;
              null === (o = a.resizeObserver) || void 0 === o || o.observe(e);
            }
            E(Je(a), _r).length > 1 ? (E(Je(a), Nr).mount(e, E(Je(a), dr), {
              record: JSON.stringify({
                record: E(Je(a), vr),
                containerId: a.containerId,
                metaData: E(Je(a), Ir)
              })
            }), E(Je(a), _r).forEach(function (e, t) {
              E(Je(a), Or) && (E(Je(a), Or)._emit("".concat(ae.READY, ":").concat(e.elementName), sr(sr({}, E(Je(a), Er)[t]), {}, {
                elementType: e.elementType
              })), ln(E(Je(a), dr), K, "".concat(e.elementType, "_").concat(W.READY)));
            }), ln(E(Je(a), dr), q, Date.now())) : E(Je(a), Ar) && (E(Je(a), Nr).mount(e, E(Je(a), dr), {
              record: JSON.stringify({
                record: E(Je(a), vr),
                containerId: a.containerId,
                metaData: E(Je(a), Ir)
              })
            }), ln(E(Je(a), dr), q, Date.now()));
          }), l(Je(a), "unmount", function () {
            var e;
            (E(Je(a), Nr).unmount(), a.resizeObserver) && (null === (e = a.resizeObserver) || void 0 === e || e.disconnect());
          }), l(Je(a), "updateElementGroup", function (e) {
            var t = or(e),
              n = function () {
                E(Je(a), fr) && (t = {
                  rows: [{
                    elements: [sr({}, t)]
                  }]
                }), f(Je(a), vr, zr(E(Je(a), vr), t)), f(Je(a), _r, Hr(E(Je(a), vr))), E(Je(a), fr) ? E(Je(a), gr).emit(de + xt(E(Je(a), Nr).name), {
                  name: E(Je(a), Nr).name,
                  options: E(Je(a), _r)[0],
                  isSingleElementAPI: !0
                }) : (E(Je(a), _r).forEach(function (e) {
                  E(Je(a), gr).emit(de + xt(E(Je(a), Nr).name), {
                    name: e.elementName,
                    options: e,
                    isSingleElementAPI: !0
                  });
                }), E(Je(a), gr).emit(de + xt(E(Je(a), Nr).name), {
                  name: E(Je(a), Nr).name,
                  options: E(Je(a), vr),
                  isSingleElementAPI: !1
                })), E(Je(a), Mr).call(Je(a));
              };
            E(Je(a), Tr) ? n() : E(Je(a), Lr).push(n);
          }), ur(Je(a), Rr, {
            writable: !0,
            value: function (e) {
              E(Je(a), fr) || E(Je(a), yr).on(de + xt(E(Je(a), Nr).name), function () {
                e(E(Je(a), _r));
              }, !0);
            }
          }), l(Je(a), "updateElement", function (e) {
            E(Je(a), gr).emit(de + e.elementName, {
              name: e.elementName,
              options: e,
              isSingleElementAPI: !0
            });
          }), l(Je(a), "update", function (e) {
            f(Je(a), wr, !0), E(Je(a), Tr) ? (e.validations = Jr(e.validations), a.updateElement(sr({
              elementName: E(Je(a), vr).elementName
            }, e)), f(Je(a), wr, !1)) : E(Je(a), wr) && E(Je(a), yr).on("".concat(it.READY, ":").concat(E(Je(a), dr)), function () {
              e.validations = Jr(e.validations), a.updateElement(sr({
                elementName: E(Je(a), vr).elementName
              }, e)), f(Je(a), Tr, !0), f(Je(a), wr, !1);
            });
          }), ur(Je(a), Sr, {
            writable: !0,
            value: function () {
              E(Je(a), Er).forEach(function (e, t) {
                if (0 === t) {
                  E(Je(a), mr).isEmpty = e.isEmpty, E(Je(a), mr).isComplete = e.isComplete, E(Je(a), mr).isValid = e.isValid, E(Je(a), mr).isFocused = e.isFocused, E(Je(a), mr).isRequired = e.isRequired, E(Je(a), mr).value = {}, E(Je(a), mr).selectedCardScheme = "";
                  var n = E(Je(a), _r)[t].elementName,
                    r = e.value && function (e, t, n) {
                      if ("string" != typeof e) return e;
                      if (t === De.CARD_NUMBER) {
                        if (e = e && e.replace(/\s/g, ""), !n) {
                          var r,
                            o = dt(e),
                            i = o !== xe.DEFAULT && o === xe.AMEX ? 6 : 8;
                          return e.length > i ? e.replace(new RegExp(".(?=.{0,".concat((null === (r = e) || void 0 === r ? void 0 : r.length) - i - 1, "}$)"), "g"), "X") : e;
                        }
                        return e;
                      }
                      return n ? e : void 0;
                    }(e.value, e.elementType, E(Je(a), br));
                  E(Je(a), fr) ? E(Je(a), mr).value = r : E(Je(a), mr).value[n] = r;
                } else E(Je(a), mr).isEmpty = E(Je(a), mr).isEmpty || e.isEmpty, E(Je(a), mr).isComplete = E(Je(a), mr).isComplete && e.isComplete, E(Je(a), mr).isValid = E(Je(a), mr).isValid && e.isValid, E(Je(a), mr).isFocused = E(Je(a), mr).isFocused || e.isFocused, E(Je(a), mr).isRequired = E(Je(a), mr).isRequired || e.isRequired, E(Je(a), mr).selectedCardScheme = E(Je(a), mr).selectedCardScheme || e.selectedCardScheme, E(Je(a), mr).value || (E(Je(a), mr).value = {}), E(Je(a), _r)[t].sensitive || (E(Je(a), mr).value[E(Je(a), _r)[t].elementName] = e.value || "");
              });
            }
          }), l(Je(a), "getState", function () {
            return {
              isEmpty: E(Je(a), mr).isEmpty,
              isComplete: E(Je(a), mr).isComplete,
              isValid: E(Je(a), mr).isValid,
              isFocused: E(Je(a), mr).isFocused,
              value: E(Je(a), mr).value,
              required: E(Je(a), mr).isRequired,
              selectedCardScheme: ""
            };
          }), l(Je(a), "getOptions", function () {
            var e = or(E(Je(a), vr));
            return E(Je(a), fr) ? e = e.rows[0].elements[0] : e.rows.forEach(function (e) {
              e.elements.forEach(function (e) {
                delete e.elementName;
              });
            }), delete e.elementName, e;
          }), ur(Je(a), Dr, {
            writable: !0,
            value: function (e) {
              E(Je(a), yr).on(ue, function () {
                var t = E(Je(a), _r).map(function (e) {
                  return e.elementName;
                });
                E(Je(a), fr) || t.push(E(Je(a), Nr).name), e(t);
              }, !0);
            }
          }), ur(Je(a), xr, {
            writable: !0,
            value: function () {
              E(Je(a), gr).on(he, function (e) {
                if (e.ready && e.name === a.iframeName()) {
                  var t = E(Je(a), Er)[0],
                    n = (t.name, ir(t, cr));
                  E(Je(a), yr)._emit(ae.READY, sr({}, n));
                }
              }), E(Je(a), _r).forEach(function (e) {
                E(Je(a), gr).on(pe + e.elementName, function (e) {
                  if (E(Je(a), fr) && e.event === ae.READY && e.name === xt(E(Je(a), Nr).name)) E(Je(a), yr)._emit(ae.READY);else {
                    var t = E(Je(a), _r).length > 1;
                    E(Je(a), _r).forEach(function (n, r) {
                      var o;
                      if (e.name === n.elementName) {
                        var i,
                          c = "";
                        switch (e.event) {
                          case ae.FOCUS:
                            c = ae.FOCUS;
                            break;
                          case ae.BLUR:
                            c = ae.BLUR;
                            break;
                          case ae.CHANGE:
                            c = ae.CHANGE;
                            break;
                          case ae.READY:
                            c = ae.READY;
                            break;
                          case ae.SUBMIT:
                            return void (null === (o = E(Je(a), Or)) || void 0 === o || o._emit(ae.SUBMIT));
                          default:
                            throw new Gt(pt.INVALID_EVENT_TYPE, [], !0);
                        }
                        E(Je(a), Er)[r].isEmpty = e.value.isEmpty, E(Je(a), Er)[r].isValid = e.value.isValid, E(Je(a), Er)[r].isComplete = e.value.isComplete, E(Je(a), Er)[r].isFocused = e.value.isFocused, E(Je(a), Er)[r].isRequired = e.value.isRequired, E(Je(a), Er)[r].selectedCardScheme = (null == e || null === (i = e.value) || void 0 === i ? void 0 : i.selectedCardScheme) || "", Object.prototype.hasOwnProperty.call(e.value, "value") ? E(Je(a), Er)[r].value = e.value.value : E(Je(a), Er)[r].value = void 0, c = t ? "".concat(c, ":").concat(e.name) : c, E(Je(a), gr).emit(ae.HEIGHT + E(Je(a), Nr).name, {}, function (e) {
                          E(Je(a), Nr).setIframeHeight(e.height);
                        }), E(Je(a), Sr).call(Je(a));
                        var l = sr(sr({}, E(Je(a), Er)[r]), {}, {
                          elementType: n.elementType
                        });
                        t && E(Je(a), Or) ? E(Je(a), Or)._emit(c, l) : E(Je(a), yr)._emit(c, l);
                      }
                    });
                  }
                });
              });
            }
          }), ur(Je(a), Mr, {
            writable: !0,
            value: function () {
              E(Je(a), vr).rows.forEach(function (e) {
                e.elements.forEach(function (e) {
                  e.elementType !== Pe.radio.name && e.elementType !== Pe.checkbox.name && (e.value = void 0);
                });
              }), f(Je(a), _r, Hr(E(Je(a), vr)));
            }
          }), a.containerId = i.containerId, f(Je(a), dr, e), f(Je(a), hr, d), f(Je(a), Ir, o), f(Je(a), vr, zr(r)), f(Je(a), _r, Hr(r)), f(Je(a), fr, c), a.resizeObserver = null, _ && f(Je(a), Or, _), f(Je(a), br, Vt[E(Je(a), hr).env].doesReturnValue), a.elementType = E(Je(a), fr) ? E(Je(a), _r)[0].elementType : "group", cn(o, e), f(Je(a), Er, []), E(Je(a), _r).forEach(function (e) {
            ln(E(Je(a), dr), G, e.elementType), E(Je(a), Er).push({
              isEmpty: !0,
              isComplete: !1,
              isValid: !e.required && E(Je(a), mr).isEmpty,
              isFocused: !1,
              value: E(Je(a), br) ? "" : void 0,
              elementType: e.elementType,
              name: e.elementName,
              isRequired: e.required,
              selectedCardScheme: ""
            });
          }), E(Je(a), _r) && E(Je(a), _r).length && E(Je(a), _r).length > 1 ? ln(E(Je(a), dr), X, F.COMPOSE) : ln(E(Je(a), dr), X, F.COLLECT), f(Je(a), Nr, new dn(E(Je(a), vr).elementName, o, a.containerId, E(Je(a), hr).logLevel)), E(Je(a), xr).call(Je(a)), E(Je(a), Dr).call(Je(a), p), E(Je(a), Rr).call(Je(a), u), Ut(Ft(R.infoLogs.CREATED_ELEMENT, "Element", function () {
            var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").split(":");
            if ("group" === e[1]) return "composable container";
            var t = atob(e[2]);
            return -1 !== t.indexOf(":") && (t = t.substring(0, t.indexOf(":"))), t;
          }(E(Je(a), Nr).name)), lt.LOG, E(Je(a), hr).logLevel), f(Je(a), Ar, i.isMounted), i.type === hi.COMPOSABLE && E(Je(a), _r).forEach(function (e) {
            E(Je(a), gr).on(ae.MOUNTED + xt(e.elementName), function (t) {
              t.name === e.elementName && (ln(E(Je(a), dr), K, "".concat(e.elementType, "_").concat(W.MOUNTED)), e.isMounted = !0, f(Je(a), Tr, !0), E(Je(a), gr).emit(ae.HEIGHT + E(Je(a), Nr).name, {}, function (e) {
                E(Je(a), Nr).setIframeHeight(e.height);
              }));
            });
          }), E(Je(a), gr).on(ae.MOUNTED + xt(E(Je(a), Nr).name), function (e) {
            e.name === E(Je(a), _r)[0].elementName && (ln(E(Je(a), dr), z, Date.now()), ln(E(Je(a), dr), K, Y.MOUNTED), E(Je(a), _r)[0].isMounted = !0, f(Je(a), Tr, !0), E(Je(a), gr).emit(ae.HEIGHT + E(Je(a), Nr).name, {}, function (e) {
              E(Je(a), Nr).setIframeHeight(e.height);
            }));
          }), a;
        }
        return u(n, [{
          key: "on",
          value: function (e, t) {
            if (!Object.values(ae).includes(e)) throw new Gt(pt.INVALID_EVENT_LISTENER, [], !0);
            if (!t) throw new Gt(pt.MISSING_HANDLER_IN_EVENT_LISTENER, [], !0);
            if ("function" != typeof t) throw new Gt(pt.INVALID_HANDLER_IN_EVENT_LISTENER, [], !0);
            E(this, yr).on(e, function (e) {
              void 0 === e.value && (e.value = ""), e.elementType !== De.CARD_NUMBER && delete e.selectedCardScheme, delete e.isComplete, delete e.name, t(e);
            }), e === ae.READY && E(this, gr).emit(he, {
              ready: E(this, Ar),
              name: this.iframeName()
            });
          }
        }, {
          key: "iframeName",
          value: function () {
            return E(this, Nr).name;
          }
        }, {
          key: "isMounted",
          value: function () {
            return E(this, Tr);
          }
        }, {
          key: "isUpdateCalled",
          value: function () {
            return E(this, wr);
          }
        }, {
          key: "isValidElement",
          value: function () {
            for (var e = 0; e < E(this, _r).length; e += 1) {
              if (!Object.prototype.hasOwnProperty.call(E(this, _r)[e], "table")) throw new Gt(pt.MISSING_TABLE_IN_COLLECT, [], !0);
              if (!E(this, _r)[e].table) throw new Gt(pt.EMPTY_TABLE_IN_COLLECT, [], !0);
              if (!("string" == typeof E(this, _r)[e].table || E(this, _r)[e].table instanceof String)) throw new Gt(pt.INVALID_TABLE_IN_COLLECT, [], !0);
              if (!Object.prototype.hasOwnProperty.call(E(this, _r)[e], "column")) throw new Gt(pt.MISSING_COLUMN_IN_COLLECT, [], !0);
              if (!E(this, _r)[e].column) throw new Gt(pt.EMPTY_COLUMN_IN_COLLECT, [], !0);
              if (!("string" == typeof E(this, _r)[e].column || E(this, _r)[e].column instanceof String)) throw new Gt(pt.INVALID_COLUMN_IN_COLLECT, [], !0);
              if (void 0 !== E(this, _r)[e].skyflowID && !E(this, _r)[e].skyflowID) throw new Gt(pt.EMPTY_SKYFLOW_ID_COLLECT, [], !0);
            }
            return !0;
          }
        }, {
          key: "setErrorOverride",
          value: function (e) {
            E(this, gr).emit(ve + xt(E(this, Nr).name), {
              name: xt(E(this, Nr).name),
              customErrorText: e
            });
          }
        }, {
          key: "setError",
          value: function (e) {
            E(this, gr).emit(me + xt(E(this, Nr).name), {
              name: xt(E(this, Nr).name),
              isTriggerError: !0,
              clientErrorText: e
            });
          }
        }, {
          key: "resetError",
          value: function () {
            E(this, gr).emit(me + xt(E(this, Nr).name), {
              name: xt(E(this, Nr).name),
              isTriggerError: !1
            });
          }
        }, {
          key: "setValue",
          value: function (e) {
            E(this, hr).env !== ct.PROD ? E(this, fr) && E(this, gr).emit(de + xt(E(this, Nr).name), {
              name: E(this, Nr).name,
              options: sr(sr({}, E(this, _r)[0]), {}, {
                value: e
              }, E(this, vr)),
              isSingleElementAPI: !0
            }) : Ut(Ft(R.warnLogs.UNABLE_TO_SET_VALUE_IN_PROD_ENV, E(this, _r)[0].elementType), lt.WARN, E(this, hr).logLevel);
          }
        }, {
          key: "clearValue",
          value: function () {
            E(this, hr).env !== ct.PROD ? E(this, fr) && E(this, gr).emit(de + xt(E(this, Nr).name), {
              name: E(this, Nr).name,
              options: sr(sr({}, E(this, _r)[0]), {}, {
                value: ""
              }),
              isSingleElementAPI: !0
            }) : Ut(Ft(R.warnLogs.UNABLE_TO_CLEAR_VALUE_IN_PROD_ENV, E(this, _r)[0].elementType), lt.WARN, E(this, hr).logLevel);
          }
        }]), n;
      }(fn);
    const Cr = Pr;
    function kr(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var Vr = new WeakMap(),
      jr = new WeakMap(),
      Ur = new WeakMap(),
      Fr = new WeakMap(),
      Yr = new WeakMap();
    const Gr = function () {
      function e(t, n, r) {
        var o = this;
        s(this, e), kr(this, Vr, {
          writable: !0,
          value: void 0
        }), kr(this, jr, {
          writable: !0,
          value: void 0
        }), kr(this, Ur, {
          writable: !0,
          value: void 0
        }), l(this, "type", hi.COMPOSABLE), kr(this, Fr, {
          writable: !0,
          value: !1
        }), kr(this, Yr, {
          writable: !0,
          value: !1
        }), l(this, "update", function (e) {
          f(o, Yr, !0), E(o, Fr) ? (e.validations = Jr(e.validations), E(o, jr)._emit(ge, {
            elementName: E(o, Vr),
            elementOptions: e
          }), f(o, Yr, !1)) : E(o, Yr) && E(o, jr).on("".concat(it.READY, ":").concat(E(o, Vr)), function () {
            e.validations = Jr(e.validations), E(o, jr)._emit(ge, {
              elementName: E(o, Vr),
              elementOptions: e
            }), f(o, Fr, !0), f(o, Yr, !1);
          });
        }), f(this, Vr, t), f(this, Ur, r), f(this, jr, n), E(this, jr).on("".concat(it.READY, ":").concat(E(this, Vr)), function () {
          f(o, Fr, !0);
        });
      }
      return u(e, [{
        key: "on",
        value: function (e, t) {
          if (!Object.values(ae).includes(e)) throw new Gt(pt.INVALID_EVENT_LISTENER, [], !0);
          if (!t) throw new Gt(pt.MISSING_HANDLER_IN_EVENT_LISTENER, [], !0);
          if ("function" != typeof t) throw new Gt(pt.INVALID_HANDLER_IN_EVENT_LISTENER, [], !0);
          E(this, jr).on("".concat(e, ":").concat(E(this, Vr)), function (e) {
            void 0 === e.value && (e.value = ""), e.elementType !== De.CARD_NUMBER && delete e.selectedCardScheme, delete e.isComplete, delete e.name, t(e);
          });
        }
      }, {
        key: "iframeName",
        value: function () {
          return E(this, Ur);
        }
      }, {
        key: "getID",
        value: function () {
          return E(this, Vr);
        }
      }]), e;
    }();
    function Br(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Xr(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Br(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Br(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function Wr(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Kr(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Wr(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wr(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function qr(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if ("group" !== e && !Object.prototype.hasOwnProperty.call(Pe, e)) throw new Gt(pt.INVALID_ELEMENT_TYPE, [], !0);
      if (Object.prototype.hasOwnProperty.call(t, "validations")) {
        if (!Array.isArray(t.validations)) throw new Gt(pt.INVALID_VALIDATIONS_TYPE, [], !0);
        t.validations.forEach(function (e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, "type")) throw new Gt(pt.MISSING_VALIDATION_RULE_TYPE, ["".concat(t)], !0);
          if (!Object.values(st).includes(e.type)) throw new Gt(pt.INVALID_VALIDATION_RULE_TYPE, ["".concat(t)], !0);
          if (!Object.prototype.hasOwnProperty.call(e, "params")) throw new Gt(pt.MISSING_VALIDATION_RULE_PARAMS, ["".concat(t)], !0);
          if ("object" !== a(e.params) || Array.isArray(e.params) || null === e.params) throw new Gt(pt.INVALID_VALIDATION_RULE_PARAMS, ["".concat(t)], !0);
          if (e.type === st.REGEX_MATCH_RULE) {
            if (!Object.prototype.hasOwnProperty.call(e.params, "regex")) throw new Gt(pt.MISSING_REGEX_IN_REGEX_MATCH_RULE, ["".concat(t)], !0);
          } else if (e.type === st.LENGTH_MATCH_RULE && !Object.prototype.hasOwnProperty.call(e.params, "min") && !Object.prototype.hasOwnProperty.call(e.params, "max")) throw new Gt(pt.MISSING_MIN_AND_MAX_IN_LENGTH_MATCH_RULE, ["".concat(t)], !0);
        });
      }
      if (Object.prototype.hasOwnProperty.call(n, "name") && n.name !== t.name) throw new Error("Name attribute can't be updated");
      if ((n = Kr(Kr({}, t), n)).mask || n.replacePattern) {
        var r = Pe[e].attributes.type;
        "text" === r && "textarea" === r && "email" === r || (delete n.mask, delete n.replacePattern);
      }
      if (void 0 === !n.mask && !Array.isArray(n.mask)) throw new Error("mask option has to be array or undefined");
      if (Array.isArray(n.mask)) {
        var o = n.mask;
        if ("string" != typeof o[0] || o[1] && "object" !== a(o[1])) throw new Error("mask array values has to be string");
      }
      if (Array.isArray(n.replacePattern)) {
        var i = n.replacePattern;
        if ("string" != typeof i[0] || i[1] && "string" != typeof i[1]) throw new Error("replacePatterns array values has to be string");
      }
      if ((e === Pe.radio.name || e === Pe.checkbox.name) && !n.value) throw new Error("Elements radio and checkbox requires value attribute");
      if (!(e !== Pe.dropdown.name || n.options && Array.isArray(n.options) && 0 !== n.options.length)) throw new Error("Element dropdown requires options attribute with an array of objects containing value and text attributes");
    }
    function zr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
      return (t = Kr(Kr({}, e), t)).rows.forEach(function (r, o) {
        var i = r,
          c = e.rows[o];
        t.rows[o] = Kr(Kr({}, c), i), i.elements.forEach(function (e, t) {
          var r,
            o,
            l = c.elements[t],
            s = e;
          if (s.elementType && l.elementType !== s.elementType && l.elementName && l.elementName !== s.elementName) throw new Error(Ft(R.errorLogs.CANNOT_CHANGE_ELEMENT));
          qr(l.elementType, l, s), i.elements[t] = Kr(Kr(Kr({}, l), s), {}, {
            elementName: l.elementName
          });
          var p = s.classes || {},
            u = s.styles || {};
          u.base = Kr(Kr({}, je), u.base), s.classes = p, s.styles = u;
          var d = (null == s || null === (r = s.labelStyles) || void 0 === r ? void 0 : r.classes) || {},
            f = (null == s || null === (o = s.labelStyles) || void 0 === o ? void 0 : o.styles) || {};
          n && function (e, t) {
            Object.values(Ue).forEach(function (n) {
              if (e[n] || t[n]) switch (n) {
                case Ue.BASE:
                  t[n] = Xr({}, t[n]);
                  break;
                case Ue.FOCUS:
                  t[Ue.BASE] = Xr(Xr({}, t[Ue.BASE]), {}, {
                    ":focus": Xr({}, t[Ue.BASE] && t[Ue.BASE][":focus"])
                  });
                  break;
                case Ue.WEBPACKAUTOFILL:
                  t[Ue.BASE] = Xr(Xr({}, t[Ue.BASE]), {}, {
                    ":-webkit-autofill": Xr({}, t[Ue.BASE] && t[Ue.BASE][":-webkit-autofill"])
                  });
                  break;
                default:
                  t[n] = Xr(Xr({}, t[Ue.BASE]), t[n]);
              }
            }), Object.keys(t).forEach(function (e) {
              var n = t[e][":-webkit-autofill"];
              "object" === a(n) && Object.keys(n).forEach(function (e) {
                n[e] && !n[e].includes("!important") && (n[e] = "".concat(n[e], " !important"));
              });
            });
          }(d, f), s.labelStyles = {
            labelClasses: d
          }, s.labelStyles.styles = f;
        });
      }), t;
    }
    var Hr = function (e) {
        var t = e.rows,
          n = [];
        return t.forEach(function (e) {
          e.elements.forEach(function (e) {
            n.push(e);
          });
        }), n;
      },
      Jr = function (e) {
        return e && Array.isArray(e) && 0 !== e.length ? e.map(function (e, t) {
          if (!e) return e;
          switch (e.type) {
            case st.ELEMENT_VALUE_MATCH_RULE:
              var n = e.params;
              if (!n || !Object.prototype.hasOwnProperty.call(n, "element")) throw new Gt(pt.MISSING_ELEMENT_IN_ELEMENT_MATCH_RULE, ["".concat(t)], !0);
              var r = n.element;
              if (!r || !(r instanceof Cr || Gr)) throw new Gt(pt.INVALID_ELEMENT_IN_ELEMENT_MATCH_RULE, ["".concat(t)], !0);
              return Kr(Kr({}, e), {}, {
                params: Kr(Kr({}, n), {}, {
                  elementID: r.getID(),
                  element: r.iframeName()
                })
              });
            case st.REGEX_MATCH_RULE:
              var o = e.params,
                i = (o || {}).regex;
              if (i && !Nt(i)) throw new Gt(pt.INVALID_REGEX_IN_REGEX_MATCH_RULE, ["".concat(t)], !0);
              if (i && Nt(i)) return Kr(Kr({}, e), {}, {
                params: Kr(Kr({}, o), {}, {
                  regex: i.toString()
                })
              });
              break;
            default:
              return e;
          }
          return e;
        }) : e;
      },
      Zr = function (e, t, n) {
        var r,
          o,
          i,
          c = Kr({
            required: !1
          }, t);
        if (Object.prototype.hasOwnProperty.call(c, "format") || Object.prototype.hasOwnProperty.call(c, "translation")) if (We.includes(e)) Ut(Ft(R.warnLogs.INPUT_FORMATTING_NOT_SUPPROTED, e), lt.WARN, n), null === (r = c) || void 0 === r || delete r.format, null === (o = c) || void 0 === o || delete o.translation;else if (e === Pe.INPUT_FIELD.name) {
          var l, s;
          At(t), null === (l = c = Kr(Kr({}, c), {}, {
            mask: [c.format, c.translation ? c.translation : Ke]
          })) || void 0 === l || delete l.format, null === (s = c) || void 0 === s || delete s.translation;
        }
        switch (e) {
          case Pe.CARD_NUMBER.name:
            var p, u, d;
            Object.prototype.hasOwnProperty.call(c, "enableCardIcon") || (c = Kr(Kr({}, c), {}, {
              enableCardIcon: !0
            }));
            var f = " ";
            if ((null === (p = c) || void 0 === p ? void 0 : p.format) === Ce && (f = "-"), null === (u = c = Kr(Kr({}, c), {}, {
              cardSeperator: f
            })) || void 0 === u || delete u.format, null === (d = c) || void 0 === d || delete d.translation, Object.prototype.hasOwnProperty.call(c, "cardMetadata")) {
              if ("object" !== a(c.cardMetadata) || "[object Object]" !== Object.prototype.toString.call(c.cardMetadata)) throw new Gt(pt.INVALID_OPTION_CARD_METADATA, [], !0);
              if (Object.prototype.hasOwnProperty.call(c.cardMetadata, "scheme") && ("object" !== a(c.cardMetadata.scheme) || "[object Array]" !== Object.prototype.toString.call(c.cardMetadata.scheme))) throw new Gt(pt.INVALID_OPTION_CARD_SCHEME, [], !0);
            }
            break;
          case Pe.EXPIRATION_DATE.name:
            var E,
              _ = !1;
            c.format && ((_ = !!(i = c.format.toUpperCase()) && Ge.includes(i)) || Ut(Ft(R.warnLogs.INVALID_EXPIRATION_DATE_FORMAT, Ge.toString()), lt.WARN, n)), null === (E = c = Kr(Kr({}, c), {}, {
              format: _ ? c.format.toUpperCase() : Ye
            })) || void 0 === E || delete E.translation;
            break;
          case Pe.EXPIRATION_YEAR.name:
            var m,
              v = !1;
            c.format && (v = function (e) {
              return !!e && Be.includes(e);
            }(c.format.toUpperCase()), v || Ut(Ft(R.warnLogs.INVALID_EXPIRATION_YEAR_FORMAT, Be.toString()), lt.WARN, n)), null === (m = c = Kr(Kr({}, c), {}, {
              format: v ? c.format.toUpperCase() : "YY"
            })) || void 0 === m || delete m.translation;
            break;
          case Pe.FILE_INPUT.name:
            Object.prototype.hasOwnProperty.call(c, "preserveFileName") || (c = Kr(Kr({}, c), {}, {
              preserveFileName: !0
            }));
        }
        if (Object.prototype.hasOwnProperty.call(c, "enableCardIcon") && !bt(c.enableCardIcon)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["enableCardIcon"], !0);
        if (Object.prototype.hasOwnProperty.call(c, "enableCopy") && !bt(c.enableCopy)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["enableCopy"], !0);
        if (Object.prototype.hasOwnProperty.call(c, "required") && !bt(c.required)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["required"], !0);
        if (Object.prototype.hasOwnProperty.call(c, "preserveFileName") && !bt(c.preserveFileName)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["preserveFileName"], !0);
        if (e === Pe.FILE_INPUT.name) {
          if (t.allowedFileType) {
            if (!Array.isArray(t.allowedFileType)) throw new Gt(pt.INVALID_ALLOWED_OPTIONS, [], !0);
            if (t.allowedFileType.length <= 0) throw new Gt(pt.EMPTY_ALLOWED_OPTIONS_ARRAY, [], !0);
            if (!t.allowedFileType.every(function (e) {
              return "string" == typeof e;
            })) throw new Gt(pt.INVALID_ALLOWED_FILETYPE_ARRAY, [], !0);
          }
          if (Object.prototype.hasOwnProperty.call(t, "allowedFileType") && (c = Kr(Kr({}, c), {}, {
            allowedFileType: t.allowedFileType
          })), Object.prototype.hasOwnProperty.call(t, "blockEmptyFiles") && !bt(t.blockEmptyFiles)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["blockEmptyFiles"], !0);
          Object.prototype.hasOwnProperty.call(t, "blockEmptyFiles") && (c = Kr(Kr({}, c), {}, {
            blockEmptyFiles: c.blockEmptyFiles
          }));
        }
        if (Object.prototype.hasOwnProperty.call(t, "masking")) {
          if (!bt(t.masking)) throw new Gt(pt.INVALID_BOOLEAN_OPTIONS, ["masking"], !0);
          if (Object.prototype.hasOwnProperty.call(t, "maskingChar") && "string" == typeof t.maskingChar && t.maskingChar.length > 1) throw new Gt(pt.INVALID_MASKING_CHARACTER, [], !0);
          c = Object.prototype.hasOwnProperty.call(t, "maskingChar") && "string" == typeof t.maskingChar ? Kr(Kr({}, c), {}, {
            masking: t.masking,
            maskingChar: t.maskingChar
          }) : Kr(Kr({}, c), {}, {
            masking: t.masking,
            maskingChar: "*"
          });
        }
        return c;
      };
    function $r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Qr(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $r(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $r(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function eo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = et(e);
        if (t) {
          var o = et(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return Qe(this, n);
      };
    }
    function to(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var no = "CollectContainer",
      ro = new WeakMap(),
      oo = new WeakMap(),
      io = new WeakMap(),
      ao = new WeakMap(),
      co = new WeakMap(),
      lo = new WeakMap(),
      so = new WeakMap(),
      po = new WeakMap(),
      uo = new WeakMap(),
      fo = new WeakMap(),
      Eo = new WeakMap(),
      _o = new WeakMap(),
      mo = new WeakMap(),
      vo = new WeakMap(),
      Io = new WeakMap(),
      yo = new WeakMap(),
      Oo = new WeakMap(),
      go = new WeakMap(),
      No = function (e) {
        $e(n, e);
        var t = eo(n);
        function n(e, r, o, i) {
          var a, c;
          s(this, n), to(Je(c = t.call(this)), ro, {
            writable: !0,
            value: void 0
          }), to(Je(c), oo, {
            writable: !0,
            value: {}
          }), to(Je(c), io, {
            writable: !0,
            value: void 0
          }), to(Je(c), ao, {
            writable: !0,
            value: void 0
          }), to(Je(c), co, {
            writable: !0,
            value: void 0
          }), l(Je(c), "type", hi.COLLECT), to(Je(c), lo, {
            writable: !0,
            value: void 0
          }), to(Je(c), so, {
            writable: !0,
            value: !1
          }), to(Je(c), po, {
            writable: !0,
            value: !1
          }), l(Je(c), "create", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              required: !1
            };
            Tt(e, E(Je(c), ao).logLevel);
            var n = Jr(e.validations),
              r = Zr(e.type, t, E(Je(c), ao).logLevel),
              o = {
                rows: [{
                  elements: [Qr(Qr(Qr({
                    elementType: e.type,
                    name: e.column,
                    accept: t.allowedFileType
                  }, e), r), {}, {
                    validations: n
                  })]
                }]
              };
            return E(Je(c), uo).call(Je(c), o, !0);
          }), to(Je(c), uo, {
            writable: !0,
            value: function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = [],
                r = or(e);
              if (r.rows.forEach(function (e) {
                e.elements.forEach(function (e) {
                  var t = e,
                    r = t.elementType;
                  qr(r, t), t.sensitive = t.sensitive || Pe[r].sensitive, t.replacePattern = t.replacePattern || Pe[r].replacePattern, t.mask = t.mask || Pe[r].mask, t.isMounted = !1, t.elementType !== Pe.radio.name && t.elementType !== Pe.checkbox.name || (t.elementName = "".concat(t.elementName, ":").concat(btoa(t.value))), t.elementName = "".concat(U, ":").concat(t.elementType, ":").concat(btoa(v())), t.label = e.label, t.skyflowID = e.skyflowID, n.push(t);
                });
              }), r.elementName = t ? n[0].elementName : "".concat(U, ":group:").concat(btoa(r.name)), t && !E(Je(c), oo)[n[0].elementName] && E(Je(c), mo).call(Je(c), n[0].name)) throw new Gt(pt.UNIQUE_ELEMENT_NAME, ["".concat(n[0].name)], !0);
              var o = E(Je(c), oo)[r.elementName];
              if (o) t ? o.updateElementGroup(n[0]) : o.updateElementGroup(r);else {
                var i = v();
                o = new Cr(i, r, E(Je(c), io), {
                  containerId: E(Je(c), ro),
                  isMounted: E(Je(c), so),
                  type: c.type
                }, t, E(Je(c), Eo), E(Je(c), _o), E(Je(c), ao), E(Je(c), lo)), E(Je(c), oo)[r.elementName] = o, E(Je(c), co)[i] = o;
              }
              return t || n.forEach(function (e) {
                var t = e.elementName;
                E(Je(c), oo)[t] ? E(Je(c), oo)[t].updateElementGroup(e) : E(Je(c), oo)[t] = c.create(e.elementType, e);
              }), o;
            }
          }), to(Je(c), fo, {
            writable: !0,
            value: function (e) {
              Object.keys(E(Je(c), oo)).forEach(function (t) {
                t === e && delete E(Je(c), oo)[t];
              });
            }
          }), to(Je(c), Eo, {
            writable: !0,
            value: function (e) {
              e.forEach(function (e) {
                E(Je(c), fo).call(Je(c), e);
              });
            }
          }), to(Je(c), _o, {
            writable: !0,
            value: function (e) {
              e.forEach(function (e) {
                E(Je(c), oo)[e.elementName] && E(Je(c), oo)[e.elementName].updateElementGroup(e);
              });
            }
          }), to(Je(c), mo, {
            writable: !0,
            value: function (e) {
              for (var t = Object.keys(E(Je(c), oo)), n = 0; n < t.length; n += 1) if (atob(t[n].split(":")[2]) === e) return !0;
              return !1;
            }
          }), l(Je(c), "collect", function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              tokens: !0
            };
            return f(Je(c), po, E(Je(c), io).skyflowContainer.isControllerFrameReady), E(Je(c), po) ? new Promise(function (t, n) {
              try {
                if (Lt(E(Je(c), io).clientJSON.config), 0 === Object.keys(E(Je(c), oo)).length) throw new Gt(pt.NO_ELEMENTS_IN_COLLECT, [], !0);
                E(Je(c), vo).call(Je(c));
                var r = Object.values(E(Je(c), oo)),
                  o = Object.keys(E(Je(c), oo)).map(function (e) {
                    return {
                      frameId: e,
                      elementId: e
                    };
                  });
                if (r.forEach(function (e) {
                  if (!e.isMounted()) throw new Gt(pt.ELEMENTS_NOT_MOUNTED, [], !0);
                  e.isValidElement();
                }), Object.prototype.hasOwnProperty.call(e, "tokens") && !bt(e.tokens)) throw new Gt(pt.INVALID_TOKENS_IN_COLLECT, [], !0);
                null != e && e.additionalFields && Et(e.additionalFields), null != e && e.upsert && ht(null == e ? void 0 : e.upsert), m().emit(ce + E(Je(c), io).uuid, Qr(Qr({
                  type: ne
                }, e), {}, {
                  tokens: void 0 === (null == e ? void 0 : e.tokens) || e.tokens,
                  elementIds: o,
                  containerId: E(Je(c), ro)
                }), function (e) {
                  !e || null != e && e.error ? (Ut("".concat(JSON.stringify(null == e ? void 0 : e.error)), lt.ERROR, E(Je(c), ao).logLevel), n(null == e ? void 0 : e.error)) : (Ut(Ft(R.infoLogs.COLLECT_SUBMIT_SUCCESS, no), lt.LOG, E(Je(c), ao).logLevel), t(e));
                }), Ut(Ft(R.infoLogs.EMIT_EVENT, no, se), lt.LOG, E(Je(c), ao).logLevel);
              } catch (e) {
                Ut("".concat(e.message), lt.ERROR, E(Je(c), ao).logLevel), n(e);
              }
            }) : new Promise(function (t, n) {
              try {
                if (Lt(E(Je(c), io).clientJSON.config), 0 === Object.keys(E(Je(c), oo)).length) throw new Gt(pt.NO_ELEMENTS_IN_COLLECT, [], !0);
                E(Je(c), vo).call(Je(c));
                var r = Object.values(E(Je(c), oo)),
                  o = Object.keys(E(Je(c), oo)).map(function (e) {
                    return {
                      frameId: e,
                      elementId: e
                    };
                  });
                if (r.forEach(function (e) {
                  if (!e.isMounted()) throw new Gt(pt.ELEMENTS_NOT_MOUNTED, [], !0);
                  e.isValidElement();
                }), Object.prototype.hasOwnProperty.call(e, "tokens") && !bt(e.tokens)) throw new Gt(pt.INVALID_TOKENS_IN_COLLECT, [], !0);
                null != e && e.additionalFields && Et(e.additionalFields), null != e && e.upsert && ht(null == e ? void 0 : e.upsert), m().target(wt.IFRAME_SECURE_ORIGIN).on(Te + E(Je(c), ro), function () {
                  m().emit(ce + E(Je(c), io).uuid, Qr(Qr({
                    type: ne
                  }, e), {}, {
                    tokens: void 0 === (null == e ? void 0 : e.tokens) || e.tokens,
                    elementIds: o,
                    containerId: E(Je(c), ro)
                  }), function (e) {
                    !e || null != e && e.error ? (Ut("".concat(JSON.stringify(null == e ? void 0 : e.error)), lt.ERROR, E(Je(c), ao).logLevel), n(null == e ? void 0 : e.error)) : (Ut(Ft(R.infoLogs.COLLECT_SUBMIT_SUCCESS, no), lt.LOG, E(Je(c), ao).logLevel), t(e));
                  });
                });
              } catch (e) {
                Ut("".concat(e.message), lt.ERROR, E(Je(c), ao).logLevel), n(e);
              }
            });
          }), l(Je(c), "uploadFiles", function (e) {
            return f(Je(c), po, E(Je(c), io).skyflowContainer.isControllerFrameReady), E(Je(c), po) ? new Promise(function (t, n) {
              try {
                if (Lt(E(Je(c), io).clientJSON.config), 0 === Object.keys(E(Je(c), oo)).length) throw new Gt(pt.NO_ELEMENTS_IN_COLLECT, [], !0);
                E(Je(c), vo).call(Je(c));
                var r = Object.values(E(Je(c), oo)),
                  o = Object.keys(E(Je(c), oo));
                r.forEach(function (e) {
                  if (!e.isMounted()) throw new Gt(pt.ELEMENTS_NOT_MOUNTED, [], !0);
                  e.isValidElement();
                }), m().emit(ce + E(Je(c), io).uuid, Qr(Qr({
                  type: re
                }, e), {}, {
                  elementIds: o,
                  containerId: E(Je(c), ro)
                }), function (e) {
                  !e || null != e && e.error ? (Ut("".concat(JSON.stringify(null == e ? void 0 : e.error)), lt.ERROR, E(Je(c), ao).logLevel), n(null == e ? void 0 : e.error)) : (Ut(Ft(R.infoLogs.COLLECT_SUBMIT_SUCCESS, no), lt.LOG, E(Je(c), ao).logLevel), t(e));
                }), Ut(Ft(R.infoLogs.EMIT_EVENT, no, Oe), lt.LOG, E(Je(c), ao).logLevel);
              } catch (e) {
                Ut("".concat(e.message), lt.ERROR, E(Je(c), ao).logLevel), n(e);
              }
            }) : new Promise(function (t, n) {
              m().target(wt.IFRAME_SECURE_ORIGIN).on(Te + E(Je(c), ro), function () {
                try {
                  if (Lt(E(Je(c), io).clientJSON.config), 0 === Object.keys(E(Je(c), oo)).length) throw new Gt(pt.NO_ELEMENTS_IN_COLLECT, [], !0);
                  E(Je(c), vo).call(Je(c));
                  var r = Object.values(E(Je(c), oo)),
                    o = Object.keys(E(Je(c), oo));
                  r.forEach(function (e) {
                    if (!e.isMounted()) throw new Gt(pt.ELEMENTS_NOT_MOUNTED, [], !0);
                    e.isValidElement();
                  }), m().emit(ce + E(Je(c), io).uuid, Qr(Qr({
                    type: re
                  }, e), {}, {
                    elementIds: o,
                    containerId: E(Je(c), ro)
                  }), function (e) {
                    !e || null != e && e.error ? (Ut("".concat(JSON.stringify(null == e ? void 0 : e.error)), lt.ERROR, E(Je(c), ao).logLevel), n(null == e ? void 0 : e.error)) : (Ut(Ft(R.infoLogs.COLLECT_SUBMIT_SUCCESS, no), lt.LOG, E(Je(c), ao).logLevel), t(e));
                  }), Ut(Ft(R.infoLogs.EMIT_EVENT, no, Oe), lt.LOG, E(Je(c), ao).logLevel);
                } catch (e) {
                  Ut("".concat(e.message), lt.ERROR, E(Je(c), ao).logLevel), n(e);
                }
              });
            });
          }), to(Je(c), vo, {
            writable: !0,
            value: function () {
              try {
                if (E(Je(c), Io).call(Je(c))) return;
                var e = E(Je(c), yo).call(Je(c));
                if (!e.length) return;
                E(Je(c), Oo).call(Je(c), e);
              } catch (e) {
                Ut("".concat(e), lt.LOG, E(Je(c), ao).logLevel);
              }
            }
          }), to(Je(c), Io, {
            writable: !0,
            value: function () {
              return 0 === Object.keys(E(Je(c), oo)).length;
            }
          }), to(Je(c), yo, {
            writable: !0,
            value: function () {
              var e,
                t = null === (e = document) || void 0 === e ? void 0 : e.body;
              if (!t) return [];
              var n = t.getElementsByTagName("iframe");
              return null != n && n.length ? Array.from(n).map(function (e) {
                return e.id;
              }) : [];
            }
          }), to(Je(c), Oo, {
            writable: !0,
            value: function (e) {
              Object.entries(E(Je(c), oo)).forEach(function (t) {
                var n = ut(t, 2),
                  r = n[0],
                  o = n[1];
                E(Je(c), go).call(Je(c), o, e) && delete E(Je(c), oo)[r];
              });
            }
          }), to(Je(c), go, {
            writable: !0,
            value: function (e, t) {
              return e.isMounted() && !t.includes(e.iframeName());
            }
          }), f(Je(c), po, r.skyflowContainer.isControllerFrameReady), f(Je(c), ro, v()), f(Je(c), io, Qr(Qr({}, r), {}, {
            clientJSON: Qr(Qr({}, r.clientJSON), {}, {
              config: Qr(Qr({}, r.clientJSON.config), {}, {
                options: Qr(Qr({}, null === (a = r.clientJSON.config) || void 0 === a ? void 0 : a.options), e)
              })
            })
          })), f(Je(c), co, o), f(Je(c), ao, i), f(Je(c), lo, new zt());
          var p = E(Je(c), io).clientDomain || "",
            u = Qt({
              name: "".concat(j, ":").concat(E(Je(c), ro), ":").concat(E(Je(c), ao).logLevel, ":").concat(btoa(p)),
              referrer: p
            });
          return $t(u, {
            src: en()
          }), tn(u, Qr({}, Ve)), Ut(Ft(R.infoLogs.CREATE_COLLECT_CONTAINER, no), lt.LOG, E(Je(c), ao).logLevel), f(Je(c), so, !0), c;
        }
        return u(n);
      }(nn);
    const Lo = No;
    function To(e) {
      this.message = e;
    }
    To.prototype = new Error(), To.prototype.name = "InvalidCharacterError";
    var ho = "undefined" != typeof window && window.atob && window.atob.bind(window) || function (e) {
      var t = String(e).replace(/=+$/, "");
      if (t.length % 4 == 1) throw new To("'atob' failed: The string to be decoded is not correctly encoded.");
      for (var n, r, o = 0, i = 0, a = ""; r = t.charAt(i++); ~r && (n = o % 4 ? 64 * n + r : r, o++ % 4) ? a += String.fromCharCode(255 & n >> (-2 * o & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
      return a;
    };
    function bo(e) {
      var t = e.replace(/-/g, "+").replace(/_/g, "/");
      switch (t.length % 4) {
        case 0:
          break;
        case 2:
          t += "==";
          break;
        case 3:
          t += "=";
          break;
        default:
          throw "Illegal base64url string!";
      }
      try {
        return function (e) {
          return decodeURIComponent(ho(e).replace(/(.)/g, function (e, t) {
            var n = t.charCodeAt(0).toString(16).toUpperCase();
            return n.length < 2 && (n = "0" + n), "%" + n;
          }));
        }(t);
      } catch (e) {
        return ho(t);
      }
    }
    function Ao(e) {
      this.message = e;
    }
    Ao.prototype = new Error(), Ao.prototype.name = "InvalidTokenError";
    const wo = function (e, t) {
      if ("string" != typeof e) throw new Ao("Invalid token specified");
      var n = !0 === (t = t || {}).header ? 0 : 1;
      try {
        return JSON.parse(bo(e.split(".")[n]));
      } catch (e) {
        throw new Ao("Invalid token specified: " + e.message);
      }
    };
    const Ro = function (e) {
      try {
        if (!e) return !1;
        if (i = e, "[object String]" !== Object.prototype.toString.call(i)) return !1;
        var t = !1,
          n = wo(e),
          r = new Date().getTime() / 1e3,
          o = n.exp;
        return o && r > o && (t = !0), !t;
      } catch (e) {
        return !1;
      }
      var i;
    };
    function So(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Do(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? So(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : So(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function xo(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var Mo = "SkyflowContainer",
      Po = new WeakMap(),
      Co = new WeakMap(),
      ko = new WeakMap(),
      Vo = function () {
        function e(t, n) {
          var r,
            o,
            i = this;
          s(this, e), xo(this, Po, {
            writable: !0,
            value: void 0
          }), xo(this, Co, {
            writable: !0,
            value: void 0
          }), l(this, "isControllerFrameReady", !1), xo(this, ko, {
            writable: !0,
            value: void 0
          }), f(this, Co, t), f(this, Po, (null === (r = E(this, Co).toJSON()) || void 0 === r || null === (r = r.metaData) || void 0 === r ? void 0 : r.uuid) || ""), f(this, ko, n);
          var a = window.location.origin || "",
            c = Qt({
              name: "".concat("skyflow_controller", ":").concat(E(this, Po), ":").concat(btoa(a), ":").concat(!(null === (o = E(this, Co).toJSON()) || void 0 === o || null === (o = o.config) || void 0 === o || null === (o = o.options) || void 0 === o || !o.trackingKey)),
              referrer: a
            });
          $t(c, {
            src: en()
          }), tn(c, Do({}, Ve)), document.body.append(c), m().target(wt.IFRAME_SECURE_ORIGIN).on(Ee + E(this, Po), function (e, t) {
            Ut(Ft(R.infoLogs.CAPTURE_PUREJS_FRAME, Mo), lt.LOG, E(i, ko).logLevel), t({
              client: E(i, Co),
              context: n
            }), i.isControllerFrameReady = !0;
          }), Ut(Ft(R.infoLogs.PUREJS_CONTROLLER_INITIALIZED, Mo), lt.LOG, E(this, ko).logLevel);
        }
        return u(e, [{
          key: "detokenize",
          value: function (e) {
            var t = this;
            return this.isControllerFrameReady ? new Promise(function (n, r) {
              try {
                Lt(E(t, Co).config), Ut(Ft(R.infoLogs.VALIDATE_DETOKENIZE_INPUT, Mo), lt.LOG, E(t, ko).logLevel), _t(e), m().emit(fe + E(t, Po), {
                  type: $,
                  records: e.records
                }, function (e) {
                  e.error ? r(e.error) : n(e);
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, $), lt.LOG, E(t, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(t, ko).logLevel), r(e);
              }
            }) : new Promise(function (n, r) {
              try {
                Lt(E(t, Co).config), Ut(Ft(R.infoLogs.VALIDATE_DETOKENIZE_INPUT, Mo), lt.LOG, E(t, ko).logLevel), _t(e), m().target(wt.IFRAME_SECURE_ORIGIN).on(Ee + E(t, Po), function () {
                  m().emit(fe + E(t, Po), {
                    type: $,
                    records: e.records
                  }, function (e) {
                    e.error ? r(e.error) : n(e);
                  });
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, $), lt.LOG, E(t, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(t, ko).logLevel), r(e);
              }
            });
          }
        }, {
          key: "insert",
          value: function (e, t) {
            var n = this;
            return this.isControllerFrameReady ? new Promise(function (r, o) {
              Lt(E(n, Co).config);
              try {
                var i, a;
                if (Ut(Ft(R.infoLogs.VALIDATE_RECORDS, Mo), lt.LOG, E(n, ko).logLevel), t) t = Do(Do({}, t), {}, {
                  tokens: void 0 === (null === (a = t) || void 0 === a ? void 0 : a.tokens) || t.tokens
                });else t = {
                  tokens: !0
                };
                null !== (i = t) && void 0 !== i && i.upsert && ht(t.upsert), ft(e, t), m().emit(fe + E(n, Po), {
                  type: Z,
                  records: e,
                  options: t
                }, function (e) {
                  e.error ? (Ut("".concat(JSON.stringify(e.error)), lt.ERROR, E(n, ko).logLevel), o(e.error)) : r(e);
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, Z), lt.LOG, E(n, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(n, ko).logLevel), o(e);
              }
            }) : new Promise(function (r, o) {
              try {
                var i, a;
                if (Lt(E(n, Co).config), Ut(Ft(R.infoLogs.VALIDATE_RECORDS, Mo), lt.LOG, E(n, ko).logLevel), t) t = Do(Do({}, t), {}, {
                  tokens: void 0 === (null === (a = t) || void 0 === a ? void 0 : a.tokens) || t.tokens
                });else t = {
                  tokens: !0
                };
                null !== (i = t) && void 0 !== i && i.upsert && ht(t.upsert), ft(e, t), m().target(wt.IFRAME_SECURE_ORIGIN).on(Ee + E(n, Po), function () {
                  m().emit(fe + E(n, Po), {
                    type: Z,
                    records: e,
                    options: t
                  }, function (e) {
                    e.error ? (Ut("".concat(JSON.stringify(e.error)), lt.ERROR, E(n, ko).logLevel), o(e.error)) : r(e);
                  });
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, Z), lt.LOG, E(n, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(n, ko).logLevel), o(e);
              }
            });
          }
        }, {
          key: "getById",
          value: function (e) {
            var t = this;
            return this.isControllerFrameReady ? new Promise(function (n, r) {
              Lt(E(t, Co).config);
              try {
                Ut(Ft(R.infoLogs.VALIDATE_GET_BY_ID_INPUT, Mo), lt.LOG, E(t, ko).logLevel), vt(e), m().emit(fe + E(t, Po), {
                  type: Q,
                  records: e.records
                }, function (e) {
                  e.error ? r(e.error) : n(e);
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, Q), lt.LOG, E(t, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(t, ko).logLevel), r(e);
              }
            }) : new Promise(function (n, r) {
              try {
                Lt(E(t, Co).config), Ut(Ft(R.infoLogs.VALIDATE_GET_BY_ID_INPUT, Mo), lt.LOG, E(t, ko).logLevel), vt(e), m().target(wt.IFRAME_SECURE_ORIGIN).on(Ee + E(t, Po), function () {
                  m().emit(fe + E(t, Po), {
                    type: Q,
                    records: e.records
                  }, function (e) {
                    e.error ? r(e.error) : n(e);
                  });
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, Q), lt.LOG, E(t, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(t, ko).logLevel), r(e);
              }
            });
          }
        }, {
          key: "get",
          value: function (e, t) {
            var n = this;
            return this.isControllerFrameReady ? new Promise(function (r, o) {
              Lt(E(n, Co).config);
              try {
                Ut(Ft(R.infoLogs.VALIDATE_GET_INPUT, Mo), lt.LOG, E(n, ko).logLevel), mt(e, t), m().emit(fe + E(n, Po), {
                  type: ee,
                  records: e.records,
                  options: t
                }, function (e) {
                  e.error ? o(e.error) : r(e);
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, ee), lt.LOG, E(n, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(n, ko).logLevel), o(e);
              }
            }) : new Promise(function (r, o) {
              try {
                Lt(E(n, Co).config), Ut(Ft(R.infoLogs.VALIDATE_GET_INPUT, Mo), lt.LOG, E(n, ko).logLevel), mt(e, t), m().target(wt.IFRAME_SECURE_ORIGIN).on(Ee + E(n, Po), function () {
                  m().emit(fe + E(n, Po), {
                    type: ee,
                    records: e.records,
                    options: t
                  }, function (e) {
                    e.error ? o(e.error) : r(e);
                  });
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, ee), lt.LOG, E(n, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(n, ko).logLevel), o(e);
              }
            });
          }
        }, {
          key: "delete",
          value: function (e, t) {
            var n = this;
            return this.isControllerFrameReady ? new Promise(function (r, o) {
              Lt(E(n, Co).config);
              try {
                Ut(Ft(R.infoLogs.VALIDATE_DELETE_INPUT, Mo), lt.LOG, E(n, ko).logLevel), It(e), m().emit(fe + E(n, Po), {
                  type: te,
                  records: e,
                  options: t
                }, function (e) {
                  e.error ? (Ut("".concat(JSON.stringify(e.error)), lt.ERROR, E(n, ko).logLevel), o(e.error)) : r(e);
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, te), lt.LOG, E(n, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(n, ko).logLevel), o(e);
              }
            }) : new Promise(function (r, o) {
              try {
                Lt(E(n, Co).config), Ut(Ft(R.infoLogs.VALIDATE_RECORDS, Mo), lt.LOG, E(n, ko).logLevel), It(e), m().target(wt.IFRAME_SECURE_ORIGIN).on(Ee + E(n, Po), function () {
                  m().emit(fe + E(n, Po), {
                    type: te,
                    records: e,
                    options: t
                  }, function (e) {
                    e.error ? (Ut("".concat(JSON.stringify(e.error)), lt.ERROR, E(n, ko).logLevel), o(e.error)) : r(e);
                  });
                }), Ut(Ft(R.infoLogs.EMIT_PURE_JS_REQUEST, Mo, te), lt.LOG, E(n, ko).logLevel);
              } catch (e) {
                Ut(e.message, lt.ERROR, E(n, ko).logLevel), o(e);
              }
            });
          }
        }]), e;
      }();
    const jo = Vo;
    var Uo = n(6119),
      Fo = n.n(Uo);
    function Yo(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Go(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Yo(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yo(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function Bo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = et(e);
        if (t) {
          var o = et(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return Qe(this, n);
      };
    }
    function Xo(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var Wo = "CollectContainer",
      Ko = new WeakMap(),
      qo = new WeakMap(),
      zo = new WeakMap(),
      Ho = new WeakMap(),
      Jo = new WeakMap(),
      Zo = new WeakMap(),
      $o = new WeakMap(),
      Qo = new WeakMap(),
      ei = new WeakMap(),
      ti = new WeakMap(),
      ni = new WeakMap(),
      ri = new WeakMap(),
      oi = new WeakMap(),
      ii = new WeakMap(),
      ai = new WeakMap(),
      ci = new WeakMap(),
      li = new WeakMap(),
      si = new WeakMap(),
      pi = new WeakMap(),
      ui = new WeakMap(),
      di = new WeakMap();
    const fi = function (e) {
      $e(n, e);
      var t = Bo(n);
      function n(e, r, o, i) {
        var a, c;
        s(this, n), Xo(Je(c = t.call(this)), Ko, {
          writable: !0,
          value: void 0
        }), Xo(Je(c), qo, {
          writable: !0,
          value: {}
        }), Xo(Je(c), zo, {
          writable: !0,
          value: void 0
        }), Xo(Je(c), Ho, {
          writable: !0,
          value: {
            rows: []
          }
        }), Xo(Je(c), Jo, {
          writable: !0,
          value: []
        }), Xo(Je(c), Zo, {
          writable: !0,
          value: void 0
        }), Xo(Je(c), $o, {
          writable: !0,
          value: void 0
        }), Xo(Je(c), Qo, {
          writable: !0,
          value: void 0
        }), Xo(Je(c), ei, {
          writable: !0,
          value: !1
        }), Xo(Je(c), ti, {
          writable: !0,
          value: void 0
        }), Xo(Je(c), ni, {
          writable: !0,
          value: void 0
        }), l(Je(c), "type", hi.COMPOSABLE), Xo(Je(c), ri, {
          writable: !0,
          value: !1
        }), Xo(Je(c), oi, {
          writable: !0,
          value: {}
        }), Xo(Je(c), ii, {
          writable: !0,
          value: ""
        }), Xo(Je(c), ai, {
          writable: !0,
          value: !1
        }), l(Je(c), "create", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            required: !1
          };
          Tt(e, E(Je(c), Zo).logLevel);
          var n = Jr(e.validations),
            r = Zr(e.type, t, E(Je(c), Zo).logLevel),
            o = "".concat(U, ":").concat(e.type, ":").concat(btoa(v()));
          E(Je(c), Jo).push(Go(Go(Go({
            elementType: e.type,
            name: e.column
          }, e), r), {}, {
            validations: n,
            elementName: o
          }));
          var i = "".concat(U, ":group:").concat(btoa(E(Je(c), oi)), ":").concat(E(Je(c), Ko), ":").concat(E(Je(c), Zo).logLevel, ":").concat(btoa(E(Je(c), ii)));
          return new Gr(o, E(Je(c), Qo), i);
        }), Xo(Je(c), ci, {
          writable: !0,
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = [];
            if (f(Je(c), oi, or(e)), E(Je(c), oi).rows.forEach(function (e) {
              e.elements.forEach(function (e) {
                var t = e,
                  r = t.elementType;
                qr(r, t), t.sensitive = t.sensitive || Pe[r].sensitive, t.replacePattern = t.replacePattern || Pe[r].replacePattern, t.mask = t.mask || Pe[r].mask, t.isMounted = !1, t.label = e.label, t.skyflowID = e.skyflowID, n.push(t);
              });
            }), E(Je(c), oi).elementName = t ? n[0].elementName : "".concat(U, ":group:").concat(btoa(E(Je(c), oi))), t && !E(Je(c), qo)[n[0].elementName] && E(Je(c), ui).call(Je(c), n[0].name)) throw new Gt(pt.UNIQUE_ELEMENT_NAME, ["".concat(n[0].name)], !0);
            var r = E(Je(c), qo)[E(Je(c), oi).elementName];
            if (r) t ? r.update(n[0]) : r.update(E(Je(c), oi));else {
              var o = v();
              r = new Cr(o, E(Je(c), oi), E(Je(c), zo), {
                containerId: E(Je(c), Ko),
                isMounted: E(Je(c), ri),
                type: c.type
              }, !0, E(Je(c), si), E(Je(c), pi), E(Je(c), Zo), E(Je(c), Qo)), E(Je(c), qo)[E(Je(c), oi).elementName] = r, E(Je(c), $o)[o] = r;
            }
            return r;
          }
        }), Xo(Je(c), li, {
          writable: !0,
          value: function (e) {
            Object.keys(E(Je(c), qo)).forEach(function (t) {
              t === e && delete E(Je(c), qo)[t];
            });
          }
        }), Xo(Je(c), si, {
          writable: !0,
          value: function (e) {
            e.forEach(function (e) {
              E(Je(c), li).call(Je(c), e);
            });
          }
        }), Xo(Je(c), pi, {
          writable: !0,
          value: function (e) {
            e.forEach(function (e) {
              E(Je(c), qo)[e.elementName] && E(Je(c), qo)[e.elementName].update(e);
            });
          }
        }), Xo(Je(c), ui, {
          writable: !0,
          value: function (e) {
            for (var t = Object.keys(E(Je(c), qo)), n = 0; n < t.length; n += 1) if (atob(t[n].split(":")[2]) === e) return !0;
            return !1;
          }
        }), l(Je(c), "on", function (e, t) {
          if (!Object.values(ae).includes(e)) throw new Gt(pt.INVALID_EVENT_LISTENER, [], !0);
          if (!t) throw new Gt(pt.MISSING_HANDLER_IN_EVENT_LISTENER, [], !0);
          if ("function" != typeof t) throw new Gt(pt.INVALID_HANDLER_IN_EVENT_LISTENER, [], !0);
          E(Je(c), Qo).on(ae.SUBMIT, function () {
            t();
          });
        }), l(Je(c), "mount", function (e) {
          if (!e) throw new Gt(pt.EMPTY_ELEMENT_IN_MOUNT, ["CollectElement"], !0);
          var t = E(Je(c), ti).layout;
          if (Fo()(t) !== E(Je(c), Jo).length) throw new Gt(pt.MISMATCH_ELEMENT_COUNT_LAYOUT_SUM, [], !0);
          var n = 0;
          t.forEach(function (e, t) {
            E(Je(c), Ho).rows = [].concat(He(E(Je(c), Ho).rows), [{
              elements: []
            }]);
            for (var r = 0; r < e; r++) E(Je(c), Ho).rows[t].elements.push(E(Je(c), Jo)[n]), n++;
          }), E(Je(c), ti).styles && (E(Je(c), Ho).styles = Go({}, E(Je(c), ti).styles)), E(Je(c), ti).errorTextStyles && (E(Je(c), Ho).errorTextStyles = Go({}, E(Je(c), ti).errorTextStyles)), E(Je(c), ri) && (f(Je(c), ni, E(Je(c), ci).call(Je(c), E(Je(c), Ho), !1)), E(Je(c), ni).mount(e), f(Je(c), ei, !0));
        }), l(Je(c), "unmount", function () {
          E(Je(c), ni).unmount();
        }), l(Je(c), "collect", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            tokens: !0
          };
          return f(Je(c), ai, E(Je(c), zo).skyflowContainer.isControllerFrameReady), E(Je(c), ai) ? new Promise(function (t, n) {
            try {
              if (Lt(E(Je(c), zo).clientJSON.config), !E(Je(c), Jo) || 0 === E(Je(c), Jo).length) throw new Gt(pt.NO_ELEMENTS_IN_COMPOSABLE, [], !0);
              if (!E(Je(c), ei)) throw new Gt(pt.COMPOSABLE_CONTAINER_NOT_MOUNTED, [], !0);
              Hr(E(Je(c), oi)).forEach(function (e) {
                if (null == e || !e.isMounted) throw new Gt(pt.ELEMENTS_NOT_MOUNTED, [], !0);
              });
              var r = [];
              if (Object.values(E(Je(c), qo)).forEach(function (e) {
                e.isValidElement();
              }), e && e.tokens && "boolean" != typeof e.tokens) throw new Gt(pt.INVALID_TOKENS_IN_COLLECT, [], !0);
              null != e && e.additionalFields && Et(e.additionalFields), null != e && e.upsert && ht(null == e ? void 0 : e.upsert), E(Je(c), Jo).forEach(function (e) {
                r.push({
                  frameId: E(Je(c), oi).elementName,
                  elementId: e.elementName
                });
              }), m().emit(ce + E(Je(c), zo).uuid, Go(Go({
                type: ne
              }, e), {}, {
                tokens: void 0 === (null == e ? void 0 : e.tokens) || e.tokens,
                elementIds: r,
                containerId: E(Je(c), Ko)
              }), function (e) {
                !e || null != e && e.error ? (Ut("".concat(JSON.stringify(null == e ? void 0 : e.error)), lt.ERROR, E(Je(c), Zo).logLevel), n(null == e ? void 0 : e.error)) : (Ut(Ft(R.infoLogs.COLLECT_SUBMIT_SUCCESS, Wo), lt.LOG, E(Je(c), Zo).logLevel), t(e));
              }), Ut(Ft(R.infoLogs.EMIT_EVENT, Wo, se), lt.LOG, E(Je(c), Zo).logLevel);
            } catch (e) {
              Ut("".concat(e.message), lt.ERROR, E(Je(c), Zo).logLevel), n(e);
            }
          }) : new Promise(function (t, n) {
            try {
              if (Lt(E(Je(c), zo).clientJSON.config), !E(Je(c), Jo) || 0 === E(Je(c), Jo).length) throw new Gt(pt.NO_ELEMENTS_IN_COMPOSABLE, [], !0);
              if (!E(Je(c), ei)) throw new Gt(pt.COMPOSABLE_CONTAINER_NOT_MOUNTED, [], !0);
              Hr(E(Je(c), oi)).forEach(function (e) {
                if (null == e || !e.isMounted) throw new Gt(pt.ELEMENTS_NOT_MOUNTED, [], !0);
              });
              var r = [];
              if (Object.values(E(Je(c), qo)).forEach(function (e) {
                e.isValidElement();
              }), e && e.tokens && "boolean" != typeof e.tokens) throw new Gt(pt.INVALID_TOKENS_IN_COLLECT, [], !0);
              null != e && e.additionalFields && Et(e.additionalFields), null != e && e.upsert && ht(null == e ? void 0 : e.upsert), E(Je(c), Jo).forEach(function (e) {
                r.push({
                  frameId: E(Je(c), oi).elementName,
                  elementId: e.elementName
                });
              }), m().target(wt.IFRAME_SECURE_ORIGIN).on(Te + E(Je(c), Ko), function () {
                m().emit(ce + E(Je(c), zo).uuid, Go(Go({
                  type: ne
                }, e), {}, {
                  tokens: void 0 === (null == e ? void 0 : e.tokens) || e.tokens,
                  elementIds: r,
                  containerId: E(Je(c), Ko)
                }), function (e) {
                  !e || null != e && e.error ? (Ut("".concat(JSON.stringify(null == e ? void 0 : e.error)), lt.ERROR, E(Je(c), Zo).logLevel), n(null == e ? void 0 : e.error)) : (Ut(Ft(R.infoLogs.COLLECT_SUBMIT_SUCCESS, Wo), lt.LOG, E(Je(c), Zo).logLevel), t(e));
                });
              }), Ut(Ft(R.infoLogs.EMIT_EVENT, Wo, se), lt.LOG, E(Je(c), Zo).logLevel);
            } catch (e) {
              Ut("".concat(e.message), lt.ERROR, E(Je(c), Zo).logLevel), n(e);
            }
          });
        }), Xo(Je(c), di, {
          writable: !0,
          value: function () {
            E(Je(c), Qo).on(ge, function (e) {
              var t,
                n = E(Je(c), Jo).map(function (n, r) {
                  return n.elementName === e.elementName ? (t = r, Go({
                    elementName: n.elementName
                  }, e.elementOptions)) : n;
                });
              E(Je(c), ni) && E(Je(c), ni).updateElement(Go({}, n[t]));
            });
          }
        }), f(Je(c), Ko, v()), f(Je(c), zo, Go(Go({}, r), {}, {
          clientJSON: Go(Go({}, r.clientJSON), {}, {
            config: Go(Go({}, r.clientJSON.config), {}, {
              options: Go(Go({}, null === (a = r.clientJSON.config) || void 0 === a ? void 0 : a.options), e)
            })
          })
        })), f(Je(c), ai, r.skyflowContainer.isControllerFrameReady), f(Je(c), $o, o), f(Je(c), Zo, i), f(Je(c), ti, e), f(Je(c), Qo, new zt()), f(Je(c), ii, E(Je(c), zo).clientDomain || "");
        var p = Qt({
          name: "".concat(j, ":").concat(E(Je(c), Ko), ":").concat(E(Je(c), Zo).logLevel, ":").concat(btoa(E(Je(c), ii))),
          referrer: E(Je(c), ii)
        });
        return $t(p, {
          src: en()
        }), tn(p, Go({}, Ve)), Ut(Ft(R.infoLogs.CREATE_COLLECT_CONTAINER, Wo), lt.LOG, E(Je(c), Zo).logLevel), f(Je(c), ri, !0), E(Je(c), di).call(Je(c)), c;
      }
      return u(n);
    }(nn);
    var Ei;
    function _i(e, t, n) {
      return function (e, t) {
        if (e !== t) throw new TypeError("Private static access of wrong provenance");
      }(e, t), function (e, t) {
        if (void 0 === e) throw new TypeError("attempted to " + t + " private static field before its declaration");
      }(n, "get"), function (e, t) {
        if (t.get) return t.get.call(e);
        return t.value;
      }(e, n);
    }
    var mi = function () {
      function e() {
        s(this, e);
      }
      return u(e, null, [{
        key: "getBrowserDetails",
        value: function () {
          return {
            browser_accept_header: "application/json",
            browser_color_depth: String(window.screen.colorDepth),
            browser_screen_height: window.screen.height,
            browser_screen_width: window.screen.width,
            browser_user_agent: window.navigator.userAgent,
            browser_java_enabled: window.navigator.javaEnabled(),
            browser_language: window.navigator.language,
            browser_tz: new Date().getTimezoneOffset(),
            browser_javascript_enabled: !0,
            accept_language: He(navigator.languages)
          };
        }
      }]), e;
    }();
    Ei = mi, l(mi, "showChallenge", function (e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "05",
        r = arguments.length > 3 ? arguments[3] : void 0;
      if (!e) throw new Gt(pt.INVALID_FIELD_SHOW_3DS_CHALLEGNGE, ["acsUrl"], !0);
      if (!t) throw new Gt(pt.INVALID_FIELD_SHOW_3DS_CHALLEGNGE, ["cReq"], !0);
      if (r && !(r instanceof HTMLElement)) throw new Gt(pt.INVALID_FIELD_SHOW_3DS_CHALLEGNGE, ["container"], !0);
      var o = _i(Ei, Ei, vi).call(Ei, n),
        i = _i(Ei, Ei, Ii).call(Ei, r || document.body, "threeDSCReqIFrame", "threeDSCReqIframe", o[0], o[1]);
      return i.sandbox.add("allow-pointer-lock"), _i(Ei, Ei, yi).call(Ei, e, t, i), i;
    });
    var vi = {
        writable: !0,
        value: function () {
          switch (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "05") {
            case "01":
              return ["250px", "400px"];
            case "02":
              return ["390px", "400px"];
            case "03":
              return ["500px", "600px"];
            case "04":
              return ["600px", "400px"];
            case "05":
              return ["100%", "100%"];
            default:
              throw new Gt(pt.INVALID_FIELD_SHOW_3DS_CHALLEGNGE, ["challengeWindowSize"], !0);
          }
        }
      },
      Ii = {
        writable: !0,
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "0",
            o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "0",
            i = document.createElement("iframe");
          return i.width = r, i.height = o, i.name = t, i.setAttribute("id", n), i.setAttribute("frameborder", "0"), i.setAttribute("border", "0"), i.setAttribute("style", "overflow:hidden; position:absolute"), i.setAttribute("allowfullscreen", "false"), i.setAttribute("allowpaymentrequest", "false"), i.setAttribute("allow", "payment; publickey-credentials-get"), i.sandbox.add("allow-forms", "allow-scripts", "allow-same-origin"), e.appendChild(i), i;
        }
      },
      yi = {
        writable: !0,
        value: function (e, t, n) {
          var r = document.createElement("html"),
            o = document.createElement("body"),
            i = _i(Ei, Ei, Oi).call(Ei, "challengeRequestForm", e, n.name, "creq", encodeURIComponent(t));
          return o.appendChild(i), r.appendChild(o), n.appendChild(r), i.submit(), n;
        }
      },
      Oi = {
        writable: !0,
        value: function (e, t, n, r, o) {
          var i = document.createElement("form");
          i.name = e, i.action = t, i.method = "POST", i.target = n, i.enctype = "application/x-www-form-urlencoded";
          var a = document.createElement("input");
          return a.name = r, a.value = o, i.appendChild(a), i.style.display = "none", i;
        }
      };
    const gi = mi;
    function Ni(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Li(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ni(Object(n), !0).forEach(function (t) {
          l(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ni(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function Ti(e, t, n) {
      !function (e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
      }(e, t), t.set(e, n);
    }
    var hi = function (e) {
        return e.COLLECT = "COLLECT", e.REVEAL = "REVEAL", e.COMPOSABLE = "COMPOSABLE", e;
      }({}),
      bi = "Skyflow",
      Ai = new WeakMap(),
      wi = new WeakMap(),
      Ri = new WeakMap(),
      Si = new WeakMap(),
      Di = new WeakMap(),
      xi = new WeakMap(),
      Mi = new WeakMap(),
      Pi = new WeakMap(),
      Ci = new WeakMap(),
      ki = function () {
        function e(t) {
          var n,
            r,
            o = this;
          s(this, e), Ti(this, Ai, {
            writable: !0,
            value: void 0
          }), Ti(this, wi, {
            writable: !0,
            value: v()
          }), Ti(this, Ri, {
            writable: !0,
            value: {
              uuid: E(this, wi),
              clientDomain: window.location.origin
            }
          }), Ti(this, Si, {
            writable: !0,
            value: void 0
          }), Ti(this, Di, {
            writable: !0,
            value: ""
          }), Ti(this, xi, {
            writable: !0,
            value: void 0
          }), Ti(this, Mi, {
            writable: !0,
            value: void 0
          }), Ti(this, Pi, {
            writable: !0,
            value: void 0
          }), Ti(this, Ci, {
            writable: !0,
            value: void 0
          });
          var i = localStorage.getItem("sdk_version") || "";
          E(this, Ri).sdkVersion = i, E(this, Ri).session_id = v(), f(this, Ai, new qt(Li({}, t), E(this, Ri))), f(this, Mi, (null == t || null === (n = t.options) || void 0 === n ? void 0 : n.logLevel) || at.ERROR), f(this, Pi, (null == t || null === (r = t.options) || void 0 === r ? void 0 : r.env) || ct.PROD), f(this, Ci, {}), f(this, Si, new jo(E(this, Ai), {
            logLevel: E(this, Mi),
            env: E(this, Pi)
          }));
          m().target(wt.IFRAME_SECURE_ORIGIN).on(_e + E(this, wi), function (e, t) {
            Ut(Ft(R.infoLogs.CAPTURED_BEARER_TOKEN_EVENT, bi), lt.LOG, E(o, Mi)), !E(o, Ai).config.getBearerToken || E(o, Di) && Ro(E(o, Di)) ? (Ut(Ft(R.infoLogs.REUSE_BEARER_TOKEN, bi), lt.LOG, E(o, Mi)), t({
              authToken: E(o, Di)
            })) : E(o, Ai).config.getBearerToken().then(function (e) {
              Ro(e) ? (Ut(Ft(R.infoLogs.BEARER_TOKEN_RESOLVED, bi), lt.LOG, E(o, Mi)), f(o, Di, e), t({
                authToken: E(o, Di)
              })) : (Ut(Ft(R.errorLogs.INVALID_BEARER_TOKEN), lt.ERROR, E(o, Mi)), t({
                error: Ft(R.errorLogs.INVALID_BEARER_TOKEN)
              }));
            }).catch(function (e) {
              Ut(Ft(R.errorLogs.BEARER_TOKEN_REJECTED), lt.ERROR, E(o, Mi)), t({
                error: e
              });
            });
          }), Ut(Ft(R.infoLogs.BEARER_TOKEN_LISTENER, bi), lt.LOG, E(this, Mi)), Ut(Ft(R.infoLogs.CURRENT_ENV, bi, E(this, Pi)), lt.LOG, E(this, Mi)), Ut(Ft(R.infoLogs.CURRENT_LOG_LEVEL, bi, E(this, Mi)), lt.LOG, E(this, Mi));
        }
        return u(e, [{
          key: "container",
          value: function (e, t) {
            switch (e) {
              case hi.COLLECT:
                var n = new Lo(t, Li(Li({}, E(this, Ri)), {}, {
                  clientJSON: E(this, Ai).toJSON(),
                  containerType: e,
                  skyflowContainer: E(this, Si)
                }), E(this, Ci), {
                  logLevel: E(this, Mi),
                  env: E(this, Pi)
                });
                return Ut(Ft(R.infoLogs.COLLECT_CONTAINER_CREATED, bi), lt.LOG, E(this, Mi)), n;
              case hi.REVEAL:
                var r = new rr(Li(Li({}, E(this, Ri)), {}, {
                  clientJSON: E(this, Ai).toJSON(),
                  containerType: e,
                  skyflowContainer: E(this, Si)
                }), E(this, Ci), {
                  logLevel: E(this, Mi)
                }, t);
                return Ut(Ft(R.infoLogs.REVEAL_CONTAINER_CREATED, bi), lt.LOG, E(this, Mi)), r;
              case hi.COMPOSABLE:
                !function (e) {
                  if (!e) throw new Gt(pt.MISSING_COMPOSABLE_CONTAINER_OPTIONS, [], !0);
                  if ("object" !== a(e)) throw new Gt(pt.INVALID_COMPOSABLE_CONTAINER_OPTIONS, [], !0);
                  if (!Object.prototype.hasOwnProperty.call(e, "layout")) throw new Gt(pt.MISSING_COMPOSABLE_LAYOUT_KEY, [], !0);
                  if (!e.layout) throw new Gt(pt.INVALID_COMPOSABLE_LAYOUT_TYPE, [], !0);
                  if (!Array.isArray(e.layout)) throw new Gt(pt.INVALID_COMPOSABLE_LAYOUT_TYPE, [], !0);
                  if (0 === e.layout.length) throw new Gt(pt.EMPTY_COMPOSABLE_LAYOUT_ARRAY, [], !0);
                  e.layout.forEach(function (e) {
                    if ("number" != typeof e) throw new Gt(pt.INVALID_COMPOSABLE_LAYOUT_TYPE, [], !0);
                    if (e < 0) throw new Gt(pt.NEGATIVE_VALUES_COMPOSABLE_LAYOUT, [], !0);
                  });
                }(t);
                var o = new fi(t, Li(Li({}, E(this, Ri)), {}, {
                  clientJSON: E(this, Ai).toJSON(),
                  containerType: e,
                  skyflowContainer: E(this, Si)
                }), E(this, Ci), {
                  logLevel: E(this, Mi),
                  env: E(this, Pi)
                });
                return Ut(Ft(R.infoLogs.COLLECT_CONTAINER_CREATED, bi), lt.LOG, E(this, Mi)), o;
              default:
                if (!e) throw new Gt(pt.EMPTY_CONTAINER_TYPE, [], !0);
                throw new Gt(pt.INVALID_CONTAINER_TYPE, [e], !0);
            }
          }
        }, {
          key: "insert",
          value: function (e, t) {
            return Ut(Ft(R.infoLogs.INSERT_TRIGGERED, bi), lt.LOG, E(this, Mi)), E(this, Si).insert(e, t);
          }
        }, {
          key: "detokenize",
          value: function (e) {
            return Ut(Ft(R.infoLogs.DETOKENIZE_TRIGGERED, bi), lt.LOG, E(this, Mi)), E(this, Si).detokenize(e);
          }
        }, {
          key: "getById",
          value: function (e) {
            return Ut(R.warnLogs.GET_BY_ID_DEPRECATED, lt.WARN, E(this, Mi)), Ut(Ft(R.infoLogs.GET_BY_ID_TRIGGERED, bi), lt.LOG, E(this, Mi)), E(this, Si).getById(e);
          }
        }, {
          key: "get",
          value: function (e, t) {
            return Ut(Ft(R.infoLogs.GET_TRIGGERED, bi), lt.LOG, E(this, Mi)), E(this, Si).get(e, t);
          }
        }, {
          key: "delete",
          value: function (e, t) {
            return Ut(Ft(R.infoLogs.DELETE_TRIGGERED, bi), lt.LOG, E(this, Mi)), E(this, Si).delete(e, t);
          }
        }], [{
          key: "init",
          value: function (t) {
            var n,
              r = (null == t || null === (n = t.options) || void 0 === n ? void 0 : n.logLevel) || at.ERROR;
            !function (e) {
              var t, n;
              if (null != e && null !== (t = e.options) && void 0 !== t && t.customElementsURL && gt(null == e || null === (n = e.options) || void 0 === n ? void 0 : n.customElementsURL)) {
                var r,
                  o,
                  i = null == e || null === (r = e.options) || void 0 === r ? void 0 : r.customElementsURL,
                  a = new URL(i),
                  c = a.protocol,
                  l = a.hostname,
                  s = "".concat(c, "//").concat(l);
                wt.IFRAME_SECURE_ORIGIN = s, wt.IFRAME_SECURE_SITE = null == e || null === (o = e.options) || void 0 === o ? void 0 : o.customElementsURL;
              }
            }(t), Ut(Ft(R.infoLogs.INITIALIZE_CLIENT, bi), lt.LOG, r);
            var o,
              i = t;
            i.vaultURL = "string" != typeof (o = t.vaultURL) ? o : "/" === (null == o ? void 0 : o.trim().slice(-1)) ? o.slice(0, -1) : o.trim();
            var a = new e(i);
            return Ut(Ft(R.infoLogs.CLIENT_INITIALIZED, bi), lt.LOG, r), a;
          }
        }, {
          key: "ContainerType",
          get: function () {
            return hi;
          }
        }, {
          key: "ElementType",
          get: function () {
            return De;
          }
        }, {
          key: "RedactionType",
          get: function () {
            return rt;
          }
        }, {
          key: "RequestMethod",
          get: function () {
            return ot;
          }
        }, {
          key: "LogLevel",
          get: function () {
            return at;
          }
        }, {
          key: "EventName",
          get: function () {
            return it;
          }
        }, {
          key: "Env",
          get: function () {
            return ct;
          }
        }, {
          key: "ValidationRuleType",
          get: function () {
            return st;
          }
        }, {
          key: "CardType",
          get: function () {
            return xe;
          }
        }, {
          key: "Error",
          get: function () {
            return Gt;
          }
        }, {
          key: "ThreeDS",
          get: function () {
            return gi;
          }
        }]), e;
      }();
    const Vi = ki,
      ji = ki;
  })(), r;
})());